/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupPasskeyRouteImport } from './routes/setup-passkey'
import { Route as OtpRouteImport } from './routes/otp'
import { Route as FarewellRouteImport } from './routes/farewell'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AcceptInvitationInvitationIdRouteImport } from './routes/accept-invitation.$invitationId'
import { Route as AuthenticatedGetTheAppRouteImport } from './routes/_authenticated/get-the-app'
import { Route as AuthenticatedForceChangePasswordRouteImport } from './routes/_authenticated/force-change-password'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authTwoFactorRouteImport } from './routes/(auth)/two-factor'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authChangePasswordRouteImport } from './routes/(auth)/change-password'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedOrganizationRouteRouteImport } from './routes/_authenticated/_organization/route'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedCreateOrganizationIndexRouteImport } from './routes/_authenticated/create-organization/index'
import { Route as AuthenticatedOrganizationIndexRouteImport } from './routes/_authenticated/_organization/index'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsIntegrationsRouteImport } from './routes/_authenticated/settings/integrations'
import { Route as AuthenticatedSettingsCommunicationRouteImport } from './routes/_authenticated/settings/communication'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedOrganizationSignaturesRouteImport } from './routes/_authenticated/_organization/signatures'
import { Route as AuthenticatedOrganizationCrossOrgRouteImport } from './routes/_authenticated/_organization/cross-org'
import { Route as AuthenticatedOrganizationAiGatewayRouteImport } from './routes/_authenticated/_organization/ai-gateway'
import { Route as publicSupportPlanShareTokenRouteImport } from './routes/(public)/support-plan-share/$token'
import { Route as publicSilRocShareTokenRouteImport } from './routes/(public)/sil-roc-share/$token'
import { Route as publicSignTokenRouteImport } from './routes/(public)/sign/$token'
import { Route as publicSignAgreementTokenRouteImport } from './routes/(public)/sign-agreement/$token'
import { Route as publicSharedDocumentTokenRouteImport } from './routes/(public)/shared-document/$token'
import { Route as publicSharedAgreementTokenRouteImport } from './routes/(public)/shared-agreement/$token'
import { Route as publicOnboardingPortalTokenRouteImport } from './routes/(public)/onboarding-portal/$token'
import { Route as publicMigrationPortalTokenRouteImport } from './routes/(public)/migration-portal/$token'
import { Route as publicImpersonateTokenRouteImport } from './routes/(public)/impersonate/$token'
import { Route as publicDevMascotRouteImport } from './routes/(public)/dev.mascot'
import { Route as publicDevChatPreviewRouteImport } from './routes/(public)/dev.chat-preview'
import { Route as publicCarePlanShareTokenRouteImport } from './routes/(public)/care-plan-share/$token'
import { Route as AuthenticatedOrganizationSupportCoordinationRouteRouteImport } from './routes/_authenticated/_organization/support-coordination/route'
import { Route as AuthenticatedOrganizationSchedulerRouteRouteImport } from './routes/_authenticated/_organization/scheduler/route'
import { Route as AuthenticatedOrganizationWorkflowsIndexRouteImport } from './routes/_authenticated/_organization/workflows/index'
import { Route as AuthenticatedOrganizationUsersIndexRouteImport } from './routes/_authenticated/_organization/users/index'
import { Route as AuthenticatedOrganizationUpgradeIndexRouteImport } from './routes/_authenticated/_organization/upgrade/index'
import { Route as AuthenticatedOrganizationTrainingIndexRouteImport } from './routes/_authenticated/_organization/training/index'
import { Route as AuthenticatedOrganizationTimesheetsIndexRouteImport } from './routes/_authenticated/_organization/timesheets/index'
import { Route as AuthenticatedOrganizationTasksIndexRouteImport } from './routes/_authenticated/_organization/tasks/index'
import { Route as AuthenticatedOrganizationSupportCoordinationIndexRouteImport } from './routes/_authenticated/_organization/support-coordination/index'
import { Route as AuthenticatedOrganizationStaffIndexRouteImport } from './routes/_authenticated/_organization/staff/index'
import { Route as AuthenticatedOrganizationSchedulerIndexRouteImport } from './routes/_authenticated/_organization/scheduler/index'
import { Route as AuthenticatedOrganizationRosterIndexRouteImport } from './routes/_authenticated/_organization/roster/index'
import { Route as AuthenticatedOrganizationReportsIndexRouteImport } from './routes/_authenticated/_organization/reports/index'
import { Route as AuthenticatedOrganizationReferralsIndexRouteImport } from './routes/_authenticated/_organization/referrals/index'
import { Route as AuthenticatedOrganizationReconciliationIndexRouteImport } from './routes/_authenticated/_organization/reconciliation/index'
import { Route as AuthenticatedOrganizationPublicHolidaysIndexRouteImport } from './routes/_authenticated/_organization/public-holidays/index'
import { Route as AuthenticatedOrganizationPoliciesIndexRouteImport } from './routes/_authenticated/_organization/policies/index'
import { Route as AuthenticatedOrganizationPayrollIndexRouteImport } from './routes/_authenticated/_organization/payroll/index'
import { Route as AuthenticatedOrganizationOffboardingIndexRouteImport } from './routes/_authenticated/_organization/offboarding/index'
import { Route as AuthenticatedOrganizationNotificationsIndexRouteImport } from './routes/_authenticated/_organization/notifications/index'
import { Route as AuthenticatedOrganizationNotesIndexRouteImport } from './routes/_authenticated/_organization/notes/index'
import { Route as AuthenticatedOrganizationNdisStandardsIndexRouteImport } from './routes/_authenticated/_organization/ndis-standards/index'
import { Route as AuthenticatedOrganizationMyTimesheetsIndexRouteImport } from './routes/_authenticated/_organization/my-timesheets/index'
import { Route as AuthenticatedOrganizationMySupportTeamIndexRouteImport } from './routes/_authenticated/_organization/my-support-team/index'
import { Route as AuthenticatedOrganizationMyShiftsIndexRouteImport } from './routes/_authenticated/_organization/my-shifts/index'
import { Route as AuthenticatedOrganizationMyPlanIndexRouteImport } from './routes/_authenticated/_organization/my-plan/index'
import { Route as AuthenticatedOrganizationMyPeopleIndexRouteImport } from './routes/_authenticated/_organization/my-people/index'
import { Route as AuthenticatedOrganizationMyParticipantsIndexRouteImport } from './routes/_authenticated/_organization/my-participants/index'
import { Route as AuthenticatedOrganizationMyOnboardingIndexRouteImport } from './routes/_authenticated/_organization/my-onboarding/index'
import { Route as AuthenticatedOrganizationMyInvoicesIndexRouteImport } from './routes/_authenticated/_organization/my-invoices/index'
import { Route as AuthenticatedOrganizationMyIncidentsIndexRouteImport } from './routes/_authenticated/_organization/my-incidents/index'
import { Route as AuthenticatedOrganizationMyIncidentReportsIndexRouteImport } from './routes/_authenticated/_organization/my-incident-reports/index'
import { Route as AuthenticatedOrganizationMyInboxIndexRouteImport } from './routes/_authenticated/_organization/my-inbox/index'
import { Route as AuthenticatedOrganizationMyGoalsIndexRouteImport } from './routes/_authenticated/_organization/my-goals/index'
import { Route as AuthenticatedOrganizationMyFormsIndexRouteImport } from './routes/_authenticated/_organization/my-forms/index'
import { Route as AuthenticatedOrganizationMyDeclarationsIndexRouteImport } from './routes/_authenticated/_organization/my-declarations/index'
import { Route as AuthenticatedOrganizationMyConsentIndexRouteImport } from './routes/_authenticated/_organization/my-consent/index'
import { Route as AuthenticatedOrganizationMyComplaintsIndexRouteImport } from './routes/_authenticated/_organization/my-complaints/index'
import { Route as AuthenticatedOrganizationMyAvailabilityIndexRouteImport } from './routes/_authenticated/_organization/my-availability/index'
import { Route as AuthenticatedOrganizationMyAppointmentsIndexRouteImport } from './routes/_authenticated/_organization/my-appointments/index'
import { Route as AuthenticatedOrganizationMyAgreementsIndexRouteImport } from './routes/_authenticated/_organization/my-agreements/index'
import { Route as AuthenticatedOrganizationLeaveIndexRouteImport } from './routes/_authenticated/_organization/leave/index'
import { Route as AuthenticatedOrganizationLearnHubshiftIndexRouteImport } from './routes/_authenticated/_organization/learn-hubshift/index'
import { Route as AuthenticatedOrganizationInvoicesIndexRouteImport } from './routes/_authenticated/_organization/invoices/index'
import { Route as AuthenticatedOrganizationIncidentsIndexRouteImport } from './routes/_authenticated/_organization/incidents/index'
import { Route as AuthenticatedOrganizationHelpCenterIndexRouteImport } from './routes/_authenticated/_organization/help-center/index'
import { Route as AuthenticatedOrganizationFormsIndexRouteImport } from './routes/_authenticated/_organization/forms/index'
import { Route as AuthenticatedOrganizationFacilitiesIndexRouteImport } from './routes/_authenticated/_organization/facilities/index'
import { Route as AuthenticatedOrganizationExtractionsIndexRouteImport } from './routes/_authenticated/_organization/extractions/index'
import { Route as AuthenticatedOrganizationExpensesIndexRouteImport } from './routes/_authenticated/_organization/expenses/index'
import { Route as AuthenticatedOrganizationDocumentsIndexRouteImport } from './routes/_authenticated/_organization/documents/index'
import { Route as AuthenticatedOrganizationComplianceIndexRouteImport } from './routes/_authenticated/_organization/compliance/index'
import { Route as AuthenticatedOrganizationClientsIndexRouteImport } from './routes/_authenticated/_organization/clients/index'
import { Route as AuthenticatedOrganizationClaimsIndexRouteImport } from './routes/_authenticated/_organization/claims/index'
import { Route as AuthenticatedOrganizationChatsIndexRouteImport } from './routes/_authenticated/_organization/chats/index'
import { Route as AuthenticatedOrganizationCaseloadIndexRouteImport } from './routes/_authenticated/_organization/caseload/index'
import { Route as AuthenticatedOrganizationCaseNotesIndexRouteImport } from './routes/_authenticated/_organization/case-notes/index'
import { Route as AuthenticatedOrganizationBudgetCalculatorIndexRouteImport } from './routes/_authenticated/_organization/budget-calculator/index'
import { Route as AuthenticatedOrganizationBillingIndexRouteImport } from './routes/_authenticated/_organization/billing/index'
import { Route as AuthenticatedOrganizationAuditLogsIndexRouteImport } from './routes/_authenticated/_organization/audit-logs/index'
import { Route as AuthenticatedOrganizationAppsIndexRouteImport } from './routes/_authenticated/_organization/apps/index'
import { Route as AuthenticatedOrganizationWorkflowsWorkflowIdRouteImport } from './routes/_authenticated/_organization/workflows/$workflowId'
import { Route as AuthenticatedOrganizationTrainingProgramIdRouteImport } from './routes/_authenticated/_organization/training/$programId'
import { Route as AuthenticatedOrganizationSupportPlanSignShareIdRouteImport } from './routes/_authenticated/_organization/support-plan-sign/$shareId'
import { Route as AuthenticatedOrganizationSupportCoordinationTimeEntriesRouteImport } from './routes/_authenticated/_organization/support-coordination/time-entries'
import { Route as AuthenticatedOrganizationSupportCoordinationTelephonyRouteImport } from './routes/_authenticated/_organization/support-coordination/telephony'
import { Route as AuthenticatedOrganizationSupportCoordinationScribeRouteImport } from './routes/_authenticated/_organization/support-coordination/scribe'
import { Route as AuthenticatedOrganizationSupportCoordinationReportsRouteImport } from './routes/_authenticated/_organization/support-coordination/reports'
import { Route as AuthenticatedOrganizationSupportCoordinationRegistersRouteImport } from './routes/_authenticated/_organization/support-coordination/registers'
import { Route as AuthenticatedOrganizationSupportCoordinationPlannerRouteImport } from './routes/_authenticated/_organization/support-coordination/planner'
import { Route as AuthenticatedOrganizationSupportCoordinationNotebookRouteImport } from './routes/_authenticated/_organization/support-coordination/notebook'
import { Route as AuthenticatedOrganizationSupportCoordinationNextBestActionsRouteImport } from './routes/_authenticated/_organization/support-coordination/next-best-actions'
import { Route as AuthenticatedOrganizationSupportCoordinationMailboxSettingsRouteImport } from './routes/_authenticated/_organization/support-coordination/mailbox-settings'
import { Route as AuthenticatedOrganizationSupportCoordinationEmailsRouteImport } from './routes/_authenticated/_organization/support-coordination/emails'
import { Route as AuthenticatedOrganizationSupportCoordinationComplianceRouteImport } from './routes/_authenticated/_organization/support-coordination/compliance'
import { Route as AuthenticatedOrganizationSupportCoordinationCaseNotesRouteImport } from './routes/_authenticated/_organization/support-coordination/case-notes'
import { Route as AuthenticatedOrganizationSupportCoordinationBudgetRouteImport } from './routes/_authenticated/_organization/support-coordination/budget'
import { Route as AuthenticatedOrganizationSupportCoordinationBillingRouteImport } from './routes/_authenticated/_organization/support-coordination/billing'
import { Route as AuthenticatedOrganizationStaffComplianceRouteImport } from './routes/_authenticated/_organization/staff/compliance'
import { Route as AuthenticatedOrganizationShiftsNewRouteImport } from './routes/_authenticated/_organization/shifts/new'
import { Route as AuthenticatedOrganizationSchedulerShiftRequestsRouteImport } from './routes/_authenticated/_organization/scheduler/shift-requests'
import { Route as AuthenticatedOrganizationSchedulerReviewQueueRouteImport } from './routes/_authenticated/_organization/scheduler/review-queue'
import { Route as AuthenticatedOrganizationSchedulerProgressNotesRouteImport } from './routes/_authenticated/_organization/scheduler/progress-notes'
import { Route as AuthenticatedOrganizationSchedulerPostShiftReviewRouteImport } from './routes/_authenticated/_organization/scheduler/post-shift-review'
import { Route as AuthenticatedOrganizationSchedulerOverviewRouteImport } from './routes/_authenticated/_organization/scheduler/overview'
import { Route as AuthenticatedOrganizationSchedulerClashesRouteImport } from './routes/_authenticated/_organization/scheduler/clashes'
import { Route as AuthenticatedOrganizationSchedulerAvailabilityRequestsRouteImport } from './routes/_authenticated/_organization/scheduler/availability-requests'
import { Route as AuthenticatedOrganizationSchedulerAllShiftsRouteImport } from './routes/_authenticated/_organization/scheduler/all-shifts'
import { Route as AuthenticatedOrganizationSchedulerAlertsRouteImport } from './routes/_authenticated/_organization/scheduler/alerts'
import { Route as AuthenticatedOrganizationReportsVoidedChargesRouteImport } from './routes/_authenticated/_organization/reports/voided-charges'
import { Route as AuthenticatedOrganizationReportsUserRecordsRouteImport } from './routes/_authenticated/_organization/reports/user-records'
import { Route as AuthenticatedOrganizationReportsUserAvailabilityRouteImport } from './routes/_authenticated/_organization/reports/user-availability'
import { Route as AuthenticatedOrganizationReportsTeamBillablesRouteImport } from './routes/_authenticated/_organization/reports/team-billables'
import { Route as AuthenticatedOrganizationReportsTeamBillableHoursRouteImport } from './routes/_authenticated/_organization/reports/team-billable-hours'
import { Route as AuthenticatedOrganizationReportsTasksWithoutNotesRouteImport } from './routes/_authenticated/_organization/reports/tasks-without-notes'
import { Route as AuthenticatedOrganizationReportsTasksRouteImport } from './routes/_authenticated/_organization/reports/tasks'
import { Route as AuthenticatedOrganizationReportsSupportsWithoutNotesRouteImport } from './routes/_authenticated/_organization/reports/supports-without-notes'
import { Route as AuthenticatedOrganizationReportsSupportsRouteImport } from './routes/_authenticated/_organization/reports/supports'
import { Route as AuthenticatedOrganizationReportsSupportNotesRouteImport } from './routes/_authenticated/_organization/reports/support-notes'
import { Route as AuthenticatedOrganizationReportsSupportCancellationsRouteImport } from './routes/_authenticated/_organization/reports/support-cancellations'
import { Route as AuthenticatedOrganizationReportsStaffUtilisationRouteImport } from './routes/_authenticated/_organization/reports/staff-utilisation'
import { Route as AuthenticatedOrganizationReportsShiftsRouteImport } from './routes/_authenticated/_organization/reports/shifts'
import { Route as AuthenticatedOrganizationReportsShiftVarianceRouteImport } from './routes/_authenticated/_organization/reports/shift-variance'
import { Route as AuthenticatedOrganizationReportsShiftTasksRouteImport } from './routes/_authenticated/_organization/reports/shift-tasks'
import { Route as AuthenticatedOrganizationReportsShiftClashesRouteImport } from './routes/_authenticated/_organization/reports/shift-clashes'
import { Route as AuthenticatedOrganizationReportsServiceDeliveryRouteImport } from './routes/_authenticated/_organization/reports/service-delivery'
import { Route as AuthenticatedOrganizationReportsRecurringShiftsExpiringRouteImport } from './routes/_authenticated/_organization/reports/recurring-shifts-expiring'
import { Route as AuthenticatedOrganizationReportsPublicHolidaySupportsRouteImport } from './routes/_authenticated/_organization/reports/public-holiday-supports'
import { Route as AuthenticatedOrganizationReportsPreviewRouteImport } from './routes/_authenticated/_organization/reports/preview'
import { Route as AuthenticatedOrganizationReportsParticipantsWithoutRisksRouteImport } from './routes/_authenticated/_organization/reports/participants-without-risks'
import { Route as AuthenticatedOrganizationReportsParticipantsWithoutGoalsRouteImport } from './routes/_authenticated/_organization/reports/participants-without-goals'
import { Route as AuthenticatedOrganizationReportsParticipantUtilisationRouteImport } from './routes/_authenticated/_organization/reports/participant-utilisation'
import { Route as AuthenticatedOrganizationReportsParticipantRisksRouteImport } from './routes/_authenticated/_organization/reports/participant-risks'
import { Route as AuthenticatedOrganizationReportsParticipantRecordsRouteImport } from './routes/_authenticated/_organization/reports/participant-records'
import { Route as AuthenticatedOrganizationReportsParticipantPlansRouteImport } from './routes/_authenticated/_organization/reports/participant-plans'
import { Route as AuthenticatedOrganizationReportsParticipantGoalsRouteImport } from './routes/_authenticated/_organization/reports/participant-goals'
import { Route as AuthenticatedOrganizationReportsParticipantBirthdaysRouteImport } from './routes/_authenticated/_organization/reports/participant-birthdays'
import { Route as AuthenticatedOrganizationReportsParticipantAlertsRouteImport } from './routes/_authenticated/_organization/reports/participant-alerts'
import { Route as AuthenticatedOrganizationReportsOvertimeRouteImport } from './routes/_authenticated/_organization/reports/overtime'
import { Route as AuthenticatedOrganizationReportsNdiaErrorsRouteImport } from './routes/_authenticated/_organization/reports/ndia-errors'
import { Route as AuthenticatedOrganizationReportsMyBillablesRouteImport } from './routes/_authenticated/_organization/reports/my-billables'
import { Route as AuthenticatedOrganizationReportsMyBillableHoursRouteImport } from './routes/_authenticated/_organization/reports/my-billable-hours'
import { Route as AuthenticatedOrganizationReportsMyBillableChargesRouteImport } from './routes/_authenticated/_organization/reports/my-billable-charges'
import { Route as AuthenticatedOrganizationReportsGoalAchievementRouteImport } from './routes/_authenticated/_organization/reports/goal-achievement'
import { Route as AuthenticatedOrganizationReportsExpiredDocumentsRouteImport } from './routes/_authenticated/_organization/reports/expired-documents'
import { Route as AuthenticatedOrganizationReportsCapacityRouteImport } from './routes/_authenticated/_organization/reports/capacity'
import { Route as AuthenticatedOrganizationReportsBillableChargesRouteImport } from './routes/_authenticated/_organization/reports/billable-charges'
import { Route as AuthenticatedOrganizationReferralsReferralIdRouteImport } from './routes/_authenticated/_organization/referrals/$referralId'
import { Route as AuthenticatedOrganizationPoliciesAuditsRouteImport } from './routes/_authenticated/_organization/policies/audits'
import { Route as AuthenticatedOrganizationPayrunsPayRunIdRouteImport } from './routes/_authenticated/_organization/payruns/$payRunId'
import { Route as AuthenticatedOrganizationOnboardingStaffRouteImport } from './routes/_authenticated/_organization/onboarding/staff'
import { Route as AuthenticatedOrganizationOnboardingRequiredDocumentsRouteImport } from './routes/_authenticated/_organization/onboarding/required-documents'
import { Route as AuthenticatedOrganizationOnboardingPreviewRouteImport } from './routes/_authenticated/_organization/onboarding/preview'
import { Route as AuthenticatedOrganizationOnboardingClientRouteImport } from './routes/_authenticated/_organization/onboarding/client'
import { Route as AuthenticatedOrganizationOnboardingAdminRouteImport } from './routes/_authenticated/_organization/onboarding/admin'
import { Route as AuthenticatedOrganizationNdisStandardsReportsRouteImport } from './routes/_authenticated/_organization/ndis-standards/reports'
import { Route as AuthenticatedOrganizationNdisStandardsPoliciesRouteImport } from './routes/_authenticated/_organization/ndis-standards/policies'
import { Route as AuthenticatedOrganizationNdisStandardsKnowledgeBaseRouteImport } from './routes/_authenticated/_organization/ndis-standards/knowledge-base'
import { Route as AuthenticatedOrganizationNdisStandardsIcanRouteImport } from './routes/_authenticated/_organization/ndis-standards/ican'
import { Route as AuthenticatedOrganizationNdisStandardsComplianceRouteImport } from './routes/_authenticated/_organization/ndis-standards/compliance'
import { Route as AuthenticatedOrganizationNdisStandardsAuditsRouteImport } from './routes/_authenticated/_organization/ndis-standards/audits'
import { Route as AuthenticatedOrganizationMyShiftsShiftIdRouteImport } from './routes/_authenticated/_organization/my-shifts/$shiftId'
import { Route as AuthenticatedOrganizationLearnHubshiftTemplateKeyRouteImport } from './routes/_authenticated/_organization/learn-hubshift/$templateKey'
import { Route as AuthenticatedOrganizationInductionInductionIdRouteImport } from './routes/_authenticated/_organization/induction/$inductionId'
import { Route as AuthenticatedOrganizationIncidentsNewRouteImport } from './routes/_authenticated/_organization/incidents/new'
import { Route as AuthenticatedOrganizationIncidentsKnowledgeBaseRouteImport } from './routes/_authenticated/_organization/incidents/knowledge-base'
import { Route as AuthenticatedOrganizationHelpCenterTicketIdRouteImport } from './routes/_authenticated/_organization/help-center/$ticketId'
import { Route as AuthenticatedOrganizationFormsReviewQueueRouteImport } from './routes/_authenticated/_organization/forms/review-queue'
import { Route as AuthenticatedOrganizationFilesViewerRouteImport } from './routes/_authenticated/_organization/files/viewer'
import { Route as AuthenticatedOrganizationExtractionsExamplesRouteImport } from './routes/_authenticated/_organization/extractions/examples'
import { Route as AuthenticatedOrganizationDemoSkeletonRouteImport } from './routes/_authenticated/_organization/demo/skeleton'
import { Route as AuthenticatedOrganizationComplianceStandardsRouteImport } from './routes/_authenticated/_organization/compliance/standards'
import { Route as AuthenticatedOrganizationComplianceRisksRouteImport } from './routes/_authenticated/_organization/compliance/risks'
import { Route as AuthenticatedOrganizationCompliancePoliciesRouteImport } from './routes/_authenticated/_organization/compliance/policies'
import { Route as AuthenticatedOrganizationCompliancePartnersRouteImport } from './routes/_authenticated/_organization/compliance/partners'
import { Route as AuthenticatedOrganizationComplianceHubRouteImport } from './routes/_authenticated/_organization/compliance/hub'
import { Route as AuthenticatedOrganizationComplianceGapAnalysisRouteImport } from './routes/_authenticated/_organization/compliance/gap-analysis'
import { Route as AuthenticatedOrganizationComplianceFindingsRouteImport } from './routes/_authenticated/_organization/compliance/findings'
import { Route as AuthenticatedOrganizationComplianceConflictsOfInterestRouteImport } from './routes/_authenticated/_organization/compliance/conflicts-of-interest'
import { Route as AuthenticatedOrganizationComplianceAuditsRouteImport } from './routes/_authenticated/_organization/compliance/audits'
import { Route as AuthenticatedOrganizationChatsConversationIdRouteImport } from './routes/_authenticated/_organization/chats/$conversationId'
import { Route as AuthenticatedOrganizationBudgetCalculatorQuickRouteImport } from './routes/_authenticated/_organization/budget-calculator/quick'
import { Route as AuthenticatedOrganizationBudgetCalculatorCalculationIdRouteImport } from './routes/_authenticated/_organization/budget-calculator/$calculationId'
import { Route as AuthenticatedOrganizationAppsSkeletonDemoRouteImport } from './routes/_authenticated/_organization/apps/skeleton-demo'
import { Route as publicSharesCrossOrgTokenRouteImport } from './routes/(public)/shares/cross-org/$token'
import { Route as AuthenticatedOrganizationOrganizationsSettingsRouteRouteImport } from './routes/_authenticated/_organization/organizations/settings/route'
import { Route as AuthenticatedOrganizationIncidentsReportsRouteRouteImport } from './routes/_authenticated/_organization/incidents/reports/route'
import { Route as AuthenticatedOrganizationTasksBoardsIndexRouteImport } from './routes/_authenticated/_organization/tasks/boards/index'
import { Route as AuthenticatedOrganizationTasksTaskIdIndexRouteImport } from './routes/_authenticated/_organization/tasks/$taskId/index'
import { Route as AuthenticatedOrganizationStaffTeamsIndexRouteImport } from './routes/_authenticated/_organization/staff/teams/index'
import { Route as AuthenticatedOrganizationStaffStaffIdIndexRouteImport } from './routes/_authenticated/_organization/staff/$staffId/index'
import { Route as AuthenticatedOrganizationSchedulerTemplatesIndexRouteImport } from './routes/_authenticated/_organization/scheduler/templates/index'
import { Route as AuthenticatedOrganizationSchedulerSilIndexRouteImport } from './routes/_authenticated/_organization/scheduler/sil/index'
import { Route as AuthenticatedOrganizationPartnerTrainingIndexRouteImport } from './routes/_authenticated/_organization/partner/training/index'
import { Route as AuthenticatedOrganizationPartnerProvidersIndexRouteImport } from './routes/_authenticated/_organization/partner/providers/index'
import { Route as AuthenticatedOrganizationPartnerLibraryIndexRouteImport } from './routes/_authenticated/_organization/partner/library/index'
import { Route as AuthenticatedOrganizationOrganizationsInductionsIndexRouteImport } from './routes/_authenticated/_organization/organizations/inductions/index'
import { Route as AuthenticatedOrganizationOnboardingManagementIndexRouteImport } from './routes/_authenticated/_organization/onboarding/management/index'
import { Route as AuthenticatedOrganizationNdisStandardsComplaintsIndexRouteImport } from './routes/_authenticated/_organization/ndis-standards/complaints/index'
import { Route as AuthenticatedOrganizationIncidentsReportsIndexRouteImport } from './routes/_authenticated/_organization/incidents/reports/index'
import { Route as AuthenticatedOrganizationIncidentsIncidentIdIndexRouteImport } from './routes/_authenticated/_organization/incidents/$incidentId/index'
import { Route as AuthenticatedOrganizationComplianceRestrictivePracticesIndexRouteImport } from './routes/_authenticated/_organization/compliance/restrictive-practices/index'
import { Route as AuthenticatedOrganizationCompliancePolicyPackIndexRouteImport } from './routes/_authenticated/_organization/compliance/policy-pack/index'
import { Route as AuthenticatedOrganizationComplianceComplaintsIndexRouteImport } from './routes/_authenticated/_organization/compliance/complaints/index'
import { Route as AuthenticatedOrganizationClientsTeamsIndexRouteImport } from './routes/_authenticated/_organization/clients/teams/index'
import { Route as AuthenticatedOrganizationClientsClientIdIndexRouteImport } from './routes/_authenticated/_organization/clients/$clientId/index'
import { Route as AuthenticatedOrganizationTasksBoardsBoardIdRouteImport } from './routes/_authenticated/_organization/tasks/boards/$boardId'
import { Route as AuthenticatedOrganizationSupportCoordinationScribeNoteIdRouteImport } from './routes/_authenticated/_organization/support-coordination/scribe.$noteId'
import { Route as AuthenticatedOrganizationStaffStaffIdWorkRightsRouteImport } from './routes/_authenticated/_organization/staff/$staffId/work-rights'
import { Route as AuthenticatedOrganizationStaffStaffIdRosterRouteImport } from './routes/_authenticated/_organization/staff/$staffId/roster'
import { Route as AuthenticatedOrganizationStaffStaffIdProfileRouteImport } from './routes/_authenticated/_organization/staff/$staffId/profile'
import { Route as AuthenticatedOrganizationStaffStaffIdPerformanceRouteImport } from './routes/_authenticated/_organization/staff/$staffId/performance'
import { Route as AuthenticatedOrganizationStaffStaffIdPayrollRouteImport } from './routes/_authenticated/_organization/staff/$staffId/payroll'
import { Route as AuthenticatedOrganizationStaffStaffIdOverviewRouteImport } from './routes/_authenticated/_organization/staff/$staffId/overview'
import { Route as AuthenticatedOrganizationStaffStaffIdEmploymentRouteImport } from './routes/_authenticated/_organization/staff/$staffId/employment'
import { Route as AuthenticatedOrganizationStaffStaffIdDocumentsRouteImport } from './routes/_authenticated/_organization/staff/$staffId/documents'
import { Route as AuthenticatedOrganizationStaffStaffIdClientsRouteImport } from './routes/_authenticated/_organization/staff/$staffId/clients'
import { Route as AuthenticatedOrganizationShiftsShiftIdEditRouteImport } from './routes/_authenticated/_organization/shifts/$shiftId/edit'
import { Route as AuthenticatedOrganizationSchedulerTemplatesTemplateIdRouteImport } from './routes/_authenticated/_organization/scheduler/templates/$templateId'
import { Route as AuthenticatedOrganizationSchedulerSilArrangementIdRouteImport } from './routes/_authenticated/_organization/scheduler/sil/$arrangementId'
import { Route as AuthenticatedOrganizationPartnerTrainingTemplateIdRouteImport } from './routes/_authenticated/_organization/partner/training/$templateId'
import { Route as AuthenticatedOrganizationPartnerProvidersProviderOrgIdRouteImport } from './routes/_authenticated/_organization/partner/providers/$providerOrgId'
import { Route as AuthenticatedOrganizationOrganizationsSettingsTravelRouteImport } from './routes/_authenticated/_organization/organizations/settings/travel'
import { Route as AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRouteImport } from './routes/_authenticated/_organization/organizations/settings/terms-privacy'
import { Route as AuthenticatedOrganizationOrganizationsSettingsServiceTypesRouteImport } from './routes/_authenticated/_organization/organizations/settings/service-types'
import { Route as AuthenticatedOrganizationOrganizationsSettingsRolesRouteImport } from './routes/_authenticated/_organization/organizations/settings/roles'
import { Route as AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRouteImport } from './routes/_authenticated/_organization/organizations/settings/reports-configuration'
import { Route as AuthenticatedOrganizationOrganizationsSettingsRegionsRouteImport } from './routes/_authenticated/_organization/organizations/settings/regions'
import { Route as AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRouteImport } from './routes/_authenticated/_organization/organizations/settings/referral-intake'
import { Route as AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRouteImport } from './routes/_authenticated/_organization/organizations/settings/public-holidays'
import { Route as AuthenticatedOrganizationOrganizationsSettingsProfileRouteImport } from './routes/_authenticated/_organization/organizations/settings/profile'
import { Route as AuthenticatedOrganizationOrganizationsSettingsPrivacyRouteImport } from './routes/_authenticated/_organization/organizations/settings/privacy'
import { Route as AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRouteImport } from './routes/_authenticated/_organization/organizations/settings/permission-matrix'
import { Route as AuthenticatedOrganizationOrganizationsSettingsPayrollRouteImport } from './routes/_authenticated/_organization/organizations/settings/payroll'
import { Route as AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRouteImport } from './routes/_authenticated/_organization/organizations/settings/notifications-config'
import { Route as AuthenticatedOrganizationOrganizationsSettingsMembersRouteImport } from './routes/_authenticated/_organization/organizations/settings/members'
import { Route as AuthenticatedOrganizationOrganizationsSettingsLineItemsRouteImport } from './routes/_authenticated/_organization/organizations/settings/line-items'
import { Route as AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRouteImport } from './routes/_authenticated/_organization/organizations/settings/invoice-templates'
import { Route as AuthenticatedOrganizationOrganizationsSettingsIntegrationsRouteImport } from './routes/_authenticated/_organization/organizations/settings/integrations'
import { Route as AuthenticatedOrganizationOrganizationsSettingsInductionRouteImport } from './routes/_authenticated/_organization/organizations/settings/induction'
import { Route as AuthenticatedOrganizationOrganizationsSettingsGoLiveRouteImport } from './routes/_authenticated/_organization/organizations/settings/go-live'
import { Route as AuthenticatedOrganizationOrganizationsSettingsFacilitiesRouteImport } from './routes/_authenticated/_organization/organizations/settings/facilities'
import { Route as AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRouteImport } from './routes/_authenticated/_organization/organizations/settings/document-types'
import { Route as AuthenticatedOrganizationOrganizationsSettingsDataMigrationRouteImport } from './routes/_authenticated/_organization/organizations/settings/data-migration'
import { Route as AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRouteImport } from './routes/_authenticated/_organization/organizations/settings/compliance-profile'
import { Route as AuthenticatedOrganizationOrganizationsSettingsClockInRouteImport } from './routes/_authenticated/_organization/organizations/settings/clock-in'
import { Route as AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRouteImport } from './routes/_authenticated/_organization/organizations/settings/client-document-types'
import { Route as AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRouteImport } from './routes/_authenticated/_organization/organizations/settings/cancellation-policy'
import { Route as AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRouteImport } from './routes/_authenticated/_organization/organizations/settings/award-xero-mapping'
import { Route as AuthenticatedOrganizationOrganizationsSettingsAwardRatesRouteImport } from './routes/_authenticated/_organization/organizations/settings/award-rates'
import { Route as AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRouteImport } from './routes/_authenticated/_organization/organizations/settings/assistant-knowledge'
import { Route as AuthenticatedOrganizationOrganizationsSettingsAiSettingsRouteImport } from './routes/_authenticated/_organization/organizations/settings/ai-settings'
import { Route as AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRouteImport } from './routes/_authenticated/_organization/organizations/settings/agreement-sections'
import { Route as AuthenticatedOrganizationOnboardingManagementPipelineRouteImport } from './routes/_authenticated/_organization/onboarding/management/pipeline'
import { Route as AuthenticatedOrganizationOnboardingManagementMemberIdRouteImport } from './routes/_authenticated/_organization/onboarding/management/$memberId'
import { Route as AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRouteImport } from './routes/_authenticated/_organization/ndis-standards/complaints/$complaintId'
import { Route as AuthenticatedOrganizationIncidentsReportsTrendAnalysisRouteImport } from './routes/_authenticated/_organization/incidents/reports/trend-analysis'
import { Route as AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRouteImport } from './routes/_authenticated/_organization/incidents/reports/operational-performance'
import { Route as AuthenticatedOrganizationIncidentsReportsIncidentMappingRouteImport } from './routes/_authenticated/_organization/incidents/reports/incident-mapping'
import { Route as AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRouteImport } from './routes/_authenticated/_organization/incidents/reports/executive-summary'
import { Route as AuthenticatedOrganizationIncidentsReportsComplianceRouteImport } from './routes/_authenticated/_organization/incidents/reports/compliance'
import { Route as AuthenticatedOrganizationIncidentsIncidentIdEditRouteImport } from './routes/_authenticated/_organization/incidents/$incidentId/edit'
import { Route as AuthenticatedOrganizationFormsFormIdPreviewRouteImport } from './routes/_authenticated/_organization/forms/$formId/preview'
import { Route as AuthenticatedOrganizationFormsFormIdFillRouteImport } from './routes/_authenticated/_organization/forms/$formId/fill'
import { Route as AuthenticatedOrganizationFormsFormIdEditRouteImport } from './routes/_authenticated/_organization/forms/$formId/edit'
import { Route as AuthenticatedOrganizationComplianceRisksSettingsRouteImport } from './routes/_authenticated/_organization/compliance/risks_.settings'
import { Route as AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRouteImport } from './routes/_authenticated/_organization/compliance/restrictive-practices/monthly-report'
import { Route as AuthenticatedOrganizationCompliancePolicyPackRunIdRouteImport } from './routes/_authenticated/_organization/compliance/policy-pack/$runId'
import { Route as AuthenticatedOrganizationCompliancePoliciesPolicyIdRouteImport } from './routes/_authenticated/_organization/compliance/policies_.$policyId'
import { Route as AuthenticatedOrganizationComplianceComplaintsComplaintIdRouteImport } from './routes/_authenticated/_organization/compliance/complaints/$complaintId'
import { Route as AuthenticatedOrganizationComplianceAuditsAuditIdRouteImport } from './routes/_authenticated/_organization/compliance/audits_.$auditId'
import { Route as AuthenticatedOrganizationClientsClientIdTransitionsRouteImport } from './routes/_authenticated/_organization/clients/$clientId/transitions'
import { Route as AuthenticatedOrganizationClientsClientIdSupportPlanRouteImport } from './routes/_authenticated/_organization/clients/$clientId/support-plan'
import { Route as AuthenticatedOrganizationClientsClientIdSupportCoordinationRouteImport } from './routes/_authenticated/_organization/clients/$clientId/support-coordination'
import { Route as AuthenticatedOrganizationClientsClientIdStakeholdersRouteImport } from './routes/_authenticated/_organization/clients/$clientId/stakeholders'
import { Route as AuthenticatedOrganizationClientsClientIdServiceAgreementRouteImport } from './routes/_authenticated/_organization/clients/$clientId/service-agreement'
import { Route as AuthenticatedOrganizationClientsClientIdSchedulesRouteImport } from './routes/_authenticated/_organization/clients/$clientId/schedules'
import { Route as AuthenticatedOrganizationClientsClientIdRiskProfileRouteImport } from './routes/_authenticated/_organization/clients/$clientId/risk-profile'
import { Route as AuthenticatedOrganizationClientsClientIdProfileRouteImport } from './routes/_authenticated/_organization/clients/$clientId/profile'
import { Route as AuthenticatedOrganizationClientsClientIdOverviewRouteImport } from './routes/_authenticated/_organization/clients/$clientId/overview'
import { Route as AuthenticatedOrganizationClientsClientIdOnboardingRouteImport } from './routes/_authenticated/_organization/clients/$clientId/onboarding'
import { Route as AuthenticatedOrganizationClientsClientIdNotesRouteImport } from './routes/_authenticated/_organization/clients/$clientId/notes'
import { Route as AuthenticatedOrganizationClientsClientIdMedicationsRouteImport } from './routes/_authenticated/_organization/clients/$clientId/medications'
import { Route as AuthenticatedOrganizationClientsClientIdIntakeRouteImport } from './routes/_authenticated/_organization/clients/$clientId/intake'
import { Route as AuthenticatedOrganizationClientsClientIdIncidentsRouteImport } from './routes/_authenticated/_organization/clients/$clientId/incidents'
import { Route as AuthenticatedOrganizationClientsClientIdIcanRouteImport } from './routes/_authenticated/_organization/clients/$clientId/ican'
import { Route as AuthenticatedOrganizationClientsClientIdGoalsRouteImport } from './routes/_authenticated/_organization/clients/$clientId/goals'
import { Route as AuthenticatedOrganizationClientsClientIdFundingRouteImport } from './routes/_authenticated/_organization/clients/$clientId/funding'
import { Route as AuthenticatedOrganizationClientsClientIdEvidencePacksRouteImport } from './routes/_authenticated/_organization/clients/$clientId/evidence-packs'
import { Route as AuthenticatedOrganizationClientsClientIdDocumentsRouteImport } from './routes/_authenticated/_organization/clients/$clientId/documents'
import { Route as AuthenticatedOrganizationClientsClientIdCarePlanRouteImport } from './routes/_authenticated/_organization/clients/$clientId/care-plan'
import { Route as AuthenticatedOrganizationClientsClientIdBehaviourSupportRouteImport } from './routes/_authenticated/_organization/clients/$clientId/behaviour-support'
import { Route as AuthenticatedOrganizationClientsClientIdAuditTrailRouteImport } from './routes/_authenticated/_organization/clients/$clientId/audit-trail'
import { Route as AuthenticatedOrganizationClientsClientIdAppointmentsRouteImport } from './routes/_authenticated/_organization/clients/$clientId/appointments'
import { Route as AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRouteImport } from './routes/_authenticated/_organization/organizations/settings/training-programs/index'
import { Route as AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRouteImport } from './routes/_authenticated/_organization/organizations/settings/progress-note-templates/index'
import { Route as AuthenticatedOrganizationFormsFormIdSubmissionsIndexRouteImport } from './routes/_authenticated/_organization/forms/$formId/submissions/index'
import { Route as AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRouteImport } from './routes/_authenticated/_organization/organizations/settings/training-programs/$programId'
import { Route as AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRouteImport } from './routes/_authenticated/_organization/organizations/settings/progress-note-templates/$templateId'
import { Route as AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRouteImport } from './routes/_authenticated/_organization/forms/$formId/submissions/$submissionId'
import { Route as AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRouteImport } from './routes/_authenticated/_organization/compliance/policies_.$policyId_.redraft.$proposalId'

const SetupPasskeyRoute = SetupPasskeyRouteImport.update({
  id: '/setup-passkey',
  path: '/setup-passkey',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpRoute = OtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const FarewellRoute = FarewellRouteImport.update({
  id: '/farewell',
  path: '/farewell',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationInvitationIdRoute =
  AcceptInvitationInvitationIdRouteImport.update({
    id: '/accept-invitation/$invitationId',
    path: '/accept-invitation/$invitationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedGetTheAppRoute = AuthenticatedGetTheAppRouteImport.update({
  id: '/get-the-app',
  path: '/get-the-app',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedForceChangePasswordRoute =
  AuthenticatedForceChangePasswordRouteImport.update({
    id: '/force-change-password',
    path: '/force-change-password',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authTwoFactorRoute = authTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authChangePasswordRoute = authChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => authRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationRouteRoute =
  AuthenticatedOrganizationRouteRouteImport.update({
    id: '/_organization',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedCreateOrganizationIndexRoute =
  AuthenticatedCreateOrganizationIndexRouteImport.update({
    id: '/create-organization/',
    path: '/create-organization/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationIndexRoute =
  AuthenticatedOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsIntegrationsRoute =
  AuthenticatedSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsCommunicationRoute =
  AuthenticatedSettingsCommunicationRouteImport.update({
    id: '/communication',
    path: '/communication',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationSignaturesRoute =
  AuthenticatedOrganizationSignaturesRouteImport.update({
    id: '/signatures',
    path: '/signatures',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationCrossOrgRoute =
  AuthenticatedOrganizationCrossOrgRouteImport.update({
    id: '/cross-org',
    path: '/cross-org',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationAiGatewayRoute =
  AuthenticatedOrganizationAiGatewayRouteImport.update({
    id: '/ai-gateway',
    path: '/ai-gateway',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const publicSupportPlanShareTokenRoute =
  publicSupportPlanShareTokenRouteImport.update({
    id: '/(public)/support-plan-share/$token',
    path: '/support-plan-share/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicSilRocShareTokenRoute = publicSilRocShareTokenRouteImport.update({
  id: '/(public)/sil-roc-share/$token',
  path: '/sil-roc-share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const publicSignTokenRoute = publicSignTokenRouteImport.update({
  id: '/(public)/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const publicSignAgreementTokenRoute =
  publicSignAgreementTokenRouteImport.update({
    id: '/(public)/sign-agreement/$token',
    path: '/sign-agreement/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicSharedDocumentTokenRoute =
  publicSharedDocumentTokenRouteImport.update({
    id: '/(public)/shared-document/$token',
    path: '/shared-document/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicSharedAgreementTokenRoute =
  publicSharedAgreementTokenRouteImport.update({
    id: '/(public)/shared-agreement/$token',
    path: '/shared-agreement/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicOnboardingPortalTokenRoute =
  publicOnboardingPortalTokenRouteImport.update({
    id: '/(public)/onboarding-portal/$token',
    path: '/onboarding-portal/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicMigrationPortalTokenRoute =
  publicMigrationPortalTokenRouteImport.update({
    id: '/(public)/migration-portal/$token',
    path: '/migration-portal/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const publicImpersonateTokenRoute = publicImpersonateTokenRouteImport.update({
  id: '/(public)/impersonate/$token',
  path: '/impersonate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const publicDevMascotRoute = publicDevMascotRouteImport.update({
  id: '/(public)/dev/mascot',
  path: '/dev/mascot',
  getParentRoute: () => rootRouteImport,
} as any)
const publicDevChatPreviewRoute = publicDevChatPreviewRouteImport.update({
  id: '/(public)/dev/chat-preview',
  path: '/dev/chat-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const publicCarePlanShareTokenRoute =
  publicCarePlanShareTokenRouteImport.update({
    id: '/(public)/care-plan-share/$token',
    path: '/care-plan-share/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedOrganizationSupportCoordinationRouteRoute =
  AuthenticatedOrganizationSupportCoordinationRouteRouteImport.update({
    id: '/support-coordination',
    path: '/support-coordination',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerRouteRoute =
  AuthenticatedOrganizationSchedulerRouteRouteImport.update({
    id: '/scheduler',
    path: '/scheduler',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationWorkflowsIndexRoute =
  AuthenticatedOrganizationWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationUsersIndexRoute =
  AuthenticatedOrganizationUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationUpgradeIndexRoute =
  AuthenticatedOrganizationUpgradeIndexRouteImport.update({
    id: '/upgrade/',
    path: '/upgrade/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTrainingIndexRoute =
  AuthenticatedOrganizationTrainingIndexRouteImport.update({
    id: '/training/',
    path: '/training/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTimesheetsIndexRoute =
  AuthenticatedOrganizationTimesheetsIndexRouteImport.update({
    id: '/timesheets/',
    path: '/timesheets/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTasksIndexRoute =
  AuthenticatedOrganizationTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationIndexRoute =
  AuthenticatedOrganizationSupportCoordinationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffIndexRoute =
  AuthenticatedOrganizationStaffIndexRouteImport.update({
    id: '/staff/',
    path: '/staff/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerIndexRoute =
  AuthenticatedOrganizationSchedulerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationRosterIndexRoute =
  AuthenticatedOrganizationRosterIndexRouteImport.update({
    id: '/roster/',
    path: '/roster/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsIndexRoute =
  AuthenticatedOrganizationReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReferralsIndexRoute =
  AuthenticatedOrganizationReferralsIndexRouteImport.update({
    id: '/referrals/',
    path: '/referrals/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReconciliationIndexRoute =
  AuthenticatedOrganizationReconciliationIndexRouteImport.update({
    id: '/reconciliation/',
    path: '/reconciliation/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPublicHolidaysIndexRoute =
  AuthenticatedOrganizationPublicHolidaysIndexRouteImport.update({
    id: '/public-holidays/',
    path: '/public-holidays/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPoliciesIndexRoute =
  AuthenticatedOrganizationPoliciesIndexRouteImport.update({
    id: '/policies/',
    path: '/policies/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPayrollIndexRoute =
  AuthenticatedOrganizationPayrollIndexRouteImport.update({
    id: '/payroll/',
    path: '/payroll/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOffboardingIndexRoute =
  AuthenticatedOrganizationOffboardingIndexRouteImport.update({
    id: '/offboarding/',
    path: '/offboarding/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNotificationsIndexRoute =
  AuthenticatedOrganizationNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNotesIndexRoute =
  AuthenticatedOrganizationNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsIndexRoute =
  AuthenticatedOrganizationNdisStandardsIndexRouteImport.update({
    id: '/ndis-standards/',
    path: '/ndis-standards/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyTimesheetsIndexRoute =
  AuthenticatedOrganizationMyTimesheetsIndexRouteImport.update({
    id: '/my-timesheets/',
    path: '/my-timesheets/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMySupportTeamIndexRoute =
  AuthenticatedOrganizationMySupportTeamIndexRouteImport.update({
    id: '/my-support-team/',
    path: '/my-support-team/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyShiftsIndexRoute =
  AuthenticatedOrganizationMyShiftsIndexRouteImport.update({
    id: '/my-shifts/',
    path: '/my-shifts/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyPlanIndexRoute =
  AuthenticatedOrganizationMyPlanIndexRouteImport.update({
    id: '/my-plan/',
    path: '/my-plan/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyPeopleIndexRoute =
  AuthenticatedOrganizationMyPeopleIndexRouteImport.update({
    id: '/my-people/',
    path: '/my-people/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyParticipantsIndexRoute =
  AuthenticatedOrganizationMyParticipantsIndexRouteImport.update({
    id: '/my-participants/',
    path: '/my-participants/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyOnboardingIndexRoute =
  AuthenticatedOrganizationMyOnboardingIndexRouteImport.update({
    id: '/my-onboarding/',
    path: '/my-onboarding/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyInvoicesIndexRoute =
  AuthenticatedOrganizationMyInvoicesIndexRouteImport.update({
    id: '/my-invoices/',
    path: '/my-invoices/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyIncidentsIndexRoute =
  AuthenticatedOrganizationMyIncidentsIndexRouteImport.update({
    id: '/my-incidents/',
    path: '/my-incidents/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyIncidentReportsIndexRoute =
  AuthenticatedOrganizationMyIncidentReportsIndexRouteImport.update({
    id: '/my-incident-reports/',
    path: '/my-incident-reports/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyInboxIndexRoute =
  AuthenticatedOrganizationMyInboxIndexRouteImport.update({
    id: '/my-inbox/',
    path: '/my-inbox/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyGoalsIndexRoute =
  AuthenticatedOrganizationMyGoalsIndexRouteImport.update({
    id: '/my-goals/',
    path: '/my-goals/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyFormsIndexRoute =
  AuthenticatedOrganizationMyFormsIndexRouteImport.update({
    id: '/my-forms/',
    path: '/my-forms/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyDeclarationsIndexRoute =
  AuthenticatedOrganizationMyDeclarationsIndexRouteImport.update({
    id: '/my-declarations/',
    path: '/my-declarations/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyConsentIndexRoute =
  AuthenticatedOrganizationMyConsentIndexRouteImport.update({
    id: '/my-consent/',
    path: '/my-consent/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyComplaintsIndexRoute =
  AuthenticatedOrganizationMyComplaintsIndexRouteImport.update({
    id: '/my-complaints/',
    path: '/my-complaints/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyAvailabilityIndexRoute =
  AuthenticatedOrganizationMyAvailabilityIndexRouteImport.update({
    id: '/my-availability/',
    path: '/my-availability/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyAppointmentsIndexRoute =
  AuthenticatedOrganizationMyAppointmentsIndexRouteImport.update({
    id: '/my-appointments/',
    path: '/my-appointments/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyAgreementsIndexRoute =
  AuthenticatedOrganizationMyAgreementsIndexRouteImport.update({
    id: '/my-agreements/',
    path: '/my-agreements/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationLeaveIndexRoute =
  AuthenticatedOrganizationLeaveIndexRouteImport.update({
    id: '/leave/',
    path: '/leave/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationLearnHubshiftIndexRoute =
  AuthenticatedOrganizationLearnHubshiftIndexRouteImport.update({
    id: '/learn-hubshift/',
    path: '/learn-hubshift/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationInvoicesIndexRoute =
  AuthenticatedOrganizationInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsIndexRoute =
  AuthenticatedOrganizationIncidentsIndexRouteImport.update({
    id: '/incidents/',
    path: '/incidents/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationHelpCenterIndexRoute =
  AuthenticatedOrganizationHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFormsIndexRoute =
  AuthenticatedOrganizationFormsIndexRouteImport.update({
    id: '/forms/',
    path: '/forms/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFacilitiesIndexRoute =
  AuthenticatedOrganizationFacilitiesIndexRouteImport.update({
    id: '/facilities/',
    path: '/facilities/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationExtractionsIndexRoute =
  AuthenticatedOrganizationExtractionsIndexRouteImport.update({
    id: '/extractions/',
    path: '/extractions/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationExpensesIndexRoute =
  AuthenticatedOrganizationExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationDocumentsIndexRoute =
  AuthenticatedOrganizationDocumentsIndexRouteImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceIndexRoute =
  AuthenticatedOrganizationComplianceIndexRouteImport.update({
    id: '/compliance/',
    path: '/compliance/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsIndexRoute =
  AuthenticatedOrganizationClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClaimsIndexRoute =
  AuthenticatedOrganizationClaimsIndexRouteImport.update({
    id: '/claims/',
    path: '/claims/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationChatsIndexRoute =
  AuthenticatedOrganizationChatsIndexRouteImport.update({
    id: '/chats/',
    path: '/chats/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationCaseloadIndexRoute =
  AuthenticatedOrganizationCaseloadIndexRouteImport.update({
    id: '/caseload/',
    path: '/caseload/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationCaseNotesIndexRoute =
  AuthenticatedOrganizationCaseNotesIndexRouteImport.update({
    id: '/case-notes/',
    path: '/case-notes/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationBudgetCalculatorIndexRoute =
  AuthenticatedOrganizationBudgetCalculatorIndexRouteImport.update({
    id: '/budget-calculator/',
    path: '/budget-calculator/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationBillingIndexRoute =
  AuthenticatedOrganizationBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationAuditLogsIndexRoute =
  AuthenticatedOrganizationAuditLogsIndexRouteImport.update({
    id: '/audit-logs/',
    path: '/audit-logs/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationAppsIndexRoute =
  AuthenticatedOrganizationAppsIndexRouteImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationWorkflowsWorkflowIdRoute =
  AuthenticatedOrganizationWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTrainingProgramIdRoute =
  AuthenticatedOrganizationTrainingProgramIdRouteImport.update({
    id: '/training/$programId',
    path: '/training/$programId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportPlanSignShareIdRoute =
  AuthenticatedOrganizationSupportPlanSignShareIdRouteImport.update({
    id: '/support-plan-sign/$shareId',
    path: '/support-plan-sign/$shareId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute =
  AuthenticatedOrganizationSupportCoordinationTimeEntriesRouteImport.update({
    id: '/time-entries',
    path: '/time-entries',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationTelephonyRoute =
  AuthenticatedOrganizationSupportCoordinationTelephonyRouteImport.update({
    id: '/telephony',
    path: '/telephony',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationScribeRoute =
  AuthenticatedOrganizationSupportCoordinationScribeRouteImport.update({
    id: '/scribe',
    path: '/scribe',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationReportsRoute =
  AuthenticatedOrganizationSupportCoordinationReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationRegistersRoute =
  AuthenticatedOrganizationSupportCoordinationRegistersRouteImport.update({
    id: '/registers',
    path: '/registers',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationPlannerRoute =
  AuthenticatedOrganizationSupportCoordinationPlannerRouteImport.update({
    id: '/planner',
    path: '/planner',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationNotebookRoute =
  AuthenticatedOrganizationSupportCoordinationNotebookRouteImport.update({
    id: '/notebook',
    path: '/notebook',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute =
  AuthenticatedOrganizationSupportCoordinationNextBestActionsRouteImport.update(
    {
      id: '/next-best-actions',
      path: '/next-best-actions',
      getParentRoute: () =>
        AuthenticatedOrganizationSupportCoordinationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute =
  AuthenticatedOrganizationSupportCoordinationMailboxSettingsRouteImport.update(
    {
      id: '/mailbox-settings',
      path: '/mailbox-settings',
      getParentRoute: () =>
        AuthenticatedOrganizationSupportCoordinationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationSupportCoordinationEmailsRoute =
  AuthenticatedOrganizationSupportCoordinationEmailsRouteImport.update({
    id: '/emails',
    path: '/emails',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationComplianceRoute =
  AuthenticatedOrganizationSupportCoordinationComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationCaseNotesRoute =
  AuthenticatedOrganizationSupportCoordinationCaseNotesRouteImport.update({
    id: '/case-notes',
    path: '/case-notes',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationBudgetRoute =
  AuthenticatedOrganizationSupportCoordinationBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationBillingRoute =
  AuthenticatedOrganizationSupportCoordinationBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffComplianceRoute =
  AuthenticatedOrganizationStaffComplianceRouteImport.update({
    id: '/staff/compliance',
    path: '/staff/compliance',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationShiftsNewRoute =
  AuthenticatedOrganizationShiftsNewRouteImport.update({
    id: '/shifts/new',
    path: '/shifts/new',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerShiftRequestsRoute =
  AuthenticatedOrganizationSchedulerShiftRequestsRouteImport.update({
    id: '/shift-requests',
    path: '/shift-requests',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerReviewQueueRoute =
  AuthenticatedOrganizationSchedulerReviewQueueRouteImport.update({
    id: '/review-queue',
    path: '/review-queue',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerProgressNotesRoute =
  AuthenticatedOrganizationSchedulerProgressNotesRouteImport.update({
    id: '/progress-notes',
    path: '/progress-notes',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerPostShiftReviewRoute =
  AuthenticatedOrganizationSchedulerPostShiftReviewRouteImport.update({
    id: '/post-shift-review',
    path: '/post-shift-review',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerOverviewRoute =
  AuthenticatedOrganizationSchedulerOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerClashesRoute =
  AuthenticatedOrganizationSchedulerClashesRouteImport.update({
    id: '/clashes',
    path: '/clashes',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute =
  AuthenticatedOrganizationSchedulerAvailabilityRequestsRouteImport.update({
    id: '/availability-requests',
    path: '/availability-requests',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerAllShiftsRoute =
  AuthenticatedOrganizationSchedulerAllShiftsRouteImport.update({
    id: '/all-shifts',
    path: '/all-shifts',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerAlertsRoute =
  AuthenticatedOrganizationSchedulerAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsVoidedChargesRoute =
  AuthenticatedOrganizationReportsVoidedChargesRouteImport.update({
    id: '/reports/voided-charges',
    path: '/reports/voided-charges',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsUserRecordsRoute =
  AuthenticatedOrganizationReportsUserRecordsRouteImport.update({
    id: '/reports/user-records',
    path: '/reports/user-records',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsUserAvailabilityRoute =
  AuthenticatedOrganizationReportsUserAvailabilityRouteImport.update({
    id: '/reports/user-availability',
    path: '/reports/user-availability',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsTeamBillablesRoute =
  AuthenticatedOrganizationReportsTeamBillablesRouteImport.update({
    id: '/reports/team-billables',
    path: '/reports/team-billables',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsTeamBillableHoursRoute =
  AuthenticatedOrganizationReportsTeamBillableHoursRouteImport.update({
    id: '/reports/team-billable-hours',
    path: '/reports/team-billable-hours',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsTasksWithoutNotesRoute =
  AuthenticatedOrganizationReportsTasksWithoutNotesRouteImport.update({
    id: '/reports/tasks-without-notes',
    path: '/reports/tasks-without-notes',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsTasksRoute =
  AuthenticatedOrganizationReportsTasksRouteImport.update({
    id: '/reports/tasks',
    path: '/reports/tasks',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsSupportsWithoutNotesRoute =
  AuthenticatedOrganizationReportsSupportsWithoutNotesRouteImport.update({
    id: '/reports/supports-without-notes',
    path: '/reports/supports-without-notes',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsSupportsRoute =
  AuthenticatedOrganizationReportsSupportsRouteImport.update({
    id: '/reports/supports',
    path: '/reports/supports',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsSupportNotesRoute =
  AuthenticatedOrganizationReportsSupportNotesRouteImport.update({
    id: '/reports/support-notes',
    path: '/reports/support-notes',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsSupportCancellationsRoute =
  AuthenticatedOrganizationReportsSupportCancellationsRouteImport.update({
    id: '/reports/support-cancellations',
    path: '/reports/support-cancellations',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsStaffUtilisationRoute =
  AuthenticatedOrganizationReportsStaffUtilisationRouteImport.update({
    id: '/reports/staff-utilisation',
    path: '/reports/staff-utilisation',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsShiftsRoute =
  AuthenticatedOrganizationReportsShiftsRouteImport.update({
    id: '/reports/shifts',
    path: '/reports/shifts',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsShiftVarianceRoute =
  AuthenticatedOrganizationReportsShiftVarianceRouteImport.update({
    id: '/reports/shift-variance',
    path: '/reports/shift-variance',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsShiftTasksRoute =
  AuthenticatedOrganizationReportsShiftTasksRouteImport.update({
    id: '/reports/shift-tasks',
    path: '/reports/shift-tasks',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsShiftClashesRoute =
  AuthenticatedOrganizationReportsShiftClashesRouteImport.update({
    id: '/reports/shift-clashes',
    path: '/reports/shift-clashes',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsServiceDeliveryRoute =
  AuthenticatedOrganizationReportsServiceDeliveryRouteImport.update({
    id: '/reports/service-delivery',
    path: '/reports/service-delivery',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute =
  AuthenticatedOrganizationReportsRecurringShiftsExpiringRouteImport.update({
    id: '/reports/recurring-shifts-expiring',
    path: '/reports/recurring-shifts-expiring',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsPublicHolidaySupportsRoute =
  AuthenticatedOrganizationReportsPublicHolidaySupportsRouteImport.update({
    id: '/reports/public-holiday-supports',
    path: '/reports/public-holiday-supports',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsPreviewRoute =
  AuthenticatedOrganizationReportsPreviewRouteImport.update({
    id: '/reports/preview',
    path: '/reports/preview',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute =
  AuthenticatedOrganizationReportsParticipantsWithoutRisksRouteImport.update({
    id: '/reports/participants-without-risks',
    path: '/reports/participants-without-risks',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute =
  AuthenticatedOrganizationReportsParticipantsWithoutGoalsRouteImport.update({
    id: '/reports/participants-without-goals',
    path: '/reports/participants-without-goals',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantUtilisationRoute =
  AuthenticatedOrganizationReportsParticipantUtilisationRouteImport.update({
    id: '/reports/participant-utilisation',
    path: '/reports/participant-utilisation',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantRisksRoute =
  AuthenticatedOrganizationReportsParticipantRisksRouteImport.update({
    id: '/reports/participant-risks',
    path: '/reports/participant-risks',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantRecordsRoute =
  AuthenticatedOrganizationReportsParticipantRecordsRouteImport.update({
    id: '/reports/participant-records',
    path: '/reports/participant-records',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantPlansRoute =
  AuthenticatedOrganizationReportsParticipantPlansRouteImport.update({
    id: '/reports/participant-plans',
    path: '/reports/participant-plans',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantGoalsRoute =
  AuthenticatedOrganizationReportsParticipantGoalsRouteImport.update({
    id: '/reports/participant-goals',
    path: '/reports/participant-goals',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantBirthdaysRoute =
  AuthenticatedOrganizationReportsParticipantBirthdaysRouteImport.update({
    id: '/reports/participant-birthdays',
    path: '/reports/participant-birthdays',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsParticipantAlertsRoute =
  AuthenticatedOrganizationReportsParticipantAlertsRouteImport.update({
    id: '/reports/participant-alerts',
    path: '/reports/participant-alerts',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsOvertimeRoute =
  AuthenticatedOrganizationReportsOvertimeRouteImport.update({
    id: '/reports/overtime',
    path: '/reports/overtime',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsNdiaErrorsRoute =
  AuthenticatedOrganizationReportsNdiaErrorsRouteImport.update({
    id: '/reports/ndia-errors',
    path: '/reports/ndia-errors',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsMyBillablesRoute =
  AuthenticatedOrganizationReportsMyBillablesRouteImport.update({
    id: '/reports/my-billables',
    path: '/reports/my-billables',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsMyBillableHoursRoute =
  AuthenticatedOrganizationReportsMyBillableHoursRouteImport.update({
    id: '/reports/my-billable-hours',
    path: '/reports/my-billable-hours',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsMyBillableChargesRoute =
  AuthenticatedOrganizationReportsMyBillableChargesRouteImport.update({
    id: '/reports/my-billable-charges',
    path: '/reports/my-billable-charges',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsGoalAchievementRoute =
  AuthenticatedOrganizationReportsGoalAchievementRouteImport.update({
    id: '/reports/goal-achievement',
    path: '/reports/goal-achievement',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsExpiredDocumentsRoute =
  AuthenticatedOrganizationReportsExpiredDocumentsRouteImport.update({
    id: '/reports/expired-documents',
    path: '/reports/expired-documents',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsCapacityRoute =
  AuthenticatedOrganizationReportsCapacityRouteImport.update({
    id: '/reports/capacity',
    path: '/reports/capacity',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReportsBillableChargesRoute =
  AuthenticatedOrganizationReportsBillableChargesRouteImport.update({
    id: '/reports/billable-charges',
    path: '/reports/billable-charges',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationReferralsReferralIdRoute =
  AuthenticatedOrganizationReferralsReferralIdRouteImport.update({
    id: '/referrals/$referralId',
    path: '/referrals/$referralId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPoliciesAuditsRoute =
  AuthenticatedOrganizationPoliciesAuditsRouteImport.update({
    id: '/policies/audits',
    path: '/policies/audits',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPayrunsPayRunIdRoute =
  AuthenticatedOrganizationPayrunsPayRunIdRouteImport.update({
    id: '/payruns/$payRunId',
    path: '/payruns/$payRunId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingStaffRoute =
  AuthenticatedOrganizationOnboardingStaffRouteImport.update({
    id: '/onboarding/staff',
    path: '/onboarding/staff',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingRequiredDocumentsRoute =
  AuthenticatedOrganizationOnboardingRequiredDocumentsRouteImport.update({
    id: '/onboarding/required-documents',
    path: '/onboarding/required-documents',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingPreviewRoute =
  AuthenticatedOrganizationOnboardingPreviewRouteImport.update({
    id: '/onboarding/preview',
    path: '/onboarding/preview',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingClientRoute =
  AuthenticatedOrganizationOnboardingClientRouteImport.update({
    id: '/onboarding/client',
    path: '/onboarding/client',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingAdminRoute =
  AuthenticatedOrganizationOnboardingAdminRouteImport.update({
    id: '/onboarding/admin',
    path: '/onboarding/admin',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsReportsRoute =
  AuthenticatedOrganizationNdisStandardsReportsRouteImport.update({
    id: '/ndis-standards/reports',
    path: '/ndis-standards/reports',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsPoliciesRoute =
  AuthenticatedOrganizationNdisStandardsPoliciesRouteImport.update({
    id: '/ndis-standards/policies',
    path: '/ndis-standards/policies',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute =
  AuthenticatedOrganizationNdisStandardsKnowledgeBaseRouteImport.update({
    id: '/ndis-standards/knowledge-base',
    path: '/ndis-standards/knowledge-base',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsIcanRoute =
  AuthenticatedOrganizationNdisStandardsIcanRouteImport.update({
    id: '/ndis-standards/ican',
    path: '/ndis-standards/ican',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsComplianceRoute =
  AuthenticatedOrganizationNdisStandardsComplianceRouteImport.update({
    id: '/ndis-standards/compliance',
    path: '/ndis-standards/compliance',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsAuditsRoute =
  AuthenticatedOrganizationNdisStandardsAuditsRouteImport.update({
    id: '/ndis-standards/audits',
    path: '/ndis-standards/audits',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationMyShiftsShiftIdRoute =
  AuthenticatedOrganizationMyShiftsShiftIdRouteImport.update({
    id: '/my-shifts/$shiftId',
    path: '/my-shifts/$shiftId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute =
  AuthenticatedOrganizationLearnHubshiftTemplateKeyRouteImport.update({
    id: '/learn-hubshift/$templateKey',
    path: '/learn-hubshift/$templateKey',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationInductionInductionIdRoute =
  AuthenticatedOrganizationInductionInductionIdRouteImport.update({
    id: '/induction/$inductionId',
    path: '/induction/$inductionId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsNewRoute =
  AuthenticatedOrganizationIncidentsNewRouteImport.update({
    id: '/incidents/new',
    path: '/incidents/new',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsKnowledgeBaseRoute =
  AuthenticatedOrganizationIncidentsKnowledgeBaseRouteImport.update({
    id: '/incidents/knowledge-base',
    path: '/incidents/knowledge-base',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationHelpCenterTicketIdRoute =
  AuthenticatedOrganizationHelpCenterTicketIdRouteImport.update({
    id: '/help-center/$ticketId',
    path: '/help-center/$ticketId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFormsReviewQueueRoute =
  AuthenticatedOrganizationFormsReviewQueueRouteImport.update({
    id: '/forms/review-queue',
    path: '/forms/review-queue',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFilesViewerRoute =
  AuthenticatedOrganizationFilesViewerRouteImport.update({
    id: '/files/viewer',
    path: '/files/viewer',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationExtractionsExamplesRoute =
  AuthenticatedOrganizationExtractionsExamplesRouteImport.update({
    id: '/extractions/examples',
    path: '/extractions/examples',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationDemoSkeletonRoute =
  AuthenticatedOrganizationDemoSkeletonRouteImport.update({
    id: '/demo/skeleton',
    path: '/demo/skeleton',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceStandardsRoute =
  AuthenticatedOrganizationComplianceStandardsRouteImport.update({
    id: '/compliance/standards',
    path: '/compliance/standards',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceRisksRoute =
  AuthenticatedOrganizationComplianceRisksRouteImport.update({
    id: '/compliance/risks',
    path: '/compliance/risks',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationCompliancePoliciesRoute =
  AuthenticatedOrganizationCompliancePoliciesRouteImport.update({
    id: '/compliance/policies',
    path: '/compliance/policies',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationCompliancePartnersRoute =
  AuthenticatedOrganizationCompliancePartnersRouteImport.update({
    id: '/compliance/partners',
    path: '/compliance/partners',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceHubRoute =
  AuthenticatedOrganizationComplianceHubRouteImport.update({
    id: '/compliance/hub',
    path: '/compliance/hub',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceGapAnalysisRoute =
  AuthenticatedOrganizationComplianceGapAnalysisRouteImport.update({
    id: '/compliance/gap-analysis',
    path: '/compliance/gap-analysis',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceFindingsRoute =
  AuthenticatedOrganizationComplianceFindingsRouteImport.update({
    id: '/compliance/findings',
    path: '/compliance/findings',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceConflictsOfInterestRoute =
  AuthenticatedOrganizationComplianceConflictsOfInterestRouteImport.update({
    id: '/compliance/conflicts-of-interest',
    path: '/compliance/conflicts-of-interest',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceAuditsRoute =
  AuthenticatedOrganizationComplianceAuditsRouteImport.update({
    id: '/compliance/audits',
    path: '/compliance/audits',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationChatsConversationIdRoute =
  AuthenticatedOrganizationChatsConversationIdRouteImport.update({
    id: '/chats/$conversationId',
    path: '/chats/$conversationId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationBudgetCalculatorQuickRoute =
  AuthenticatedOrganizationBudgetCalculatorQuickRouteImport.update({
    id: '/budget-calculator/quick',
    path: '/budget-calculator/quick',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute =
  AuthenticatedOrganizationBudgetCalculatorCalculationIdRouteImport.update({
    id: '/budget-calculator/$calculationId',
    path: '/budget-calculator/$calculationId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationAppsSkeletonDemoRoute =
  AuthenticatedOrganizationAppsSkeletonDemoRouteImport.update({
    id: '/apps/skeleton-demo',
    path: '/apps/skeleton-demo',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const publicSharesCrossOrgTokenRoute =
  publicSharesCrossOrgTokenRouteImport.update({
    id: '/(public)/shares/cross-org/$token',
    path: '/shares/cross-org/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsRouteRoute =
  AuthenticatedOrganizationOrganizationsSettingsRouteRouteImport.update({
    id: '/organizations/settings',
    path: '/organizations/settings',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsReportsRouteRoute =
  AuthenticatedOrganizationIncidentsReportsRouteRouteImport.update({
    id: '/incidents/reports',
    path: '/incidents/reports',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTasksBoardsIndexRoute =
  AuthenticatedOrganizationTasksBoardsIndexRouteImport.update({
    id: '/tasks/boards/',
    path: '/tasks/boards/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTasksTaskIdIndexRoute =
  AuthenticatedOrganizationTasksTaskIdIndexRouteImport.update({
    id: '/tasks/$taskId/',
    path: '/tasks/$taskId/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffTeamsIndexRoute =
  AuthenticatedOrganizationStaffTeamsIndexRouteImport.update({
    id: '/staff/teams/',
    path: '/staff/teams/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdIndexRoute =
  AuthenticatedOrganizationStaffStaffIdIndexRouteImport.update({
    id: '/staff/$staffId/',
    path: '/staff/$staffId/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerTemplatesIndexRoute =
  AuthenticatedOrganizationSchedulerTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerSilIndexRoute =
  AuthenticatedOrganizationSchedulerSilIndexRouteImport.update({
    id: '/sil/',
    path: '/sil/',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationPartnerTrainingIndexRoute =
  AuthenticatedOrganizationPartnerTrainingIndexRouteImport.update({
    id: '/partner/training/',
    path: '/partner/training/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPartnerProvidersIndexRoute =
  AuthenticatedOrganizationPartnerProvidersIndexRouteImport.update({
    id: '/partner/providers/',
    path: '/partner/providers/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPartnerLibraryIndexRoute =
  AuthenticatedOrganizationPartnerLibraryIndexRouteImport.update({
    id: '/partner/library/',
    path: '/partner/library/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsInductionsIndexRoute =
  AuthenticatedOrganizationOrganizationsInductionsIndexRouteImport.update({
    id: '/organizations/inductions/',
    path: '/organizations/inductions/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingManagementIndexRoute =
  AuthenticatedOrganizationOnboardingManagementIndexRouteImport.update({
    id: '/onboarding/management/',
    path: '/onboarding/management/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute =
  AuthenticatedOrganizationNdisStandardsComplaintsIndexRouteImport.update({
    id: '/ndis-standards/complaints/',
    path: '/ndis-standards/complaints/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsReportsIndexRoute =
  AuthenticatedOrganizationIncidentsReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationIncidentsReportsRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsIncidentIdIndexRoute =
  AuthenticatedOrganizationIncidentsIncidentIdIndexRouteImport.update({
    id: '/incidents/$incidentId/',
    path: '/incidents/$incidentId/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute =
  AuthenticatedOrganizationComplianceRestrictivePracticesIndexRouteImport.update(
    {
      id: '/compliance/restrictive-practices/',
      path: '/compliance/restrictive-practices/',
      getParentRoute: () => AuthenticatedOrganizationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationCompliancePolicyPackIndexRoute =
  AuthenticatedOrganizationCompliancePolicyPackIndexRouteImport.update({
    id: '/compliance/policy-pack/',
    path: '/compliance/policy-pack/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceComplaintsIndexRoute =
  AuthenticatedOrganizationComplianceComplaintsIndexRouteImport.update({
    id: '/compliance/complaints/',
    path: '/compliance/complaints/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsTeamsIndexRoute =
  AuthenticatedOrganizationClientsTeamsIndexRouteImport.update({
    id: '/clients/teams/',
    path: '/clients/teams/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdIndexRoute =
  AuthenticatedOrganizationClientsClientIdIndexRouteImport.update({
    id: '/clients/$clientId/',
    path: '/clients/$clientId/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationTasksBoardsBoardIdRoute =
  AuthenticatedOrganizationTasksBoardsBoardIdRouteImport.update({
    id: '/tasks/boards/$boardId',
    path: '/tasks/boards/$boardId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute =
  AuthenticatedOrganizationSupportCoordinationScribeNoteIdRouteImport.update({
    id: '/$noteId',
    path: '/$noteId',
    getParentRoute: () =>
      AuthenticatedOrganizationSupportCoordinationScribeRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdWorkRightsRoute =
  AuthenticatedOrganizationStaffStaffIdWorkRightsRouteImport.update({
    id: '/staff/$staffId/work-rights',
    path: '/staff/$staffId/work-rights',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdRosterRoute =
  AuthenticatedOrganizationStaffStaffIdRosterRouteImport.update({
    id: '/staff/$staffId/roster',
    path: '/staff/$staffId/roster',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdProfileRoute =
  AuthenticatedOrganizationStaffStaffIdProfileRouteImport.update({
    id: '/staff/$staffId/profile',
    path: '/staff/$staffId/profile',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdPerformanceRoute =
  AuthenticatedOrganizationStaffStaffIdPerformanceRouteImport.update({
    id: '/staff/$staffId/performance',
    path: '/staff/$staffId/performance',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdPayrollRoute =
  AuthenticatedOrganizationStaffStaffIdPayrollRouteImport.update({
    id: '/staff/$staffId/payroll',
    path: '/staff/$staffId/payroll',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdOverviewRoute =
  AuthenticatedOrganizationStaffStaffIdOverviewRouteImport.update({
    id: '/staff/$staffId/overview',
    path: '/staff/$staffId/overview',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdEmploymentRoute =
  AuthenticatedOrganizationStaffStaffIdEmploymentRouteImport.update({
    id: '/staff/$staffId/employment',
    path: '/staff/$staffId/employment',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdDocumentsRoute =
  AuthenticatedOrganizationStaffStaffIdDocumentsRouteImport.update({
    id: '/staff/$staffId/documents',
    path: '/staff/$staffId/documents',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationStaffStaffIdClientsRoute =
  AuthenticatedOrganizationStaffStaffIdClientsRouteImport.update({
    id: '/staff/$staffId/clients',
    path: '/staff/$staffId/clients',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationShiftsShiftIdEditRoute =
  AuthenticatedOrganizationShiftsShiftIdEditRouteImport.update({
    id: '/shifts/$shiftId/edit',
    path: '/shifts/$shiftId/edit',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute =
  AuthenticatedOrganizationSchedulerTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationSchedulerSilArrangementIdRoute =
  AuthenticatedOrganizationSchedulerSilArrangementIdRouteImport.update({
    id: '/sil/$arrangementId',
    path: '/sil/$arrangementId',
    getParentRoute: () => AuthenticatedOrganizationSchedulerRouteRoute,
  } as any)
const AuthenticatedOrganizationPartnerTrainingTemplateIdRoute =
  AuthenticatedOrganizationPartnerTrainingTemplateIdRouteImport.update({
    id: '/partner/training/$templateId',
    path: '/partner/training/$templateId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute =
  AuthenticatedOrganizationPartnerProvidersProviderOrgIdRouteImport.update({
    id: '/partner/providers/$providerOrgId',
    path: '/partner/providers/$providerOrgId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsTravelRoute =
  AuthenticatedOrganizationOrganizationsSettingsTravelRouteImport.update({
    id: '/travel',
    path: '/travel',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute =
  AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRouteImport.update({
    id: '/terms-privacy',
    path: '/terms-privacy',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute =
  AuthenticatedOrganizationOrganizationsSettingsServiceTypesRouteImport.update({
    id: '/service-types',
    path: '/service-types',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsRolesRoute =
  AuthenticatedOrganizationOrganizationsSettingsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute =
  AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRouteImport.update(
    {
      id: '/reports-configuration',
      path: '/reports-configuration',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsRegionsRoute =
  AuthenticatedOrganizationOrganizationsSettingsRegionsRouteImport.update({
    id: '/regions',
    path: '/regions',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute =
  AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRouteImport.update(
    {
      id: '/referral-intake',
      path: '/referral-intake',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute =
  AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRouteImport.update(
    {
      id: '/public-holidays',
      path: '/public-holidays',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsProfileRoute =
  AuthenticatedOrganizationOrganizationsSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute =
  AuthenticatedOrganizationOrganizationsSettingsPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute =
  AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRouteImport.update(
    {
      id: '/permission-matrix',
      path: '/permission-matrix',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsPayrollRoute =
  AuthenticatedOrganizationOrganizationsSettingsPayrollRouteImport.update({
    id: '/payroll',
    path: '/payroll',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute =
  AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRouteImport.update(
    {
      id: '/notifications-config',
      path: '/notifications-config',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsMembersRoute =
  AuthenticatedOrganizationOrganizationsSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute =
  AuthenticatedOrganizationOrganizationsSettingsLineItemsRouteImport.update({
    id: '/line-items',
    path: '/line-items',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute =
  AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRouteImport.update(
    {
      id: '/invoice-templates',
      path: '/invoice-templates',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute =
  AuthenticatedOrganizationOrganizationsSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsInductionRoute =
  AuthenticatedOrganizationOrganizationsSettingsInductionRouteImport.update({
    id: '/induction',
    path: '/induction',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute =
  AuthenticatedOrganizationOrganizationsSettingsGoLiveRouteImport.update({
    id: '/go-live',
    path: '/go-live',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute =
  AuthenticatedOrganizationOrganizationsSettingsFacilitiesRouteImport.update({
    id: '/facilities',
    path: '/facilities',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute =
  AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRouteImport.update(
    {
      id: '/document-types',
      path: '/document-types',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute =
  AuthenticatedOrganizationOrganizationsSettingsDataMigrationRouteImport.update(
    {
      id: '/data-migration',
      path: '/data-migration',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute =
  AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRouteImport.update(
    {
      id: '/compliance-profile',
      path: '/compliance-profile',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsClockInRoute =
  AuthenticatedOrganizationOrganizationsSettingsClockInRouteImport.update({
    id: '/clock-in',
    path: '/clock-in',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute =
  AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRouteImport.update(
    {
      id: '/client-document-types',
      path: '/client-document-types',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute =
  AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRouteImport.update(
    {
      id: '/cancellation-policy',
      path: '/cancellation-policy',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute =
  AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRouteImport.update(
    {
      id: '/award-xero-mapping',
      path: '/award-xero-mapping',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute =
  AuthenticatedOrganizationOrganizationsSettingsAwardRatesRouteImport.update({
    id: '/award-rates',
    path: '/award-rates',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute =
  AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRouteImport.update(
    {
      id: '/assistant-knowledge',
      path: '/assistant-knowledge',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute =
  AuthenticatedOrganizationOrganizationsSettingsAiSettingsRouteImport.update({
    id: '/ai-settings',
    path: '/ai-settings',
    getParentRoute: () =>
      AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute =
  AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRouteImport.update(
    {
      id: '/agreement-sections',
      path: '/agreement-sections',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOnboardingManagementPipelineRoute =
  AuthenticatedOrganizationOnboardingManagementPipelineRouteImport.update({
    id: '/onboarding/management/pipeline',
    path: '/onboarding/management/pipeline',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOnboardingManagementMemberIdRoute =
  AuthenticatedOrganizationOnboardingManagementMemberIdRouteImport.update({
    id: '/onboarding/management/$memberId',
    path: '/onboarding/management/$memberId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute =
  AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRouteImport.update(
    {
      id: '/ndis-standards/complaints/$complaintId',
      path: '/ndis-standards/complaints/$complaintId',
      getParentRoute: () => AuthenticatedOrganizationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute =
  AuthenticatedOrganizationIncidentsReportsTrendAnalysisRouteImport.update({
    id: '/trend-analysis',
    path: '/trend-analysis',
    getParentRoute: () => AuthenticatedOrganizationIncidentsReportsRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute =
  AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRouteImport.update(
    {
      id: '/operational-performance',
      path: '/operational-performance',
      getParentRoute: () => AuthenticatedOrganizationIncidentsReportsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute =
  AuthenticatedOrganizationIncidentsReportsIncidentMappingRouteImport.update({
    id: '/incident-mapping',
    path: '/incident-mapping',
    getParentRoute: () => AuthenticatedOrganizationIncidentsReportsRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute =
  AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRouteImport.update({
    id: '/executive-summary',
    path: '/executive-summary',
    getParentRoute: () => AuthenticatedOrganizationIncidentsReportsRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsReportsComplianceRoute =
  AuthenticatedOrganizationIncidentsReportsComplianceRouteImport.update({
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AuthenticatedOrganizationIncidentsReportsRouteRoute,
  } as any)
const AuthenticatedOrganizationIncidentsIncidentIdEditRoute =
  AuthenticatedOrganizationIncidentsIncidentIdEditRouteImport.update({
    id: '/incidents/$incidentId/edit',
    path: '/incidents/$incidentId/edit',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFormsFormIdPreviewRoute =
  AuthenticatedOrganizationFormsFormIdPreviewRouteImport.update({
    id: '/forms/$formId/preview',
    path: '/forms/$formId/preview',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFormsFormIdFillRoute =
  AuthenticatedOrganizationFormsFormIdFillRouteImport.update({
    id: '/forms/$formId/fill',
    path: '/forms/$formId/fill',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationFormsFormIdEditRoute =
  AuthenticatedOrganizationFormsFormIdEditRouteImport.update({
    id: '/forms/$formId/edit',
    path: '/forms/$formId/edit',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceRisksSettingsRoute =
  AuthenticatedOrganizationComplianceRisksSettingsRouteImport.update({
    id: '/compliance/risks_/settings',
    path: '/compliance/risks/settings',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute =
  AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRouteImport.update(
    {
      id: '/compliance/restrictive-practices/monthly-report',
      path: '/compliance/restrictive-practices/monthly-report',
      getParentRoute: () => AuthenticatedOrganizationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationCompliancePolicyPackRunIdRoute =
  AuthenticatedOrganizationCompliancePolicyPackRunIdRouteImport.update({
    id: '/compliance/policy-pack/$runId',
    path: '/compliance/policy-pack/$runId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute =
  AuthenticatedOrganizationCompliancePoliciesPolicyIdRouteImport.update({
    id: '/compliance/policies_/$policyId',
    path: '/compliance/policies/$policyId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute =
  AuthenticatedOrganizationComplianceComplaintsComplaintIdRouteImport.update({
    id: '/compliance/complaints/$complaintId',
    path: '/compliance/complaints/$complaintId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationComplianceAuditsAuditIdRoute =
  AuthenticatedOrganizationComplianceAuditsAuditIdRouteImport.update({
    id: '/compliance/audits_/$auditId',
    path: '/compliance/audits/$auditId',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdTransitionsRoute =
  AuthenticatedOrganizationClientsClientIdTransitionsRouteImport.update({
    id: '/clients/$clientId/transitions',
    path: '/clients/$clientId/transitions',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdSupportPlanRoute =
  AuthenticatedOrganizationClientsClientIdSupportPlanRouteImport.update({
    id: '/clients/$clientId/support-plan',
    path: '/clients/$clientId/support-plan',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute =
  AuthenticatedOrganizationClientsClientIdSupportCoordinationRouteImport.update(
    {
      id: '/clients/$clientId/support-coordination',
      path: '/clients/$clientId/support-coordination',
      getParentRoute: () => AuthenticatedOrganizationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationClientsClientIdStakeholdersRoute =
  AuthenticatedOrganizationClientsClientIdStakeholdersRouteImport.update({
    id: '/clients/$clientId/stakeholders',
    path: '/clients/$clientId/stakeholders',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdServiceAgreementRoute =
  AuthenticatedOrganizationClientsClientIdServiceAgreementRouteImport.update({
    id: '/clients/$clientId/service-agreement',
    path: '/clients/$clientId/service-agreement',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdSchedulesRoute =
  AuthenticatedOrganizationClientsClientIdSchedulesRouteImport.update({
    id: '/clients/$clientId/schedules',
    path: '/clients/$clientId/schedules',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdRiskProfileRoute =
  AuthenticatedOrganizationClientsClientIdRiskProfileRouteImport.update({
    id: '/clients/$clientId/risk-profile',
    path: '/clients/$clientId/risk-profile',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdProfileRoute =
  AuthenticatedOrganizationClientsClientIdProfileRouteImport.update({
    id: '/clients/$clientId/profile',
    path: '/clients/$clientId/profile',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdOverviewRoute =
  AuthenticatedOrganizationClientsClientIdOverviewRouteImport.update({
    id: '/clients/$clientId/overview',
    path: '/clients/$clientId/overview',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdOnboardingRoute =
  AuthenticatedOrganizationClientsClientIdOnboardingRouteImport.update({
    id: '/clients/$clientId/onboarding',
    path: '/clients/$clientId/onboarding',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdNotesRoute =
  AuthenticatedOrganizationClientsClientIdNotesRouteImport.update({
    id: '/clients/$clientId/notes',
    path: '/clients/$clientId/notes',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdMedicationsRoute =
  AuthenticatedOrganizationClientsClientIdMedicationsRouteImport.update({
    id: '/clients/$clientId/medications',
    path: '/clients/$clientId/medications',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdIntakeRoute =
  AuthenticatedOrganizationClientsClientIdIntakeRouteImport.update({
    id: '/clients/$clientId/intake',
    path: '/clients/$clientId/intake',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdIncidentsRoute =
  AuthenticatedOrganizationClientsClientIdIncidentsRouteImport.update({
    id: '/clients/$clientId/incidents',
    path: '/clients/$clientId/incidents',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdIcanRoute =
  AuthenticatedOrganizationClientsClientIdIcanRouteImport.update({
    id: '/clients/$clientId/ican',
    path: '/clients/$clientId/ican',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdGoalsRoute =
  AuthenticatedOrganizationClientsClientIdGoalsRouteImport.update({
    id: '/clients/$clientId/goals',
    path: '/clients/$clientId/goals',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdFundingRoute =
  AuthenticatedOrganizationClientsClientIdFundingRouteImport.update({
    id: '/clients/$clientId/funding',
    path: '/clients/$clientId/funding',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdEvidencePacksRoute =
  AuthenticatedOrganizationClientsClientIdEvidencePacksRouteImport.update({
    id: '/clients/$clientId/evidence-packs',
    path: '/clients/$clientId/evidence-packs',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdDocumentsRoute =
  AuthenticatedOrganizationClientsClientIdDocumentsRouteImport.update({
    id: '/clients/$clientId/documents',
    path: '/clients/$clientId/documents',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdCarePlanRoute =
  AuthenticatedOrganizationClientsClientIdCarePlanRouteImport.update({
    id: '/clients/$clientId/care-plan',
    path: '/clients/$clientId/care-plan',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute =
  AuthenticatedOrganizationClientsClientIdBehaviourSupportRouteImport.update({
    id: '/clients/$clientId/behaviour-support',
    path: '/clients/$clientId/behaviour-support',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdAuditTrailRoute =
  AuthenticatedOrganizationClientsClientIdAuditTrailRouteImport.update({
    id: '/clients/$clientId/audit-trail',
    path: '/clients/$clientId/audit-trail',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationClientsClientIdAppointmentsRoute =
  AuthenticatedOrganizationClientsClientIdAppointmentsRouteImport.update({
    id: '/clients/$clientId/appointments',
    path: '/clients/$clientId/appointments',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute =
  AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRouteImport.update(
    {
      id: '/training-programs/',
      path: '/training-programs/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute =
  AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRouteImport.update(
    {
      id: '/progress-note-templates/',
      path: '/progress-note-templates/',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute =
  AuthenticatedOrganizationFormsFormIdSubmissionsIndexRouteImport.update({
    id: '/forms/$formId/submissions/',
    path: '/forms/$formId/submissions/',
    getParentRoute: () => AuthenticatedOrganizationRouteRoute,
  } as any)
const AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute =
  AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRouteImport.update(
    {
      id: '/training-programs/$programId',
      path: '/training-programs/$programId',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute =
  AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRouteImport.update(
    {
      id: '/progress-note-templates/$templateId',
      path: '/progress-note-templates/$templateId',
      getParentRoute: () =>
        AuthenticatedOrganizationOrganizationsSettingsRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute =
  AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRouteImport.update(
    {
      id: '/forms/$formId/submissions/$submissionId',
      path: '/forms/$formId/submissions/$submissionId',
      getParentRoute: () => AuthenticatedOrganizationRouteRoute,
    } as any,
  )
const AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute =
  AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRouteImport.update(
    {
      id: '/compliance/policies_/$policyId_/redraft/$proposalId',
      path: '/compliance/policies/$policyId/redraft/$proposalId',
      getParentRoute: () => AuthenticatedOrganizationRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/farewell': typeof FarewellRoute
  '/otp': typeof OtpRoute
  '/setup-passkey': typeof SetupPasskeyRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/change-password': typeof authChangePasswordRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/two-factor': typeof authTwoFactorRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/force-change-password': typeof AuthenticatedForceChangePasswordRoute
  '/get-the-app': typeof AuthenticatedGetTheAppRoute
  '/accept-invitation/$invitationId': typeof AcceptInvitationInvitationIdRoute
  '/scheduler': typeof AuthenticatedOrganizationSchedulerRouteRouteWithChildren
  '/support-coordination': typeof AuthenticatedOrganizationSupportCoordinationRouteRouteWithChildren
  '/care-plan-share/$token': typeof publicCarePlanShareTokenRoute
  '/dev/chat-preview': typeof publicDevChatPreviewRoute
  '/dev/mascot': typeof publicDevMascotRoute
  '/impersonate/$token': typeof publicImpersonateTokenRoute
  '/migration-portal/$token': typeof publicMigrationPortalTokenRoute
  '/onboarding-portal/$token': typeof publicOnboardingPortalTokenRoute
  '/shared-agreement/$token': typeof publicSharedAgreementTokenRoute
  '/shared-document/$token': typeof publicSharedDocumentTokenRoute
  '/sign-agreement/$token': typeof publicSignAgreementTokenRoute
  '/sign/$token': typeof publicSignTokenRoute
  '/sil-roc-share/$token': typeof publicSilRocShareTokenRoute
  '/support-plan-share/$token': typeof publicSupportPlanShareTokenRoute
  '/ai-gateway': typeof AuthenticatedOrganizationAiGatewayRoute
  '/cross-org': typeof AuthenticatedOrganizationCrossOrgRoute
  '/signatures': typeof AuthenticatedOrganizationSignaturesRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/communication': typeof AuthenticatedSettingsCommunicationRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/': typeof AuthenticatedOrganizationIndexRoute
  '/create-organization': typeof AuthenticatedCreateOrganizationIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/incidents/reports': typeof AuthenticatedOrganizationIncidentsReportsRouteRouteWithChildren
  '/organizations/settings': typeof AuthenticatedOrganizationOrganizationsSettingsRouteRouteWithChildren
  '/shares/cross-org/$token': typeof publicSharesCrossOrgTokenRoute
  '/apps/skeleton-demo': typeof AuthenticatedOrganizationAppsSkeletonDemoRoute
  '/budget-calculator/$calculationId': typeof AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute
  '/budget-calculator/quick': typeof AuthenticatedOrganizationBudgetCalculatorQuickRoute
  '/chats/$conversationId': typeof AuthenticatedOrganizationChatsConversationIdRoute
  '/compliance/audits': typeof AuthenticatedOrganizationComplianceAuditsRoute
  '/compliance/conflicts-of-interest': typeof AuthenticatedOrganizationComplianceConflictsOfInterestRoute
  '/compliance/findings': typeof AuthenticatedOrganizationComplianceFindingsRoute
  '/compliance/gap-analysis': typeof AuthenticatedOrganizationComplianceGapAnalysisRoute
  '/compliance/hub': typeof AuthenticatedOrganizationComplianceHubRoute
  '/compliance/partners': typeof AuthenticatedOrganizationCompliancePartnersRoute
  '/compliance/policies': typeof AuthenticatedOrganizationCompliancePoliciesRoute
  '/compliance/risks': typeof AuthenticatedOrganizationComplianceRisksRoute
  '/compliance/standards': typeof AuthenticatedOrganizationComplianceStandardsRoute
  '/demo/skeleton': typeof AuthenticatedOrganizationDemoSkeletonRoute
  '/extractions/examples': typeof AuthenticatedOrganizationExtractionsExamplesRoute
  '/files/viewer': typeof AuthenticatedOrganizationFilesViewerRoute
  '/forms/review-queue': typeof AuthenticatedOrganizationFormsReviewQueueRoute
  '/help-center/$ticketId': typeof AuthenticatedOrganizationHelpCenterTicketIdRoute
  '/incidents/knowledge-base': typeof AuthenticatedOrganizationIncidentsKnowledgeBaseRoute
  '/incidents/new': typeof AuthenticatedOrganizationIncidentsNewRoute
  '/induction/$inductionId': typeof AuthenticatedOrganizationInductionInductionIdRoute
  '/learn-hubshift/$templateKey': typeof AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute
  '/my-shifts/$shiftId': typeof AuthenticatedOrganizationMyShiftsShiftIdRoute
  '/ndis-standards/audits': typeof AuthenticatedOrganizationNdisStandardsAuditsRoute
  '/ndis-standards/compliance': typeof AuthenticatedOrganizationNdisStandardsComplianceRoute
  '/ndis-standards/ican': typeof AuthenticatedOrganizationNdisStandardsIcanRoute
  '/ndis-standards/knowledge-base': typeof AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute
  '/ndis-standards/policies': typeof AuthenticatedOrganizationNdisStandardsPoliciesRoute
  '/ndis-standards/reports': typeof AuthenticatedOrganizationNdisStandardsReportsRoute
  '/onboarding/admin': typeof AuthenticatedOrganizationOnboardingAdminRoute
  '/onboarding/client': typeof AuthenticatedOrganizationOnboardingClientRoute
  '/onboarding/preview': typeof AuthenticatedOrganizationOnboardingPreviewRoute
  '/onboarding/required-documents': typeof AuthenticatedOrganizationOnboardingRequiredDocumentsRoute
  '/onboarding/staff': typeof AuthenticatedOrganizationOnboardingStaffRoute
  '/payruns/$payRunId': typeof AuthenticatedOrganizationPayrunsPayRunIdRoute
  '/policies/audits': typeof AuthenticatedOrganizationPoliciesAuditsRoute
  '/referrals/$referralId': typeof AuthenticatedOrganizationReferralsReferralIdRoute
  '/reports/billable-charges': typeof AuthenticatedOrganizationReportsBillableChargesRoute
  '/reports/capacity': typeof AuthenticatedOrganizationReportsCapacityRoute
  '/reports/expired-documents': typeof AuthenticatedOrganizationReportsExpiredDocumentsRoute
  '/reports/goal-achievement': typeof AuthenticatedOrganizationReportsGoalAchievementRoute
  '/reports/my-billable-charges': typeof AuthenticatedOrganizationReportsMyBillableChargesRoute
  '/reports/my-billable-hours': typeof AuthenticatedOrganizationReportsMyBillableHoursRoute
  '/reports/my-billables': typeof AuthenticatedOrganizationReportsMyBillablesRoute
  '/reports/ndia-errors': typeof AuthenticatedOrganizationReportsNdiaErrorsRoute
  '/reports/overtime': typeof AuthenticatedOrganizationReportsOvertimeRoute
  '/reports/participant-alerts': typeof AuthenticatedOrganizationReportsParticipantAlertsRoute
  '/reports/participant-birthdays': typeof AuthenticatedOrganizationReportsParticipantBirthdaysRoute
  '/reports/participant-goals': typeof AuthenticatedOrganizationReportsParticipantGoalsRoute
  '/reports/participant-plans': typeof AuthenticatedOrganizationReportsParticipantPlansRoute
  '/reports/participant-records': typeof AuthenticatedOrganizationReportsParticipantRecordsRoute
  '/reports/participant-risks': typeof AuthenticatedOrganizationReportsParticipantRisksRoute
  '/reports/participant-utilisation': typeof AuthenticatedOrganizationReportsParticipantUtilisationRoute
  '/reports/participants-without-goals': typeof AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute
  '/reports/participants-without-risks': typeof AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute
  '/reports/preview': typeof AuthenticatedOrganizationReportsPreviewRoute
  '/reports/public-holiday-supports': typeof AuthenticatedOrganizationReportsPublicHolidaySupportsRoute
  '/reports/recurring-shifts-expiring': typeof AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute
  '/reports/service-delivery': typeof AuthenticatedOrganizationReportsServiceDeliveryRoute
  '/reports/shift-clashes': typeof AuthenticatedOrganizationReportsShiftClashesRoute
  '/reports/shift-tasks': typeof AuthenticatedOrganizationReportsShiftTasksRoute
  '/reports/shift-variance': typeof AuthenticatedOrganizationReportsShiftVarianceRoute
  '/reports/shifts': typeof AuthenticatedOrganizationReportsShiftsRoute
  '/reports/staff-utilisation': typeof AuthenticatedOrganizationReportsStaffUtilisationRoute
  '/reports/support-cancellations': typeof AuthenticatedOrganizationReportsSupportCancellationsRoute
  '/reports/support-notes': typeof AuthenticatedOrganizationReportsSupportNotesRoute
  '/reports/supports': typeof AuthenticatedOrganizationReportsSupportsRoute
  '/reports/supports-without-notes': typeof AuthenticatedOrganizationReportsSupportsWithoutNotesRoute
  '/reports/tasks': typeof AuthenticatedOrganizationReportsTasksRoute
  '/reports/tasks-without-notes': typeof AuthenticatedOrganizationReportsTasksWithoutNotesRoute
  '/reports/team-billable-hours': typeof AuthenticatedOrganizationReportsTeamBillableHoursRoute
  '/reports/team-billables': typeof AuthenticatedOrganizationReportsTeamBillablesRoute
  '/reports/user-availability': typeof AuthenticatedOrganizationReportsUserAvailabilityRoute
  '/reports/user-records': typeof AuthenticatedOrganizationReportsUserRecordsRoute
  '/reports/voided-charges': typeof AuthenticatedOrganizationReportsVoidedChargesRoute
  '/scheduler/alerts': typeof AuthenticatedOrganizationSchedulerAlertsRoute
  '/scheduler/all-shifts': typeof AuthenticatedOrganizationSchedulerAllShiftsRoute
  '/scheduler/availability-requests': typeof AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute
  '/scheduler/clashes': typeof AuthenticatedOrganizationSchedulerClashesRoute
  '/scheduler/overview': typeof AuthenticatedOrganizationSchedulerOverviewRoute
  '/scheduler/post-shift-review': typeof AuthenticatedOrganizationSchedulerPostShiftReviewRoute
  '/scheduler/progress-notes': typeof AuthenticatedOrganizationSchedulerProgressNotesRoute
  '/scheduler/review-queue': typeof AuthenticatedOrganizationSchedulerReviewQueueRoute
  '/scheduler/shift-requests': typeof AuthenticatedOrganizationSchedulerShiftRequestsRoute
  '/shifts/new': typeof AuthenticatedOrganizationShiftsNewRoute
  '/staff/compliance': typeof AuthenticatedOrganizationStaffComplianceRoute
  '/support-coordination/billing': typeof AuthenticatedOrganizationSupportCoordinationBillingRoute
  '/support-coordination/budget': typeof AuthenticatedOrganizationSupportCoordinationBudgetRoute
  '/support-coordination/case-notes': typeof AuthenticatedOrganizationSupportCoordinationCaseNotesRoute
  '/support-coordination/compliance': typeof AuthenticatedOrganizationSupportCoordinationComplianceRoute
  '/support-coordination/emails': typeof AuthenticatedOrganizationSupportCoordinationEmailsRoute
  '/support-coordination/mailbox-settings': typeof AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute
  '/support-coordination/next-best-actions': typeof AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute
  '/support-coordination/notebook': typeof AuthenticatedOrganizationSupportCoordinationNotebookRoute
  '/support-coordination/planner': typeof AuthenticatedOrganizationSupportCoordinationPlannerRoute
  '/support-coordination/registers': typeof AuthenticatedOrganizationSupportCoordinationRegistersRoute
  '/support-coordination/reports': typeof AuthenticatedOrganizationSupportCoordinationReportsRoute
  '/support-coordination/scribe': typeof AuthenticatedOrganizationSupportCoordinationScribeRouteWithChildren
  '/support-coordination/telephony': typeof AuthenticatedOrganizationSupportCoordinationTelephonyRoute
  '/support-coordination/time-entries': typeof AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute
  '/support-plan-sign/$shareId': typeof AuthenticatedOrganizationSupportPlanSignShareIdRoute
  '/training/$programId': typeof AuthenticatedOrganizationTrainingProgramIdRoute
  '/workflows/$workflowId': typeof AuthenticatedOrganizationWorkflowsWorkflowIdRoute
  '/apps': typeof AuthenticatedOrganizationAppsIndexRoute
  '/audit-logs': typeof AuthenticatedOrganizationAuditLogsIndexRoute
  '/billing': typeof AuthenticatedOrganizationBillingIndexRoute
  '/budget-calculator': typeof AuthenticatedOrganizationBudgetCalculatorIndexRoute
  '/case-notes': typeof AuthenticatedOrganizationCaseNotesIndexRoute
  '/caseload': typeof AuthenticatedOrganizationCaseloadIndexRoute
  '/chats': typeof AuthenticatedOrganizationChatsIndexRoute
  '/claims': typeof AuthenticatedOrganizationClaimsIndexRoute
  '/clients': typeof AuthenticatedOrganizationClientsIndexRoute
  '/compliance': typeof AuthenticatedOrganizationComplianceIndexRoute
  '/documents': typeof AuthenticatedOrganizationDocumentsIndexRoute
  '/expenses': typeof AuthenticatedOrganizationExpensesIndexRoute
  '/extractions': typeof AuthenticatedOrganizationExtractionsIndexRoute
  '/facilities': typeof AuthenticatedOrganizationFacilitiesIndexRoute
  '/forms': typeof AuthenticatedOrganizationFormsIndexRoute
  '/help-center': typeof AuthenticatedOrganizationHelpCenterIndexRoute
  '/incidents': typeof AuthenticatedOrganizationIncidentsIndexRoute
  '/invoices': typeof AuthenticatedOrganizationInvoicesIndexRoute
  '/learn-hubshift': typeof AuthenticatedOrganizationLearnHubshiftIndexRoute
  '/leave': typeof AuthenticatedOrganizationLeaveIndexRoute
  '/my-agreements': typeof AuthenticatedOrganizationMyAgreementsIndexRoute
  '/my-appointments': typeof AuthenticatedOrganizationMyAppointmentsIndexRoute
  '/my-availability': typeof AuthenticatedOrganizationMyAvailabilityIndexRoute
  '/my-complaints': typeof AuthenticatedOrganizationMyComplaintsIndexRoute
  '/my-consent': typeof AuthenticatedOrganizationMyConsentIndexRoute
  '/my-declarations': typeof AuthenticatedOrganizationMyDeclarationsIndexRoute
  '/my-forms': typeof AuthenticatedOrganizationMyFormsIndexRoute
  '/my-goals': typeof AuthenticatedOrganizationMyGoalsIndexRoute
  '/my-inbox': typeof AuthenticatedOrganizationMyInboxIndexRoute
  '/my-incident-reports': typeof AuthenticatedOrganizationMyIncidentReportsIndexRoute
  '/my-incidents': typeof AuthenticatedOrganizationMyIncidentsIndexRoute
  '/my-invoices': typeof AuthenticatedOrganizationMyInvoicesIndexRoute
  '/my-onboarding': typeof AuthenticatedOrganizationMyOnboardingIndexRoute
  '/my-participants': typeof AuthenticatedOrganizationMyParticipantsIndexRoute
  '/my-people': typeof AuthenticatedOrganizationMyPeopleIndexRoute
  '/my-plan': typeof AuthenticatedOrganizationMyPlanIndexRoute
  '/my-shifts': typeof AuthenticatedOrganizationMyShiftsIndexRoute
  '/my-support-team': typeof AuthenticatedOrganizationMySupportTeamIndexRoute
  '/my-timesheets': typeof AuthenticatedOrganizationMyTimesheetsIndexRoute
  '/ndis-standards': typeof AuthenticatedOrganizationNdisStandardsIndexRoute
  '/notes': typeof AuthenticatedOrganizationNotesIndexRoute
  '/notifications': typeof AuthenticatedOrganizationNotificationsIndexRoute
  '/offboarding': typeof AuthenticatedOrganizationOffboardingIndexRoute
  '/payroll': typeof AuthenticatedOrganizationPayrollIndexRoute
  '/policies': typeof AuthenticatedOrganizationPoliciesIndexRoute
  '/public-holidays': typeof AuthenticatedOrganizationPublicHolidaysIndexRoute
  '/reconciliation': typeof AuthenticatedOrganizationReconciliationIndexRoute
  '/referrals': typeof AuthenticatedOrganizationReferralsIndexRoute
  '/reports': typeof AuthenticatedOrganizationReportsIndexRoute
  '/roster': typeof AuthenticatedOrganizationRosterIndexRoute
  '/scheduler/': typeof AuthenticatedOrganizationSchedulerIndexRoute
  '/staff': typeof AuthenticatedOrganizationStaffIndexRoute
  '/support-coordination/': typeof AuthenticatedOrganizationSupportCoordinationIndexRoute
  '/tasks': typeof AuthenticatedOrganizationTasksIndexRoute
  '/timesheets': typeof AuthenticatedOrganizationTimesheetsIndexRoute
  '/training': typeof AuthenticatedOrganizationTrainingIndexRoute
  '/upgrade': typeof AuthenticatedOrganizationUpgradeIndexRoute
  '/users': typeof AuthenticatedOrganizationUsersIndexRoute
  '/workflows': typeof AuthenticatedOrganizationWorkflowsIndexRoute
  '/clients/$clientId/appointments': typeof AuthenticatedOrganizationClientsClientIdAppointmentsRoute
  '/clients/$clientId/audit-trail': typeof AuthenticatedOrganizationClientsClientIdAuditTrailRoute
  '/clients/$clientId/behaviour-support': typeof AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute
  '/clients/$clientId/care-plan': typeof AuthenticatedOrganizationClientsClientIdCarePlanRoute
  '/clients/$clientId/documents': typeof AuthenticatedOrganizationClientsClientIdDocumentsRoute
  '/clients/$clientId/evidence-packs': typeof AuthenticatedOrganizationClientsClientIdEvidencePacksRoute
  '/clients/$clientId/funding': typeof AuthenticatedOrganizationClientsClientIdFundingRoute
  '/clients/$clientId/goals': typeof AuthenticatedOrganizationClientsClientIdGoalsRoute
  '/clients/$clientId/ican': typeof AuthenticatedOrganizationClientsClientIdIcanRoute
  '/clients/$clientId/incidents': typeof AuthenticatedOrganizationClientsClientIdIncidentsRoute
  '/clients/$clientId/intake': typeof AuthenticatedOrganizationClientsClientIdIntakeRoute
  '/clients/$clientId/medications': typeof AuthenticatedOrganizationClientsClientIdMedicationsRoute
  '/clients/$clientId/notes': typeof AuthenticatedOrganizationClientsClientIdNotesRoute
  '/clients/$clientId/onboarding': typeof AuthenticatedOrganizationClientsClientIdOnboardingRoute
  '/clients/$clientId/overview': typeof AuthenticatedOrganizationClientsClientIdOverviewRoute
  '/clients/$clientId/profile': typeof AuthenticatedOrganizationClientsClientIdProfileRoute
  '/clients/$clientId/risk-profile': typeof AuthenticatedOrganizationClientsClientIdRiskProfileRoute
  '/clients/$clientId/schedules': typeof AuthenticatedOrganizationClientsClientIdSchedulesRoute
  '/clients/$clientId/service-agreement': typeof AuthenticatedOrganizationClientsClientIdServiceAgreementRoute
  '/clients/$clientId/stakeholders': typeof AuthenticatedOrganizationClientsClientIdStakeholdersRoute
  '/clients/$clientId/support-coordination': typeof AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute
  '/clients/$clientId/support-plan': typeof AuthenticatedOrganizationClientsClientIdSupportPlanRoute
  '/clients/$clientId/transitions': typeof AuthenticatedOrganizationClientsClientIdTransitionsRoute
  '/compliance/audits/$auditId': typeof AuthenticatedOrganizationComplianceAuditsAuditIdRoute
  '/compliance/complaints/$complaintId': typeof AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute
  '/compliance/policies/$policyId': typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute
  '/compliance/policy-pack/$runId': typeof AuthenticatedOrganizationCompliancePolicyPackRunIdRoute
  '/compliance/restrictive-practices/monthly-report': typeof AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute
  '/compliance/risks/settings': typeof AuthenticatedOrganizationComplianceRisksSettingsRoute
  '/forms/$formId/edit': typeof AuthenticatedOrganizationFormsFormIdEditRoute
  '/forms/$formId/fill': typeof AuthenticatedOrganizationFormsFormIdFillRoute
  '/forms/$formId/preview': typeof AuthenticatedOrganizationFormsFormIdPreviewRoute
  '/incidents/$incidentId/edit': typeof AuthenticatedOrganizationIncidentsIncidentIdEditRoute
  '/incidents/reports/compliance': typeof AuthenticatedOrganizationIncidentsReportsComplianceRoute
  '/incidents/reports/executive-summary': typeof AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute
  '/incidents/reports/incident-mapping': typeof AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute
  '/incidents/reports/operational-performance': typeof AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute
  '/incidents/reports/trend-analysis': typeof AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute
  '/ndis-standards/complaints/$complaintId': typeof AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute
  '/onboarding/management/$memberId': typeof AuthenticatedOrganizationOnboardingManagementMemberIdRoute
  '/onboarding/management/pipeline': typeof AuthenticatedOrganizationOnboardingManagementPipelineRoute
  '/organizations/settings/agreement-sections': typeof AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute
  '/organizations/settings/ai-settings': typeof AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute
  '/organizations/settings/assistant-knowledge': typeof AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute
  '/organizations/settings/award-rates': typeof AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute
  '/organizations/settings/award-xero-mapping': typeof AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute
  '/organizations/settings/cancellation-policy': typeof AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute
  '/organizations/settings/client-document-types': typeof AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute
  '/organizations/settings/clock-in': typeof AuthenticatedOrganizationOrganizationsSettingsClockInRoute
  '/organizations/settings/compliance-profile': typeof AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute
  '/organizations/settings/data-migration': typeof AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute
  '/organizations/settings/document-types': typeof AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute
  '/organizations/settings/facilities': typeof AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute
  '/organizations/settings/go-live': typeof AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute
  '/organizations/settings/induction': typeof AuthenticatedOrganizationOrganizationsSettingsInductionRoute
  '/organizations/settings/integrations': typeof AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute
  '/organizations/settings/invoice-templates': typeof AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute
  '/organizations/settings/line-items': typeof AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute
  '/organizations/settings/members': typeof AuthenticatedOrganizationOrganizationsSettingsMembersRoute
  '/organizations/settings/notifications-config': typeof AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute
  '/organizations/settings/payroll': typeof AuthenticatedOrganizationOrganizationsSettingsPayrollRoute
  '/organizations/settings/permission-matrix': typeof AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute
  '/organizations/settings/privacy': typeof AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute
  '/organizations/settings/profile': typeof AuthenticatedOrganizationOrganizationsSettingsProfileRoute
  '/organizations/settings/public-holidays': typeof AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute
  '/organizations/settings/referral-intake': typeof AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute
  '/organizations/settings/regions': typeof AuthenticatedOrganizationOrganizationsSettingsRegionsRoute
  '/organizations/settings/reports-configuration': typeof AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute
  '/organizations/settings/roles': typeof AuthenticatedOrganizationOrganizationsSettingsRolesRoute
  '/organizations/settings/service-types': typeof AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute
  '/organizations/settings/terms-privacy': typeof AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute
  '/organizations/settings/travel': typeof AuthenticatedOrganizationOrganizationsSettingsTravelRoute
  '/partner/providers/$providerOrgId': typeof AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute
  '/partner/training/$templateId': typeof AuthenticatedOrganizationPartnerTrainingTemplateIdRoute
  '/scheduler/sil/$arrangementId': typeof AuthenticatedOrganizationSchedulerSilArrangementIdRoute
  '/scheduler/templates/$templateId': typeof AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute
  '/shifts/$shiftId/edit': typeof AuthenticatedOrganizationShiftsShiftIdEditRoute
  '/staff/$staffId/clients': typeof AuthenticatedOrganizationStaffStaffIdClientsRoute
  '/staff/$staffId/documents': typeof AuthenticatedOrganizationStaffStaffIdDocumentsRoute
  '/staff/$staffId/employment': typeof AuthenticatedOrganizationStaffStaffIdEmploymentRoute
  '/staff/$staffId/overview': typeof AuthenticatedOrganizationStaffStaffIdOverviewRoute
  '/staff/$staffId/payroll': typeof AuthenticatedOrganizationStaffStaffIdPayrollRoute
  '/staff/$staffId/performance': typeof AuthenticatedOrganizationStaffStaffIdPerformanceRoute
  '/staff/$staffId/profile': typeof AuthenticatedOrganizationStaffStaffIdProfileRoute
  '/staff/$staffId/roster': typeof AuthenticatedOrganizationStaffStaffIdRosterRoute
  '/staff/$staffId/work-rights': typeof AuthenticatedOrganizationStaffStaffIdWorkRightsRoute
  '/support-coordination/scribe/$noteId': typeof AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute
  '/tasks/boards/$boardId': typeof AuthenticatedOrganizationTasksBoardsBoardIdRoute
  '/clients/$clientId': typeof AuthenticatedOrganizationClientsClientIdIndexRoute
  '/clients/teams': typeof AuthenticatedOrganizationClientsTeamsIndexRoute
  '/compliance/complaints': typeof AuthenticatedOrganizationComplianceComplaintsIndexRoute
  '/compliance/policy-pack': typeof AuthenticatedOrganizationCompliancePolicyPackIndexRoute
  '/compliance/restrictive-practices': typeof AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute
  '/incidents/$incidentId': typeof AuthenticatedOrganizationIncidentsIncidentIdIndexRoute
  '/incidents/reports/': typeof AuthenticatedOrganizationIncidentsReportsIndexRoute
  '/ndis-standards/complaints': typeof AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute
  '/onboarding/management': typeof AuthenticatedOrganizationOnboardingManagementIndexRoute
  '/organizations/inductions': typeof AuthenticatedOrganizationOrganizationsInductionsIndexRoute
  '/partner/library': typeof AuthenticatedOrganizationPartnerLibraryIndexRoute
  '/partner/providers': typeof AuthenticatedOrganizationPartnerProvidersIndexRoute
  '/partner/training': typeof AuthenticatedOrganizationPartnerTrainingIndexRoute
  '/scheduler/sil': typeof AuthenticatedOrganizationSchedulerSilIndexRoute
  '/scheduler/templates': typeof AuthenticatedOrganizationSchedulerTemplatesIndexRoute
  '/staff/$staffId': typeof AuthenticatedOrganizationStaffStaffIdIndexRoute
  '/staff/teams': typeof AuthenticatedOrganizationStaffTeamsIndexRoute
  '/tasks/$taskId': typeof AuthenticatedOrganizationTasksTaskIdIndexRoute
  '/tasks/boards': typeof AuthenticatedOrganizationTasksBoardsIndexRoute
  '/forms/$formId/submissions/$submissionId': typeof AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute
  '/organizations/settings/progress-note-templates/$templateId': typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute
  '/organizations/settings/training-programs/$programId': typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute
  '/forms/$formId/submissions': typeof AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute
  '/organizations/settings/progress-note-templates': typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute
  '/organizations/settings/training-programs': typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute
  '/compliance/policies/$policyId/redraft/$proposalId': typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute
}
export interface FileRoutesByTo {
  '/farewell': typeof FarewellRoute
  '/otp': typeof OtpRoute
  '/setup-passkey': typeof SetupPasskeyRoute
  '/change-password': typeof authChangePasswordRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/two-factor': typeof authTwoFactorRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/force-change-password': typeof AuthenticatedForceChangePasswordRoute
  '/get-the-app': typeof AuthenticatedGetTheAppRoute
  '/accept-invitation/$invitationId': typeof AcceptInvitationInvitationIdRoute
  '/care-plan-share/$token': typeof publicCarePlanShareTokenRoute
  '/dev/chat-preview': typeof publicDevChatPreviewRoute
  '/dev/mascot': typeof publicDevMascotRoute
  '/impersonate/$token': typeof publicImpersonateTokenRoute
  '/migration-portal/$token': typeof publicMigrationPortalTokenRoute
  '/onboarding-portal/$token': typeof publicOnboardingPortalTokenRoute
  '/shared-agreement/$token': typeof publicSharedAgreementTokenRoute
  '/shared-document/$token': typeof publicSharedDocumentTokenRoute
  '/sign-agreement/$token': typeof publicSignAgreementTokenRoute
  '/sign/$token': typeof publicSignTokenRoute
  '/sil-roc-share/$token': typeof publicSilRocShareTokenRoute
  '/support-plan-share/$token': typeof publicSupportPlanShareTokenRoute
  '/ai-gateway': typeof AuthenticatedOrganizationAiGatewayRoute
  '/cross-org': typeof AuthenticatedOrganizationCrossOrgRoute
  '/signatures': typeof AuthenticatedOrganizationSignaturesRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/communication': typeof AuthenticatedSettingsCommunicationRoute
  '/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/': typeof AuthenticatedOrganizationIndexRoute
  '/create-organization': typeof AuthenticatedCreateOrganizationIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/organizations/settings': typeof AuthenticatedOrganizationOrganizationsSettingsRouteRouteWithChildren
  '/shares/cross-org/$token': typeof publicSharesCrossOrgTokenRoute
  '/apps/skeleton-demo': typeof AuthenticatedOrganizationAppsSkeletonDemoRoute
  '/budget-calculator/$calculationId': typeof AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute
  '/budget-calculator/quick': typeof AuthenticatedOrganizationBudgetCalculatorQuickRoute
  '/chats/$conversationId': typeof AuthenticatedOrganizationChatsConversationIdRoute
  '/compliance/audits': typeof AuthenticatedOrganizationComplianceAuditsRoute
  '/compliance/conflicts-of-interest': typeof AuthenticatedOrganizationComplianceConflictsOfInterestRoute
  '/compliance/findings': typeof AuthenticatedOrganizationComplianceFindingsRoute
  '/compliance/gap-analysis': typeof AuthenticatedOrganizationComplianceGapAnalysisRoute
  '/compliance/hub': typeof AuthenticatedOrganizationComplianceHubRoute
  '/compliance/partners': typeof AuthenticatedOrganizationCompliancePartnersRoute
  '/compliance/policies': typeof AuthenticatedOrganizationCompliancePoliciesRoute
  '/compliance/risks': typeof AuthenticatedOrganizationComplianceRisksRoute
  '/compliance/standards': typeof AuthenticatedOrganizationComplianceStandardsRoute
  '/demo/skeleton': typeof AuthenticatedOrganizationDemoSkeletonRoute
  '/extractions/examples': typeof AuthenticatedOrganizationExtractionsExamplesRoute
  '/files/viewer': typeof AuthenticatedOrganizationFilesViewerRoute
  '/forms/review-queue': typeof AuthenticatedOrganizationFormsReviewQueueRoute
  '/help-center/$ticketId': typeof AuthenticatedOrganizationHelpCenterTicketIdRoute
  '/incidents/knowledge-base': typeof AuthenticatedOrganizationIncidentsKnowledgeBaseRoute
  '/incidents/new': typeof AuthenticatedOrganizationIncidentsNewRoute
  '/induction/$inductionId': typeof AuthenticatedOrganizationInductionInductionIdRoute
  '/learn-hubshift/$templateKey': typeof AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute
  '/my-shifts/$shiftId': typeof AuthenticatedOrganizationMyShiftsShiftIdRoute
  '/ndis-standards/audits': typeof AuthenticatedOrganizationNdisStandardsAuditsRoute
  '/ndis-standards/compliance': typeof AuthenticatedOrganizationNdisStandardsComplianceRoute
  '/ndis-standards/ican': typeof AuthenticatedOrganizationNdisStandardsIcanRoute
  '/ndis-standards/knowledge-base': typeof AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute
  '/ndis-standards/policies': typeof AuthenticatedOrganizationNdisStandardsPoliciesRoute
  '/ndis-standards/reports': typeof AuthenticatedOrganizationNdisStandardsReportsRoute
  '/onboarding/admin': typeof AuthenticatedOrganizationOnboardingAdminRoute
  '/onboarding/client': typeof AuthenticatedOrganizationOnboardingClientRoute
  '/onboarding/preview': typeof AuthenticatedOrganizationOnboardingPreviewRoute
  '/onboarding/required-documents': typeof AuthenticatedOrganizationOnboardingRequiredDocumentsRoute
  '/onboarding/staff': typeof AuthenticatedOrganizationOnboardingStaffRoute
  '/payruns/$payRunId': typeof AuthenticatedOrganizationPayrunsPayRunIdRoute
  '/policies/audits': typeof AuthenticatedOrganizationPoliciesAuditsRoute
  '/referrals/$referralId': typeof AuthenticatedOrganizationReferralsReferralIdRoute
  '/reports/billable-charges': typeof AuthenticatedOrganizationReportsBillableChargesRoute
  '/reports/capacity': typeof AuthenticatedOrganizationReportsCapacityRoute
  '/reports/expired-documents': typeof AuthenticatedOrganizationReportsExpiredDocumentsRoute
  '/reports/goal-achievement': typeof AuthenticatedOrganizationReportsGoalAchievementRoute
  '/reports/my-billable-charges': typeof AuthenticatedOrganizationReportsMyBillableChargesRoute
  '/reports/my-billable-hours': typeof AuthenticatedOrganizationReportsMyBillableHoursRoute
  '/reports/my-billables': typeof AuthenticatedOrganizationReportsMyBillablesRoute
  '/reports/ndia-errors': typeof AuthenticatedOrganizationReportsNdiaErrorsRoute
  '/reports/overtime': typeof AuthenticatedOrganizationReportsOvertimeRoute
  '/reports/participant-alerts': typeof AuthenticatedOrganizationReportsParticipantAlertsRoute
  '/reports/participant-birthdays': typeof AuthenticatedOrganizationReportsParticipantBirthdaysRoute
  '/reports/participant-goals': typeof AuthenticatedOrganizationReportsParticipantGoalsRoute
  '/reports/participant-plans': typeof AuthenticatedOrganizationReportsParticipantPlansRoute
  '/reports/participant-records': typeof AuthenticatedOrganizationReportsParticipantRecordsRoute
  '/reports/participant-risks': typeof AuthenticatedOrganizationReportsParticipantRisksRoute
  '/reports/participant-utilisation': typeof AuthenticatedOrganizationReportsParticipantUtilisationRoute
  '/reports/participants-without-goals': typeof AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute
  '/reports/participants-without-risks': typeof AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute
  '/reports/preview': typeof AuthenticatedOrganizationReportsPreviewRoute
  '/reports/public-holiday-supports': typeof AuthenticatedOrganizationReportsPublicHolidaySupportsRoute
  '/reports/recurring-shifts-expiring': typeof AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute
  '/reports/service-delivery': typeof AuthenticatedOrganizationReportsServiceDeliveryRoute
  '/reports/shift-clashes': typeof AuthenticatedOrganizationReportsShiftClashesRoute
  '/reports/shift-tasks': typeof AuthenticatedOrganizationReportsShiftTasksRoute
  '/reports/shift-variance': typeof AuthenticatedOrganizationReportsShiftVarianceRoute
  '/reports/shifts': typeof AuthenticatedOrganizationReportsShiftsRoute
  '/reports/staff-utilisation': typeof AuthenticatedOrganizationReportsStaffUtilisationRoute
  '/reports/support-cancellations': typeof AuthenticatedOrganizationReportsSupportCancellationsRoute
  '/reports/support-notes': typeof AuthenticatedOrganizationReportsSupportNotesRoute
  '/reports/supports': typeof AuthenticatedOrganizationReportsSupportsRoute
  '/reports/supports-without-notes': typeof AuthenticatedOrganizationReportsSupportsWithoutNotesRoute
  '/reports/tasks': typeof AuthenticatedOrganizationReportsTasksRoute
  '/reports/tasks-without-notes': typeof AuthenticatedOrganizationReportsTasksWithoutNotesRoute
  '/reports/team-billable-hours': typeof AuthenticatedOrganizationReportsTeamBillableHoursRoute
  '/reports/team-billables': typeof AuthenticatedOrganizationReportsTeamBillablesRoute
  '/reports/user-availability': typeof AuthenticatedOrganizationReportsUserAvailabilityRoute
  '/reports/user-records': typeof AuthenticatedOrganizationReportsUserRecordsRoute
  '/reports/voided-charges': typeof AuthenticatedOrganizationReportsVoidedChargesRoute
  '/scheduler/alerts': typeof AuthenticatedOrganizationSchedulerAlertsRoute
  '/scheduler/all-shifts': typeof AuthenticatedOrganizationSchedulerAllShiftsRoute
  '/scheduler/availability-requests': typeof AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute
  '/scheduler/clashes': typeof AuthenticatedOrganizationSchedulerClashesRoute
  '/scheduler/overview': typeof AuthenticatedOrganizationSchedulerOverviewRoute
  '/scheduler/post-shift-review': typeof AuthenticatedOrganizationSchedulerPostShiftReviewRoute
  '/scheduler/progress-notes': typeof AuthenticatedOrganizationSchedulerProgressNotesRoute
  '/scheduler/review-queue': typeof AuthenticatedOrganizationSchedulerReviewQueueRoute
  '/scheduler/shift-requests': typeof AuthenticatedOrganizationSchedulerShiftRequestsRoute
  '/shifts/new': typeof AuthenticatedOrganizationShiftsNewRoute
  '/staff/compliance': typeof AuthenticatedOrganizationStaffComplianceRoute
  '/support-coordination/billing': typeof AuthenticatedOrganizationSupportCoordinationBillingRoute
  '/support-coordination/budget': typeof AuthenticatedOrganizationSupportCoordinationBudgetRoute
  '/support-coordination/case-notes': typeof AuthenticatedOrganizationSupportCoordinationCaseNotesRoute
  '/support-coordination/compliance': typeof AuthenticatedOrganizationSupportCoordinationComplianceRoute
  '/support-coordination/emails': typeof AuthenticatedOrganizationSupportCoordinationEmailsRoute
  '/support-coordination/mailbox-settings': typeof AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute
  '/support-coordination/next-best-actions': typeof AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute
  '/support-coordination/notebook': typeof AuthenticatedOrganizationSupportCoordinationNotebookRoute
  '/support-coordination/planner': typeof AuthenticatedOrganizationSupportCoordinationPlannerRoute
  '/support-coordination/registers': typeof AuthenticatedOrganizationSupportCoordinationRegistersRoute
  '/support-coordination/reports': typeof AuthenticatedOrganizationSupportCoordinationReportsRoute
  '/support-coordination/scribe': typeof AuthenticatedOrganizationSupportCoordinationScribeRouteWithChildren
  '/support-coordination/telephony': typeof AuthenticatedOrganizationSupportCoordinationTelephonyRoute
  '/support-coordination/time-entries': typeof AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute
  '/support-plan-sign/$shareId': typeof AuthenticatedOrganizationSupportPlanSignShareIdRoute
  '/training/$programId': typeof AuthenticatedOrganizationTrainingProgramIdRoute
  '/workflows/$workflowId': typeof AuthenticatedOrganizationWorkflowsWorkflowIdRoute
  '/apps': typeof AuthenticatedOrganizationAppsIndexRoute
  '/audit-logs': typeof AuthenticatedOrganizationAuditLogsIndexRoute
  '/billing': typeof AuthenticatedOrganizationBillingIndexRoute
  '/budget-calculator': typeof AuthenticatedOrganizationBudgetCalculatorIndexRoute
  '/case-notes': typeof AuthenticatedOrganizationCaseNotesIndexRoute
  '/caseload': typeof AuthenticatedOrganizationCaseloadIndexRoute
  '/chats': typeof AuthenticatedOrganizationChatsIndexRoute
  '/claims': typeof AuthenticatedOrganizationClaimsIndexRoute
  '/clients': typeof AuthenticatedOrganizationClientsIndexRoute
  '/compliance': typeof AuthenticatedOrganizationComplianceIndexRoute
  '/documents': typeof AuthenticatedOrganizationDocumentsIndexRoute
  '/expenses': typeof AuthenticatedOrganizationExpensesIndexRoute
  '/extractions': typeof AuthenticatedOrganizationExtractionsIndexRoute
  '/facilities': typeof AuthenticatedOrganizationFacilitiesIndexRoute
  '/forms': typeof AuthenticatedOrganizationFormsIndexRoute
  '/help-center': typeof AuthenticatedOrganizationHelpCenterIndexRoute
  '/incidents': typeof AuthenticatedOrganizationIncidentsIndexRoute
  '/invoices': typeof AuthenticatedOrganizationInvoicesIndexRoute
  '/learn-hubshift': typeof AuthenticatedOrganizationLearnHubshiftIndexRoute
  '/leave': typeof AuthenticatedOrganizationLeaveIndexRoute
  '/my-agreements': typeof AuthenticatedOrganizationMyAgreementsIndexRoute
  '/my-appointments': typeof AuthenticatedOrganizationMyAppointmentsIndexRoute
  '/my-availability': typeof AuthenticatedOrganizationMyAvailabilityIndexRoute
  '/my-complaints': typeof AuthenticatedOrganizationMyComplaintsIndexRoute
  '/my-consent': typeof AuthenticatedOrganizationMyConsentIndexRoute
  '/my-declarations': typeof AuthenticatedOrganizationMyDeclarationsIndexRoute
  '/my-forms': typeof AuthenticatedOrganizationMyFormsIndexRoute
  '/my-goals': typeof AuthenticatedOrganizationMyGoalsIndexRoute
  '/my-inbox': typeof AuthenticatedOrganizationMyInboxIndexRoute
  '/my-incident-reports': typeof AuthenticatedOrganizationMyIncidentReportsIndexRoute
  '/my-incidents': typeof AuthenticatedOrganizationMyIncidentsIndexRoute
  '/my-invoices': typeof AuthenticatedOrganizationMyInvoicesIndexRoute
  '/my-onboarding': typeof AuthenticatedOrganizationMyOnboardingIndexRoute
  '/my-participants': typeof AuthenticatedOrganizationMyParticipantsIndexRoute
  '/my-people': typeof AuthenticatedOrganizationMyPeopleIndexRoute
  '/my-plan': typeof AuthenticatedOrganizationMyPlanIndexRoute
  '/my-shifts': typeof AuthenticatedOrganizationMyShiftsIndexRoute
  '/my-support-team': typeof AuthenticatedOrganizationMySupportTeamIndexRoute
  '/my-timesheets': typeof AuthenticatedOrganizationMyTimesheetsIndexRoute
  '/ndis-standards': typeof AuthenticatedOrganizationNdisStandardsIndexRoute
  '/notes': typeof AuthenticatedOrganizationNotesIndexRoute
  '/notifications': typeof AuthenticatedOrganizationNotificationsIndexRoute
  '/offboarding': typeof AuthenticatedOrganizationOffboardingIndexRoute
  '/payroll': typeof AuthenticatedOrganizationPayrollIndexRoute
  '/policies': typeof AuthenticatedOrganizationPoliciesIndexRoute
  '/public-holidays': typeof AuthenticatedOrganizationPublicHolidaysIndexRoute
  '/reconciliation': typeof AuthenticatedOrganizationReconciliationIndexRoute
  '/referrals': typeof AuthenticatedOrganizationReferralsIndexRoute
  '/reports': typeof AuthenticatedOrganizationReportsIndexRoute
  '/roster': typeof AuthenticatedOrganizationRosterIndexRoute
  '/scheduler': typeof AuthenticatedOrganizationSchedulerIndexRoute
  '/staff': typeof AuthenticatedOrganizationStaffIndexRoute
  '/support-coordination': typeof AuthenticatedOrganizationSupportCoordinationIndexRoute
  '/tasks': typeof AuthenticatedOrganizationTasksIndexRoute
  '/timesheets': typeof AuthenticatedOrganizationTimesheetsIndexRoute
  '/training': typeof AuthenticatedOrganizationTrainingIndexRoute
  '/upgrade': typeof AuthenticatedOrganizationUpgradeIndexRoute
  '/users': typeof AuthenticatedOrganizationUsersIndexRoute
  '/workflows': typeof AuthenticatedOrganizationWorkflowsIndexRoute
  '/clients/$clientId/appointments': typeof AuthenticatedOrganizationClientsClientIdAppointmentsRoute
  '/clients/$clientId/audit-trail': typeof AuthenticatedOrganizationClientsClientIdAuditTrailRoute
  '/clients/$clientId/behaviour-support': typeof AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute
  '/clients/$clientId/care-plan': typeof AuthenticatedOrganizationClientsClientIdCarePlanRoute
  '/clients/$clientId/documents': typeof AuthenticatedOrganizationClientsClientIdDocumentsRoute
  '/clients/$clientId/evidence-packs': typeof AuthenticatedOrganizationClientsClientIdEvidencePacksRoute
  '/clients/$clientId/funding': typeof AuthenticatedOrganizationClientsClientIdFundingRoute
  '/clients/$clientId/goals': typeof AuthenticatedOrganizationClientsClientIdGoalsRoute
  '/clients/$clientId/ican': typeof AuthenticatedOrganizationClientsClientIdIcanRoute
  '/clients/$clientId/incidents': typeof AuthenticatedOrganizationClientsClientIdIncidentsRoute
  '/clients/$clientId/intake': typeof AuthenticatedOrganizationClientsClientIdIntakeRoute
  '/clients/$clientId/medications': typeof AuthenticatedOrganizationClientsClientIdMedicationsRoute
  '/clients/$clientId/notes': typeof AuthenticatedOrganizationClientsClientIdNotesRoute
  '/clients/$clientId/onboarding': typeof AuthenticatedOrganizationClientsClientIdOnboardingRoute
  '/clients/$clientId/overview': typeof AuthenticatedOrganizationClientsClientIdOverviewRoute
  '/clients/$clientId/profile': typeof AuthenticatedOrganizationClientsClientIdProfileRoute
  '/clients/$clientId/risk-profile': typeof AuthenticatedOrganizationClientsClientIdRiskProfileRoute
  '/clients/$clientId/schedules': typeof AuthenticatedOrganizationClientsClientIdSchedulesRoute
  '/clients/$clientId/service-agreement': typeof AuthenticatedOrganizationClientsClientIdServiceAgreementRoute
  '/clients/$clientId/stakeholders': typeof AuthenticatedOrganizationClientsClientIdStakeholdersRoute
  '/clients/$clientId/support-coordination': typeof AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute
  '/clients/$clientId/support-plan': typeof AuthenticatedOrganizationClientsClientIdSupportPlanRoute
  '/clients/$clientId/transitions': typeof AuthenticatedOrganizationClientsClientIdTransitionsRoute
  '/compliance/audits/$auditId': typeof AuthenticatedOrganizationComplianceAuditsAuditIdRoute
  '/compliance/complaints/$complaintId': typeof AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute
  '/compliance/policies/$policyId': typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute
  '/compliance/policy-pack/$runId': typeof AuthenticatedOrganizationCompliancePolicyPackRunIdRoute
  '/compliance/restrictive-practices/monthly-report': typeof AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute
  '/compliance/risks/settings': typeof AuthenticatedOrganizationComplianceRisksSettingsRoute
  '/forms/$formId/edit': typeof AuthenticatedOrganizationFormsFormIdEditRoute
  '/forms/$formId/fill': typeof AuthenticatedOrganizationFormsFormIdFillRoute
  '/forms/$formId/preview': typeof AuthenticatedOrganizationFormsFormIdPreviewRoute
  '/incidents/$incidentId/edit': typeof AuthenticatedOrganizationIncidentsIncidentIdEditRoute
  '/incidents/reports/compliance': typeof AuthenticatedOrganizationIncidentsReportsComplianceRoute
  '/incidents/reports/executive-summary': typeof AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute
  '/incidents/reports/incident-mapping': typeof AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute
  '/incidents/reports/operational-performance': typeof AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute
  '/incidents/reports/trend-analysis': typeof AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute
  '/ndis-standards/complaints/$complaintId': typeof AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute
  '/onboarding/management/$memberId': typeof AuthenticatedOrganizationOnboardingManagementMemberIdRoute
  '/onboarding/management/pipeline': typeof AuthenticatedOrganizationOnboardingManagementPipelineRoute
  '/organizations/settings/agreement-sections': typeof AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute
  '/organizations/settings/ai-settings': typeof AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute
  '/organizations/settings/assistant-knowledge': typeof AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute
  '/organizations/settings/award-rates': typeof AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute
  '/organizations/settings/award-xero-mapping': typeof AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute
  '/organizations/settings/cancellation-policy': typeof AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute
  '/organizations/settings/client-document-types': typeof AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute
  '/organizations/settings/clock-in': typeof AuthenticatedOrganizationOrganizationsSettingsClockInRoute
  '/organizations/settings/compliance-profile': typeof AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute
  '/organizations/settings/data-migration': typeof AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute
  '/organizations/settings/document-types': typeof AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute
  '/organizations/settings/facilities': typeof AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute
  '/organizations/settings/go-live': typeof AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute
  '/organizations/settings/induction': typeof AuthenticatedOrganizationOrganizationsSettingsInductionRoute
  '/organizations/settings/integrations': typeof AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute
  '/organizations/settings/invoice-templates': typeof AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute
  '/organizations/settings/line-items': typeof AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute
  '/organizations/settings/members': typeof AuthenticatedOrganizationOrganizationsSettingsMembersRoute
  '/organizations/settings/notifications-config': typeof AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute
  '/organizations/settings/payroll': typeof AuthenticatedOrganizationOrganizationsSettingsPayrollRoute
  '/organizations/settings/permission-matrix': typeof AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute
  '/organizations/settings/privacy': typeof AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute
  '/organizations/settings/profile': typeof AuthenticatedOrganizationOrganizationsSettingsProfileRoute
  '/organizations/settings/public-holidays': typeof AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute
  '/organizations/settings/referral-intake': typeof AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute
  '/organizations/settings/regions': typeof AuthenticatedOrganizationOrganizationsSettingsRegionsRoute
  '/organizations/settings/reports-configuration': typeof AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute
  '/organizations/settings/roles': typeof AuthenticatedOrganizationOrganizationsSettingsRolesRoute
  '/organizations/settings/service-types': typeof AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute
  '/organizations/settings/terms-privacy': typeof AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute
  '/organizations/settings/travel': typeof AuthenticatedOrganizationOrganizationsSettingsTravelRoute
  '/partner/providers/$providerOrgId': typeof AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute
  '/partner/training/$templateId': typeof AuthenticatedOrganizationPartnerTrainingTemplateIdRoute
  '/scheduler/sil/$arrangementId': typeof AuthenticatedOrganizationSchedulerSilArrangementIdRoute
  '/scheduler/templates/$templateId': typeof AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute
  '/shifts/$shiftId/edit': typeof AuthenticatedOrganizationShiftsShiftIdEditRoute
  '/staff/$staffId/clients': typeof AuthenticatedOrganizationStaffStaffIdClientsRoute
  '/staff/$staffId/documents': typeof AuthenticatedOrganizationStaffStaffIdDocumentsRoute
  '/staff/$staffId/employment': typeof AuthenticatedOrganizationStaffStaffIdEmploymentRoute
  '/staff/$staffId/overview': typeof AuthenticatedOrganizationStaffStaffIdOverviewRoute
  '/staff/$staffId/payroll': typeof AuthenticatedOrganizationStaffStaffIdPayrollRoute
  '/staff/$staffId/performance': typeof AuthenticatedOrganizationStaffStaffIdPerformanceRoute
  '/staff/$staffId/profile': typeof AuthenticatedOrganizationStaffStaffIdProfileRoute
  '/staff/$staffId/roster': typeof AuthenticatedOrganizationStaffStaffIdRosterRoute
  '/staff/$staffId/work-rights': typeof AuthenticatedOrganizationStaffStaffIdWorkRightsRoute
  '/support-coordination/scribe/$noteId': typeof AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute
  '/tasks/boards/$boardId': typeof AuthenticatedOrganizationTasksBoardsBoardIdRoute
  '/clients/$clientId': typeof AuthenticatedOrganizationClientsClientIdIndexRoute
  '/clients/teams': typeof AuthenticatedOrganizationClientsTeamsIndexRoute
  '/compliance/complaints': typeof AuthenticatedOrganizationComplianceComplaintsIndexRoute
  '/compliance/policy-pack': typeof AuthenticatedOrganizationCompliancePolicyPackIndexRoute
  '/compliance/restrictive-practices': typeof AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute
  '/incidents/$incidentId': typeof AuthenticatedOrganizationIncidentsIncidentIdIndexRoute
  '/incidents/reports': typeof AuthenticatedOrganizationIncidentsReportsIndexRoute
  '/ndis-standards/complaints': typeof AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute
  '/onboarding/management': typeof AuthenticatedOrganizationOnboardingManagementIndexRoute
  '/organizations/inductions': typeof AuthenticatedOrganizationOrganizationsInductionsIndexRoute
  '/partner/library': typeof AuthenticatedOrganizationPartnerLibraryIndexRoute
  '/partner/providers': typeof AuthenticatedOrganizationPartnerProvidersIndexRoute
  '/partner/training': typeof AuthenticatedOrganizationPartnerTrainingIndexRoute
  '/scheduler/sil': typeof AuthenticatedOrganizationSchedulerSilIndexRoute
  '/scheduler/templates': typeof AuthenticatedOrganizationSchedulerTemplatesIndexRoute
  '/staff/$staffId': typeof AuthenticatedOrganizationStaffStaffIdIndexRoute
  '/staff/teams': typeof AuthenticatedOrganizationStaffTeamsIndexRoute
  '/tasks/$taskId': typeof AuthenticatedOrganizationTasksTaskIdIndexRoute
  '/tasks/boards': typeof AuthenticatedOrganizationTasksBoardsIndexRoute
  '/forms/$formId/submissions/$submissionId': typeof AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute
  '/organizations/settings/progress-note-templates/$templateId': typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute
  '/organizations/settings/training-programs/$programId': typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute
  '/forms/$formId/submissions': typeof AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute
  '/organizations/settings/progress-note-templates': typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute
  '/organizations/settings/training-programs': typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute
  '/compliance/policies/$policyId/redraft/$proposalId': typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/farewell': typeof FarewellRoute
  '/otp': typeof OtpRoute
  '/setup-passkey': typeof SetupPasskeyRoute
  '/_authenticated/_organization': typeof AuthenticatedOrganizationRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(auth)/change-password': typeof authChangePasswordRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(auth)/two-factor': typeof authTwoFactorRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/force-change-password': typeof AuthenticatedForceChangePasswordRoute
  '/_authenticated/get-the-app': typeof AuthenticatedGetTheAppRoute
  '/accept-invitation/$invitationId': typeof AcceptInvitationInvitationIdRoute
  '/_authenticated/_organization/scheduler': typeof AuthenticatedOrganizationSchedulerRouteRouteWithChildren
  '/_authenticated/_organization/support-coordination': typeof AuthenticatedOrganizationSupportCoordinationRouteRouteWithChildren
  '/(public)/care-plan-share/$token': typeof publicCarePlanShareTokenRoute
  '/(public)/dev/chat-preview': typeof publicDevChatPreviewRoute
  '/(public)/dev/mascot': typeof publicDevMascotRoute
  '/(public)/impersonate/$token': typeof publicImpersonateTokenRoute
  '/(public)/migration-portal/$token': typeof publicMigrationPortalTokenRoute
  '/(public)/onboarding-portal/$token': typeof publicOnboardingPortalTokenRoute
  '/(public)/shared-agreement/$token': typeof publicSharedAgreementTokenRoute
  '/(public)/shared-document/$token': typeof publicSharedDocumentTokenRoute
  '/(public)/sign-agreement/$token': typeof publicSignAgreementTokenRoute
  '/(public)/sign/$token': typeof publicSignTokenRoute
  '/(public)/sil-roc-share/$token': typeof publicSilRocShareTokenRoute
  '/(public)/support-plan-share/$token': typeof publicSupportPlanShareTokenRoute
  '/_authenticated/_organization/ai-gateway': typeof AuthenticatedOrganizationAiGatewayRoute
  '/_authenticated/_organization/cross-org': typeof AuthenticatedOrganizationCrossOrgRoute
  '/_authenticated/_organization/signatures': typeof AuthenticatedOrganizationSignaturesRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/communication': typeof AuthenticatedSettingsCommunicationRoute
  '/_authenticated/settings/integrations': typeof AuthenticatedSettingsIntegrationsRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/_organization/': typeof AuthenticatedOrganizationIndexRoute
  '/_authenticated/create-organization/': typeof AuthenticatedCreateOrganizationIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/_organization/incidents/reports': typeof AuthenticatedOrganizationIncidentsReportsRouteRouteWithChildren
  '/_authenticated/_organization/organizations/settings': typeof AuthenticatedOrganizationOrganizationsSettingsRouteRouteWithChildren
  '/(public)/shares/cross-org/$token': typeof publicSharesCrossOrgTokenRoute
  '/_authenticated/_organization/apps/skeleton-demo': typeof AuthenticatedOrganizationAppsSkeletonDemoRoute
  '/_authenticated/_organization/budget-calculator/$calculationId': typeof AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute
  '/_authenticated/_organization/budget-calculator/quick': typeof AuthenticatedOrganizationBudgetCalculatorQuickRoute
  '/_authenticated/_organization/chats/$conversationId': typeof AuthenticatedOrganizationChatsConversationIdRoute
  '/_authenticated/_organization/compliance/audits': typeof AuthenticatedOrganizationComplianceAuditsRoute
  '/_authenticated/_organization/compliance/conflicts-of-interest': typeof AuthenticatedOrganizationComplianceConflictsOfInterestRoute
  '/_authenticated/_organization/compliance/findings': typeof AuthenticatedOrganizationComplianceFindingsRoute
  '/_authenticated/_organization/compliance/gap-analysis': typeof AuthenticatedOrganizationComplianceGapAnalysisRoute
  '/_authenticated/_organization/compliance/hub': typeof AuthenticatedOrganizationComplianceHubRoute
  '/_authenticated/_organization/compliance/partners': typeof AuthenticatedOrganizationCompliancePartnersRoute
  '/_authenticated/_organization/compliance/policies': typeof AuthenticatedOrganizationCompliancePoliciesRoute
  '/_authenticated/_organization/compliance/risks': typeof AuthenticatedOrganizationComplianceRisksRoute
  '/_authenticated/_organization/compliance/standards': typeof AuthenticatedOrganizationComplianceStandardsRoute
  '/_authenticated/_organization/demo/skeleton': typeof AuthenticatedOrganizationDemoSkeletonRoute
  '/_authenticated/_organization/extractions/examples': typeof AuthenticatedOrganizationExtractionsExamplesRoute
  '/_authenticated/_organization/files/viewer': typeof AuthenticatedOrganizationFilesViewerRoute
  '/_authenticated/_organization/forms/review-queue': typeof AuthenticatedOrganizationFormsReviewQueueRoute
  '/_authenticated/_organization/help-center/$ticketId': typeof AuthenticatedOrganizationHelpCenterTicketIdRoute
  '/_authenticated/_organization/incidents/knowledge-base': typeof AuthenticatedOrganizationIncidentsKnowledgeBaseRoute
  '/_authenticated/_organization/incidents/new': typeof AuthenticatedOrganizationIncidentsNewRoute
  '/_authenticated/_organization/induction/$inductionId': typeof AuthenticatedOrganizationInductionInductionIdRoute
  '/_authenticated/_organization/learn-hubshift/$templateKey': typeof AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute
  '/_authenticated/_organization/my-shifts/$shiftId': typeof AuthenticatedOrganizationMyShiftsShiftIdRoute
  '/_authenticated/_organization/ndis-standards/audits': typeof AuthenticatedOrganizationNdisStandardsAuditsRoute
  '/_authenticated/_organization/ndis-standards/compliance': typeof AuthenticatedOrganizationNdisStandardsComplianceRoute
  '/_authenticated/_organization/ndis-standards/ican': typeof AuthenticatedOrganizationNdisStandardsIcanRoute
  '/_authenticated/_organization/ndis-standards/knowledge-base': typeof AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute
  '/_authenticated/_organization/ndis-standards/policies': typeof AuthenticatedOrganizationNdisStandardsPoliciesRoute
  '/_authenticated/_organization/ndis-standards/reports': typeof AuthenticatedOrganizationNdisStandardsReportsRoute
  '/_authenticated/_organization/onboarding/admin': typeof AuthenticatedOrganizationOnboardingAdminRoute
  '/_authenticated/_organization/onboarding/client': typeof AuthenticatedOrganizationOnboardingClientRoute
  '/_authenticated/_organization/onboarding/preview': typeof AuthenticatedOrganizationOnboardingPreviewRoute
  '/_authenticated/_organization/onboarding/required-documents': typeof AuthenticatedOrganizationOnboardingRequiredDocumentsRoute
  '/_authenticated/_organization/onboarding/staff': typeof AuthenticatedOrganizationOnboardingStaffRoute
  '/_authenticated/_organization/payruns/$payRunId': typeof AuthenticatedOrganizationPayrunsPayRunIdRoute
  '/_authenticated/_organization/policies/audits': typeof AuthenticatedOrganizationPoliciesAuditsRoute
  '/_authenticated/_organization/referrals/$referralId': typeof AuthenticatedOrganizationReferralsReferralIdRoute
  '/_authenticated/_organization/reports/billable-charges': typeof AuthenticatedOrganizationReportsBillableChargesRoute
  '/_authenticated/_organization/reports/capacity': typeof AuthenticatedOrganizationReportsCapacityRoute
  '/_authenticated/_organization/reports/expired-documents': typeof AuthenticatedOrganizationReportsExpiredDocumentsRoute
  '/_authenticated/_organization/reports/goal-achievement': typeof AuthenticatedOrganizationReportsGoalAchievementRoute
  '/_authenticated/_organization/reports/my-billable-charges': typeof AuthenticatedOrganizationReportsMyBillableChargesRoute
  '/_authenticated/_organization/reports/my-billable-hours': typeof AuthenticatedOrganizationReportsMyBillableHoursRoute
  '/_authenticated/_organization/reports/my-billables': typeof AuthenticatedOrganizationReportsMyBillablesRoute
  '/_authenticated/_organization/reports/ndia-errors': typeof AuthenticatedOrganizationReportsNdiaErrorsRoute
  '/_authenticated/_organization/reports/overtime': typeof AuthenticatedOrganizationReportsOvertimeRoute
  '/_authenticated/_organization/reports/participant-alerts': typeof AuthenticatedOrganizationReportsParticipantAlertsRoute
  '/_authenticated/_organization/reports/participant-birthdays': typeof AuthenticatedOrganizationReportsParticipantBirthdaysRoute
  '/_authenticated/_organization/reports/participant-goals': typeof AuthenticatedOrganizationReportsParticipantGoalsRoute
  '/_authenticated/_organization/reports/participant-plans': typeof AuthenticatedOrganizationReportsParticipantPlansRoute
  '/_authenticated/_organization/reports/participant-records': typeof AuthenticatedOrganizationReportsParticipantRecordsRoute
  '/_authenticated/_organization/reports/participant-risks': typeof AuthenticatedOrganizationReportsParticipantRisksRoute
  '/_authenticated/_organization/reports/participant-utilisation': typeof AuthenticatedOrganizationReportsParticipantUtilisationRoute
  '/_authenticated/_organization/reports/participants-without-goals': typeof AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute
  '/_authenticated/_organization/reports/participants-without-risks': typeof AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute
  '/_authenticated/_organization/reports/preview': typeof AuthenticatedOrganizationReportsPreviewRoute
  '/_authenticated/_organization/reports/public-holiday-supports': typeof AuthenticatedOrganizationReportsPublicHolidaySupportsRoute
  '/_authenticated/_organization/reports/recurring-shifts-expiring': typeof AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute
  '/_authenticated/_organization/reports/service-delivery': typeof AuthenticatedOrganizationReportsServiceDeliveryRoute
  '/_authenticated/_organization/reports/shift-clashes': typeof AuthenticatedOrganizationReportsShiftClashesRoute
  '/_authenticated/_organization/reports/shift-tasks': typeof AuthenticatedOrganizationReportsShiftTasksRoute
  '/_authenticated/_organization/reports/shift-variance': typeof AuthenticatedOrganizationReportsShiftVarianceRoute
  '/_authenticated/_organization/reports/shifts': typeof AuthenticatedOrganizationReportsShiftsRoute
  '/_authenticated/_organization/reports/staff-utilisation': typeof AuthenticatedOrganizationReportsStaffUtilisationRoute
  '/_authenticated/_organization/reports/support-cancellations': typeof AuthenticatedOrganizationReportsSupportCancellationsRoute
  '/_authenticated/_organization/reports/support-notes': typeof AuthenticatedOrganizationReportsSupportNotesRoute
  '/_authenticated/_organization/reports/supports': typeof AuthenticatedOrganizationReportsSupportsRoute
  '/_authenticated/_organization/reports/supports-without-notes': typeof AuthenticatedOrganizationReportsSupportsWithoutNotesRoute
  '/_authenticated/_organization/reports/tasks': typeof AuthenticatedOrganizationReportsTasksRoute
  '/_authenticated/_organization/reports/tasks-without-notes': typeof AuthenticatedOrganizationReportsTasksWithoutNotesRoute
  '/_authenticated/_organization/reports/team-billable-hours': typeof AuthenticatedOrganizationReportsTeamBillableHoursRoute
  '/_authenticated/_organization/reports/team-billables': typeof AuthenticatedOrganizationReportsTeamBillablesRoute
  '/_authenticated/_organization/reports/user-availability': typeof AuthenticatedOrganizationReportsUserAvailabilityRoute
  '/_authenticated/_organization/reports/user-records': typeof AuthenticatedOrganizationReportsUserRecordsRoute
  '/_authenticated/_organization/reports/voided-charges': typeof AuthenticatedOrganizationReportsVoidedChargesRoute
  '/_authenticated/_organization/scheduler/alerts': typeof AuthenticatedOrganizationSchedulerAlertsRoute
  '/_authenticated/_organization/scheduler/all-shifts': typeof AuthenticatedOrganizationSchedulerAllShiftsRoute
  '/_authenticated/_organization/scheduler/availability-requests': typeof AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute
  '/_authenticated/_organization/scheduler/clashes': typeof AuthenticatedOrganizationSchedulerClashesRoute
  '/_authenticated/_organization/scheduler/overview': typeof AuthenticatedOrganizationSchedulerOverviewRoute
  '/_authenticated/_organization/scheduler/post-shift-review': typeof AuthenticatedOrganizationSchedulerPostShiftReviewRoute
  '/_authenticated/_organization/scheduler/progress-notes': typeof AuthenticatedOrganizationSchedulerProgressNotesRoute
  '/_authenticated/_organization/scheduler/review-queue': typeof AuthenticatedOrganizationSchedulerReviewQueueRoute
  '/_authenticated/_organization/scheduler/shift-requests': typeof AuthenticatedOrganizationSchedulerShiftRequestsRoute
  '/_authenticated/_organization/shifts/new': typeof AuthenticatedOrganizationShiftsNewRoute
  '/_authenticated/_organization/staff/compliance': typeof AuthenticatedOrganizationStaffComplianceRoute
  '/_authenticated/_organization/support-coordination/billing': typeof AuthenticatedOrganizationSupportCoordinationBillingRoute
  '/_authenticated/_organization/support-coordination/budget': typeof AuthenticatedOrganizationSupportCoordinationBudgetRoute
  '/_authenticated/_organization/support-coordination/case-notes': typeof AuthenticatedOrganizationSupportCoordinationCaseNotesRoute
  '/_authenticated/_organization/support-coordination/compliance': typeof AuthenticatedOrganizationSupportCoordinationComplianceRoute
  '/_authenticated/_organization/support-coordination/emails': typeof AuthenticatedOrganizationSupportCoordinationEmailsRoute
  '/_authenticated/_organization/support-coordination/mailbox-settings': typeof AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute
  '/_authenticated/_organization/support-coordination/next-best-actions': typeof AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute
  '/_authenticated/_organization/support-coordination/notebook': typeof AuthenticatedOrganizationSupportCoordinationNotebookRoute
  '/_authenticated/_organization/support-coordination/planner': typeof AuthenticatedOrganizationSupportCoordinationPlannerRoute
  '/_authenticated/_organization/support-coordination/registers': typeof AuthenticatedOrganizationSupportCoordinationRegistersRoute
  '/_authenticated/_organization/support-coordination/reports': typeof AuthenticatedOrganizationSupportCoordinationReportsRoute
  '/_authenticated/_organization/support-coordination/scribe': typeof AuthenticatedOrganizationSupportCoordinationScribeRouteWithChildren
  '/_authenticated/_organization/support-coordination/telephony': typeof AuthenticatedOrganizationSupportCoordinationTelephonyRoute
  '/_authenticated/_organization/support-coordination/time-entries': typeof AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute
  '/_authenticated/_organization/support-plan-sign/$shareId': typeof AuthenticatedOrganizationSupportPlanSignShareIdRoute
  '/_authenticated/_organization/training/$programId': typeof AuthenticatedOrganizationTrainingProgramIdRoute
  '/_authenticated/_organization/workflows/$workflowId': typeof AuthenticatedOrganizationWorkflowsWorkflowIdRoute
  '/_authenticated/_organization/apps/': typeof AuthenticatedOrganizationAppsIndexRoute
  '/_authenticated/_organization/audit-logs/': typeof AuthenticatedOrganizationAuditLogsIndexRoute
  '/_authenticated/_organization/billing/': typeof AuthenticatedOrganizationBillingIndexRoute
  '/_authenticated/_organization/budget-calculator/': typeof AuthenticatedOrganizationBudgetCalculatorIndexRoute
  '/_authenticated/_organization/case-notes/': typeof AuthenticatedOrganizationCaseNotesIndexRoute
  '/_authenticated/_organization/caseload/': typeof AuthenticatedOrganizationCaseloadIndexRoute
  '/_authenticated/_organization/chats/': typeof AuthenticatedOrganizationChatsIndexRoute
  '/_authenticated/_organization/claims/': typeof AuthenticatedOrganizationClaimsIndexRoute
  '/_authenticated/_organization/clients/': typeof AuthenticatedOrganizationClientsIndexRoute
  '/_authenticated/_organization/compliance/': typeof AuthenticatedOrganizationComplianceIndexRoute
  '/_authenticated/_organization/documents/': typeof AuthenticatedOrganizationDocumentsIndexRoute
  '/_authenticated/_organization/expenses/': typeof AuthenticatedOrganizationExpensesIndexRoute
  '/_authenticated/_organization/extractions/': typeof AuthenticatedOrganizationExtractionsIndexRoute
  '/_authenticated/_organization/facilities/': typeof AuthenticatedOrganizationFacilitiesIndexRoute
  '/_authenticated/_organization/forms/': typeof AuthenticatedOrganizationFormsIndexRoute
  '/_authenticated/_organization/help-center/': typeof AuthenticatedOrganizationHelpCenterIndexRoute
  '/_authenticated/_organization/incidents/': typeof AuthenticatedOrganizationIncidentsIndexRoute
  '/_authenticated/_organization/invoices/': typeof AuthenticatedOrganizationInvoicesIndexRoute
  '/_authenticated/_organization/learn-hubshift/': typeof AuthenticatedOrganizationLearnHubshiftIndexRoute
  '/_authenticated/_organization/leave/': typeof AuthenticatedOrganizationLeaveIndexRoute
  '/_authenticated/_organization/my-agreements/': typeof AuthenticatedOrganizationMyAgreementsIndexRoute
  '/_authenticated/_organization/my-appointments/': typeof AuthenticatedOrganizationMyAppointmentsIndexRoute
  '/_authenticated/_organization/my-availability/': typeof AuthenticatedOrganizationMyAvailabilityIndexRoute
  '/_authenticated/_organization/my-complaints/': typeof AuthenticatedOrganizationMyComplaintsIndexRoute
  '/_authenticated/_organization/my-consent/': typeof AuthenticatedOrganizationMyConsentIndexRoute
  '/_authenticated/_organization/my-declarations/': typeof AuthenticatedOrganizationMyDeclarationsIndexRoute
  '/_authenticated/_organization/my-forms/': typeof AuthenticatedOrganizationMyFormsIndexRoute
  '/_authenticated/_organization/my-goals/': typeof AuthenticatedOrganizationMyGoalsIndexRoute
  '/_authenticated/_organization/my-inbox/': typeof AuthenticatedOrganizationMyInboxIndexRoute
  '/_authenticated/_organization/my-incident-reports/': typeof AuthenticatedOrganizationMyIncidentReportsIndexRoute
  '/_authenticated/_organization/my-incidents/': typeof AuthenticatedOrganizationMyIncidentsIndexRoute
  '/_authenticated/_organization/my-invoices/': typeof AuthenticatedOrganizationMyInvoicesIndexRoute
  '/_authenticated/_organization/my-onboarding/': typeof AuthenticatedOrganizationMyOnboardingIndexRoute
  '/_authenticated/_organization/my-participants/': typeof AuthenticatedOrganizationMyParticipantsIndexRoute
  '/_authenticated/_organization/my-people/': typeof AuthenticatedOrganizationMyPeopleIndexRoute
  '/_authenticated/_organization/my-plan/': typeof AuthenticatedOrganizationMyPlanIndexRoute
  '/_authenticated/_organization/my-shifts/': typeof AuthenticatedOrganizationMyShiftsIndexRoute
  '/_authenticated/_organization/my-support-team/': typeof AuthenticatedOrganizationMySupportTeamIndexRoute
  '/_authenticated/_organization/my-timesheets/': typeof AuthenticatedOrganizationMyTimesheetsIndexRoute
  '/_authenticated/_organization/ndis-standards/': typeof AuthenticatedOrganizationNdisStandardsIndexRoute
  '/_authenticated/_organization/notes/': typeof AuthenticatedOrganizationNotesIndexRoute
  '/_authenticated/_organization/notifications/': typeof AuthenticatedOrganizationNotificationsIndexRoute
  '/_authenticated/_organization/offboarding/': typeof AuthenticatedOrganizationOffboardingIndexRoute
  '/_authenticated/_organization/payroll/': typeof AuthenticatedOrganizationPayrollIndexRoute
  '/_authenticated/_organization/policies/': typeof AuthenticatedOrganizationPoliciesIndexRoute
  '/_authenticated/_organization/public-holidays/': typeof AuthenticatedOrganizationPublicHolidaysIndexRoute
  '/_authenticated/_organization/reconciliation/': typeof AuthenticatedOrganizationReconciliationIndexRoute
  '/_authenticated/_organization/referrals/': typeof AuthenticatedOrganizationReferralsIndexRoute
  '/_authenticated/_organization/reports/': typeof AuthenticatedOrganizationReportsIndexRoute
  '/_authenticated/_organization/roster/': typeof AuthenticatedOrganizationRosterIndexRoute
  '/_authenticated/_organization/scheduler/': typeof AuthenticatedOrganizationSchedulerIndexRoute
  '/_authenticated/_organization/staff/': typeof AuthenticatedOrganizationStaffIndexRoute
  '/_authenticated/_organization/support-coordination/': typeof AuthenticatedOrganizationSupportCoordinationIndexRoute
  '/_authenticated/_organization/tasks/': typeof AuthenticatedOrganizationTasksIndexRoute
  '/_authenticated/_organization/timesheets/': typeof AuthenticatedOrganizationTimesheetsIndexRoute
  '/_authenticated/_organization/training/': typeof AuthenticatedOrganizationTrainingIndexRoute
  '/_authenticated/_organization/upgrade/': typeof AuthenticatedOrganizationUpgradeIndexRoute
  '/_authenticated/_organization/users/': typeof AuthenticatedOrganizationUsersIndexRoute
  '/_authenticated/_organization/workflows/': typeof AuthenticatedOrganizationWorkflowsIndexRoute
  '/_authenticated/_organization/clients/$clientId/appointments': typeof AuthenticatedOrganizationClientsClientIdAppointmentsRoute
  '/_authenticated/_organization/clients/$clientId/audit-trail': typeof AuthenticatedOrganizationClientsClientIdAuditTrailRoute
  '/_authenticated/_organization/clients/$clientId/behaviour-support': typeof AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute
  '/_authenticated/_organization/clients/$clientId/care-plan': typeof AuthenticatedOrganizationClientsClientIdCarePlanRoute
  '/_authenticated/_organization/clients/$clientId/documents': typeof AuthenticatedOrganizationClientsClientIdDocumentsRoute
  '/_authenticated/_organization/clients/$clientId/evidence-packs': typeof AuthenticatedOrganizationClientsClientIdEvidencePacksRoute
  '/_authenticated/_organization/clients/$clientId/funding': typeof AuthenticatedOrganizationClientsClientIdFundingRoute
  '/_authenticated/_organization/clients/$clientId/goals': typeof AuthenticatedOrganizationClientsClientIdGoalsRoute
  '/_authenticated/_organization/clients/$clientId/ican': typeof AuthenticatedOrganizationClientsClientIdIcanRoute
  '/_authenticated/_organization/clients/$clientId/incidents': typeof AuthenticatedOrganizationClientsClientIdIncidentsRoute
  '/_authenticated/_organization/clients/$clientId/intake': typeof AuthenticatedOrganizationClientsClientIdIntakeRoute
  '/_authenticated/_organization/clients/$clientId/medications': typeof AuthenticatedOrganizationClientsClientIdMedicationsRoute
  '/_authenticated/_organization/clients/$clientId/notes': typeof AuthenticatedOrganizationClientsClientIdNotesRoute
  '/_authenticated/_organization/clients/$clientId/onboarding': typeof AuthenticatedOrganizationClientsClientIdOnboardingRoute
  '/_authenticated/_organization/clients/$clientId/overview': typeof AuthenticatedOrganizationClientsClientIdOverviewRoute
  '/_authenticated/_organization/clients/$clientId/profile': typeof AuthenticatedOrganizationClientsClientIdProfileRoute
  '/_authenticated/_organization/clients/$clientId/risk-profile': typeof AuthenticatedOrganizationClientsClientIdRiskProfileRoute
  '/_authenticated/_organization/clients/$clientId/schedules': typeof AuthenticatedOrganizationClientsClientIdSchedulesRoute
  '/_authenticated/_organization/clients/$clientId/service-agreement': typeof AuthenticatedOrganizationClientsClientIdServiceAgreementRoute
  '/_authenticated/_organization/clients/$clientId/stakeholders': typeof AuthenticatedOrganizationClientsClientIdStakeholdersRoute
  '/_authenticated/_organization/clients/$clientId/support-coordination': typeof AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute
  '/_authenticated/_organization/clients/$clientId/support-plan': typeof AuthenticatedOrganizationClientsClientIdSupportPlanRoute
  '/_authenticated/_organization/clients/$clientId/transitions': typeof AuthenticatedOrganizationClientsClientIdTransitionsRoute
  '/_authenticated/_organization/compliance/audits_/$auditId': typeof AuthenticatedOrganizationComplianceAuditsAuditIdRoute
  '/_authenticated/_organization/compliance/complaints/$complaintId': typeof AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute
  '/_authenticated/_organization/compliance/policies_/$policyId': typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute
  '/_authenticated/_organization/compliance/policy-pack/$runId': typeof AuthenticatedOrganizationCompliancePolicyPackRunIdRoute
  '/_authenticated/_organization/compliance/restrictive-practices/monthly-report': typeof AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute
  '/_authenticated/_organization/compliance/risks_/settings': typeof AuthenticatedOrganizationComplianceRisksSettingsRoute
  '/_authenticated/_organization/forms/$formId/edit': typeof AuthenticatedOrganizationFormsFormIdEditRoute
  '/_authenticated/_organization/forms/$formId/fill': typeof AuthenticatedOrganizationFormsFormIdFillRoute
  '/_authenticated/_organization/forms/$formId/preview': typeof AuthenticatedOrganizationFormsFormIdPreviewRoute
  '/_authenticated/_organization/incidents/$incidentId/edit': typeof AuthenticatedOrganizationIncidentsIncidentIdEditRoute
  '/_authenticated/_organization/incidents/reports/compliance': typeof AuthenticatedOrganizationIncidentsReportsComplianceRoute
  '/_authenticated/_organization/incidents/reports/executive-summary': typeof AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute
  '/_authenticated/_organization/incidents/reports/incident-mapping': typeof AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute
  '/_authenticated/_organization/incidents/reports/operational-performance': typeof AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute
  '/_authenticated/_organization/incidents/reports/trend-analysis': typeof AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute
  '/_authenticated/_organization/ndis-standards/complaints/$complaintId': typeof AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute
  '/_authenticated/_organization/onboarding/management/$memberId': typeof AuthenticatedOrganizationOnboardingManagementMemberIdRoute
  '/_authenticated/_organization/onboarding/management/pipeline': typeof AuthenticatedOrganizationOnboardingManagementPipelineRoute
  '/_authenticated/_organization/organizations/settings/agreement-sections': typeof AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute
  '/_authenticated/_organization/organizations/settings/ai-settings': typeof AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute
  '/_authenticated/_organization/organizations/settings/assistant-knowledge': typeof AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute
  '/_authenticated/_organization/organizations/settings/award-rates': typeof AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute
  '/_authenticated/_organization/organizations/settings/award-xero-mapping': typeof AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute
  '/_authenticated/_organization/organizations/settings/cancellation-policy': typeof AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute
  '/_authenticated/_organization/organizations/settings/client-document-types': typeof AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute
  '/_authenticated/_organization/organizations/settings/clock-in': typeof AuthenticatedOrganizationOrganizationsSettingsClockInRoute
  '/_authenticated/_organization/organizations/settings/compliance-profile': typeof AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute
  '/_authenticated/_organization/organizations/settings/data-migration': typeof AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute
  '/_authenticated/_organization/organizations/settings/document-types': typeof AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute
  '/_authenticated/_organization/organizations/settings/facilities': typeof AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute
  '/_authenticated/_organization/organizations/settings/go-live': typeof AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute
  '/_authenticated/_organization/organizations/settings/induction': typeof AuthenticatedOrganizationOrganizationsSettingsInductionRoute
  '/_authenticated/_organization/organizations/settings/integrations': typeof AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute
  '/_authenticated/_organization/organizations/settings/invoice-templates': typeof AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute
  '/_authenticated/_organization/organizations/settings/line-items': typeof AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute
  '/_authenticated/_organization/organizations/settings/members': typeof AuthenticatedOrganizationOrganizationsSettingsMembersRoute
  '/_authenticated/_organization/organizations/settings/notifications-config': typeof AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute
  '/_authenticated/_organization/organizations/settings/payroll': typeof AuthenticatedOrganizationOrganizationsSettingsPayrollRoute
  '/_authenticated/_organization/organizations/settings/permission-matrix': typeof AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute
  '/_authenticated/_organization/organizations/settings/privacy': typeof AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute
  '/_authenticated/_organization/organizations/settings/profile': typeof AuthenticatedOrganizationOrganizationsSettingsProfileRoute
  '/_authenticated/_organization/organizations/settings/public-holidays': typeof AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute
  '/_authenticated/_organization/organizations/settings/referral-intake': typeof AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute
  '/_authenticated/_organization/organizations/settings/regions': typeof AuthenticatedOrganizationOrganizationsSettingsRegionsRoute
  '/_authenticated/_organization/organizations/settings/reports-configuration': typeof AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute
  '/_authenticated/_organization/organizations/settings/roles': typeof AuthenticatedOrganizationOrganizationsSettingsRolesRoute
  '/_authenticated/_organization/organizations/settings/service-types': typeof AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute
  '/_authenticated/_organization/organizations/settings/terms-privacy': typeof AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute
  '/_authenticated/_organization/organizations/settings/travel': typeof AuthenticatedOrganizationOrganizationsSettingsTravelRoute
  '/_authenticated/_organization/partner/providers/$providerOrgId': typeof AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute
  '/_authenticated/_organization/partner/training/$templateId': typeof AuthenticatedOrganizationPartnerTrainingTemplateIdRoute
  '/_authenticated/_organization/scheduler/sil/$arrangementId': typeof AuthenticatedOrganizationSchedulerSilArrangementIdRoute
  '/_authenticated/_organization/scheduler/templates/$templateId': typeof AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute
  '/_authenticated/_organization/shifts/$shiftId/edit': typeof AuthenticatedOrganizationShiftsShiftIdEditRoute
  '/_authenticated/_organization/staff/$staffId/clients': typeof AuthenticatedOrganizationStaffStaffIdClientsRoute
  '/_authenticated/_organization/staff/$staffId/documents': typeof AuthenticatedOrganizationStaffStaffIdDocumentsRoute
  '/_authenticated/_organization/staff/$staffId/employment': typeof AuthenticatedOrganizationStaffStaffIdEmploymentRoute
  '/_authenticated/_organization/staff/$staffId/overview': typeof AuthenticatedOrganizationStaffStaffIdOverviewRoute
  '/_authenticated/_organization/staff/$staffId/payroll': typeof AuthenticatedOrganizationStaffStaffIdPayrollRoute
  '/_authenticated/_organization/staff/$staffId/performance': typeof AuthenticatedOrganizationStaffStaffIdPerformanceRoute
  '/_authenticated/_organization/staff/$staffId/profile': typeof AuthenticatedOrganizationStaffStaffIdProfileRoute
  '/_authenticated/_organization/staff/$staffId/roster': typeof AuthenticatedOrganizationStaffStaffIdRosterRoute
  '/_authenticated/_organization/staff/$staffId/work-rights': typeof AuthenticatedOrganizationStaffStaffIdWorkRightsRoute
  '/_authenticated/_organization/support-coordination/scribe/$noteId': typeof AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute
  '/_authenticated/_organization/tasks/boards/$boardId': typeof AuthenticatedOrganizationTasksBoardsBoardIdRoute
  '/_authenticated/_organization/clients/$clientId/': typeof AuthenticatedOrganizationClientsClientIdIndexRoute
  '/_authenticated/_organization/clients/teams/': typeof AuthenticatedOrganizationClientsTeamsIndexRoute
  '/_authenticated/_organization/compliance/complaints/': typeof AuthenticatedOrganizationComplianceComplaintsIndexRoute
  '/_authenticated/_organization/compliance/policy-pack/': typeof AuthenticatedOrganizationCompliancePolicyPackIndexRoute
  '/_authenticated/_organization/compliance/restrictive-practices/': typeof AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute
  '/_authenticated/_organization/incidents/$incidentId/': typeof AuthenticatedOrganizationIncidentsIncidentIdIndexRoute
  '/_authenticated/_organization/incidents/reports/': typeof AuthenticatedOrganizationIncidentsReportsIndexRoute
  '/_authenticated/_organization/ndis-standards/complaints/': typeof AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute
  '/_authenticated/_organization/onboarding/management/': typeof AuthenticatedOrganizationOnboardingManagementIndexRoute
  '/_authenticated/_organization/organizations/inductions/': typeof AuthenticatedOrganizationOrganizationsInductionsIndexRoute
  '/_authenticated/_organization/partner/library/': typeof AuthenticatedOrganizationPartnerLibraryIndexRoute
  '/_authenticated/_organization/partner/providers/': typeof AuthenticatedOrganizationPartnerProvidersIndexRoute
  '/_authenticated/_organization/partner/training/': typeof AuthenticatedOrganizationPartnerTrainingIndexRoute
  '/_authenticated/_organization/scheduler/sil/': typeof AuthenticatedOrganizationSchedulerSilIndexRoute
  '/_authenticated/_organization/scheduler/templates/': typeof AuthenticatedOrganizationSchedulerTemplatesIndexRoute
  '/_authenticated/_organization/staff/$staffId/': typeof AuthenticatedOrganizationStaffStaffIdIndexRoute
  '/_authenticated/_organization/staff/teams/': typeof AuthenticatedOrganizationStaffTeamsIndexRoute
  '/_authenticated/_organization/tasks/$taskId/': typeof AuthenticatedOrganizationTasksTaskIdIndexRoute
  '/_authenticated/_organization/tasks/boards/': typeof AuthenticatedOrganizationTasksBoardsIndexRoute
  '/_authenticated/_organization/forms/$formId/submissions/$submissionId': typeof AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute
  '/_authenticated/_organization/organizations/settings/progress-note-templates/$templateId': typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute
  '/_authenticated/_organization/organizations/settings/training-programs/$programId': typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute
  '/_authenticated/_organization/forms/$formId/submissions/': typeof AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute
  '/_authenticated/_organization/organizations/settings/progress-note-templates/': typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute
  '/_authenticated/_organization/organizations/settings/training-programs/': typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute
  '/_authenticated/_organization/compliance/policies_/$policyId_/redraft/$proposalId': typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/farewell'
    | '/otp'
    | '/setup-passkey'
    | '/settings'
    | '/change-password'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/two-factor'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/force-change-password'
    | '/get-the-app'
    | '/accept-invitation/$invitationId'
    | '/scheduler'
    | '/support-coordination'
    | '/care-plan-share/$token'
    | '/dev/chat-preview'
    | '/dev/mascot'
    | '/impersonate/$token'
    | '/migration-portal/$token'
    | '/onboarding-portal/$token'
    | '/shared-agreement/$token'
    | '/shared-document/$token'
    | '/sign-agreement/$token'
    | '/sign/$token'
    | '/sil-roc-share/$token'
    | '/support-plan-share/$token'
    | '/ai-gateway'
    | '/cross-org'
    | '/signatures'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/communication'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/security'
    | '/'
    | '/create-organization'
    | '/settings/'
    | '/incidents/reports'
    | '/organizations/settings'
    | '/shares/cross-org/$token'
    | '/apps/skeleton-demo'
    | '/budget-calculator/$calculationId'
    | '/budget-calculator/quick'
    | '/chats/$conversationId'
    | '/compliance/audits'
    | '/compliance/conflicts-of-interest'
    | '/compliance/findings'
    | '/compliance/gap-analysis'
    | '/compliance/hub'
    | '/compliance/partners'
    | '/compliance/policies'
    | '/compliance/risks'
    | '/compliance/standards'
    | '/demo/skeleton'
    | '/extractions/examples'
    | '/files/viewer'
    | '/forms/review-queue'
    | '/help-center/$ticketId'
    | '/incidents/knowledge-base'
    | '/incidents/new'
    | '/induction/$inductionId'
    | '/learn-hubshift/$templateKey'
    | '/my-shifts/$shiftId'
    | '/ndis-standards/audits'
    | '/ndis-standards/compliance'
    | '/ndis-standards/ican'
    | '/ndis-standards/knowledge-base'
    | '/ndis-standards/policies'
    | '/ndis-standards/reports'
    | '/onboarding/admin'
    | '/onboarding/client'
    | '/onboarding/preview'
    | '/onboarding/required-documents'
    | '/onboarding/staff'
    | '/payruns/$payRunId'
    | '/policies/audits'
    | '/referrals/$referralId'
    | '/reports/billable-charges'
    | '/reports/capacity'
    | '/reports/expired-documents'
    | '/reports/goal-achievement'
    | '/reports/my-billable-charges'
    | '/reports/my-billable-hours'
    | '/reports/my-billables'
    | '/reports/ndia-errors'
    | '/reports/overtime'
    | '/reports/participant-alerts'
    | '/reports/participant-birthdays'
    | '/reports/participant-goals'
    | '/reports/participant-plans'
    | '/reports/participant-records'
    | '/reports/participant-risks'
    | '/reports/participant-utilisation'
    | '/reports/participants-without-goals'
    | '/reports/participants-without-risks'
    | '/reports/preview'
    | '/reports/public-holiday-supports'
    | '/reports/recurring-shifts-expiring'
    | '/reports/service-delivery'
    | '/reports/shift-clashes'
    | '/reports/shift-tasks'
    | '/reports/shift-variance'
    | '/reports/shifts'
    | '/reports/staff-utilisation'
    | '/reports/support-cancellations'
    | '/reports/support-notes'
    | '/reports/supports'
    | '/reports/supports-without-notes'
    | '/reports/tasks'
    | '/reports/tasks-without-notes'
    | '/reports/team-billable-hours'
    | '/reports/team-billables'
    | '/reports/user-availability'
    | '/reports/user-records'
    | '/reports/voided-charges'
    | '/scheduler/alerts'
    | '/scheduler/all-shifts'
    | '/scheduler/availability-requests'
    | '/scheduler/clashes'
    | '/scheduler/overview'
    | '/scheduler/post-shift-review'
    | '/scheduler/progress-notes'
    | '/scheduler/review-queue'
    | '/scheduler/shift-requests'
    | '/shifts/new'
    | '/staff/compliance'
    | '/support-coordination/billing'
    | '/support-coordination/budget'
    | '/support-coordination/case-notes'
    | '/support-coordination/compliance'
    | '/support-coordination/emails'
    | '/support-coordination/mailbox-settings'
    | '/support-coordination/next-best-actions'
    | '/support-coordination/notebook'
    | '/support-coordination/planner'
    | '/support-coordination/registers'
    | '/support-coordination/reports'
    | '/support-coordination/scribe'
    | '/support-coordination/telephony'
    | '/support-coordination/time-entries'
    | '/support-plan-sign/$shareId'
    | '/training/$programId'
    | '/workflows/$workflowId'
    | '/apps'
    | '/audit-logs'
    | '/billing'
    | '/budget-calculator'
    | '/case-notes'
    | '/caseload'
    | '/chats'
    | '/claims'
    | '/clients'
    | '/compliance'
    | '/documents'
    | '/expenses'
    | '/extractions'
    | '/facilities'
    | '/forms'
    | '/help-center'
    | '/incidents'
    | '/invoices'
    | '/learn-hubshift'
    | '/leave'
    | '/my-agreements'
    | '/my-appointments'
    | '/my-availability'
    | '/my-complaints'
    | '/my-consent'
    | '/my-declarations'
    | '/my-forms'
    | '/my-goals'
    | '/my-inbox'
    | '/my-incident-reports'
    | '/my-incidents'
    | '/my-invoices'
    | '/my-onboarding'
    | '/my-participants'
    | '/my-people'
    | '/my-plan'
    | '/my-shifts'
    | '/my-support-team'
    | '/my-timesheets'
    | '/ndis-standards'
    | '/notes'
    | '/notifications'
    | '/offboarding'
    | '/payroll'
    | '/policies'
    | '/public-holidays'
    | '/reconciliation'
    | '/referrals'
    | '/reports'
    | '/roster'
    | '/scheduler/'
    | '/staff'
    | '/support-coordination/'
    | '/tasks'
    | '/timesheets'
    | '/training'
    | '/upgrade'
    | '/users'
    | '/workflows'
    | '/clients/$clientId/appointments'
    | '/clients/$clientId/audit-trail'
    | '/clients/$clientId/behaviour-support'
    | '/clients/$clientId/care-plan'
    | '/clients/$clientId/documents'
    | '/clients/$clientId/evidence-packs'
    | '/clients/$clientId/funding'
    | '/clients/$clientId/goals'
    | '/clients/$clientId/ican'
    | '/clients/$clientId/incidents'
    | '/clients/$clientId/intake'
    | '/clients/$clientId/medications'
    | '/clients/$clientId/notes'
    | '/clients/$clientId/onboarding'
    | '/clients/$clientId/overview'
    | '/clients/$clientId/profile'
    | '/clients/$clientId/risk-profile'
    | '/clients/$clientId/schedules'
    | '/clients/$clientId/service-agreement'
    | '/clients/$clientId/stakeholders'
    | '/clients/$clientId/support-coordination'
    | '/clients/$clientId/support-plan'
    | '/clients/$clientId/transitions'
    | '/compliance/audits/$auditId'
    | '/compliance/complaints/$complaintId'
    | '/compliance/policies/$policyId'
    | '/compliance/policy-pack/$runId'
    | '/compliance/restrictive-practices/monthly-report'
    | '/compliance/risks/settings'
    | '/forms/$formId/edit'
    | '/forms/$formId/fill'
    | '/forms/$formId/preview'
    | '/incidents/$incidentId/edit'
    | '/incidents/reports/compliance'
    | '/incidents/reports/executive-summary'
    | '/incidents/reports/incident-mapping'
    | '/incidents/reports/operational-performance'
    | '/incidents/reports/trend-analysis'
    | '/ndis-standards/complaints/$complaintId'
    | '/onboarding/management/$memberId'
    | '/onboarding/management/pipeline'
    | '/organizations/settings/agreement-sections'
    | '/organizations/settings/ai-settings'
    | '/organizations/settings/assistant-knowledge'
    | '/organizations/settings/award-rates'
    | '/organizations/settings/award-xero-mapping'
    | '/organizations/settings/cancellation-policy'
    | '/organizations/settings/client-document-types'
    | '/organizations/settings/clock-in'
    | '/organizations/settings/compliance-profile'
    | '/organizations/settings/data-migration'
    | '/organizations/settings/document-types'
    | '/organizations/settings/facilities'
    | '/organizations/settings/go-live'
    | '/organizations/settings/induction'
    | '/organizations/settings/integrations'
    | '/organizations/settings/invoice-templates'
    | '/organizations/settings/line-items'
    | '/organizations/settings/members'
    | '/organizations/settings/notifications-config'
    | '/organizations/settings/payroll'
    | '/organizations/settings/permission-matrix'
    | '/organizations/settings/privacy'
    | '/organizations/settings/profile'
    | '/organizations/settings/public-holidays'
    | '/organizations/settings/referral-intake'
    | '/organizations/settings/regions'
    | '/organizations/settings/reports-configuration'
    | '/organizations/settings/roles'
    | '/organizations/settings/service-types'
    | '/organizations/settings/terms-privacy'
    | '/organizations/settings/travel'
    | '/partner/providers/$providerOrgId'
    | '/partner/training/$templateId'
    | '/scheduler/sil/$arrangementId'
    | '/scheduler/templates/$templateId'
    | '/shifts/$shiftId/edit'
    | '/staff/$staffId/clients'
    | '/staff/$staffId/documents'
    | '/staff/$staffId/employment'
    | '/staff/$staffId/overview'
    | '/staff/$staffId/payroll'
    | '/staff/$staffId/performance'
    | '/staff/$staffId/profile'
    | '/staff/$staffId/roster'
    | '/staff/$staffId/work-rights'
    | '/support-coordination/scribe/$noteId'
    | '/tasks/boards/$boardId'
    | '/clients/$clientId'
    | '/clients/teams'
    | '/compliance/complaints'
    | '/compliance/policy-pack'
    | '/compliance/restrictive-practices'
    | '/incidents/$incidentId'
    | '/incidents/reports/'
    | '/ndis-standards/complaints'
    | '/onboarding/management'
    | '/organizations/inductions'
    | '/partner/library'
    | '/partner/providers'
    | '/partner/training'
    | '/scheduler/sil'
    | '/scheduler/templates'
    | '/staff/$staffId'
    | '/staff/teams'
    | '/tasks/$taskId'
    | '/tasks/boards'
    | '/forms/$formId/submissions/$submissionId'
    | '/organizations/settings/progress-note-templates/$templateId'
    | '/organizations/settings/training-programs/$programId'
    | '/forms/$formId/submissions'
    | '/organizations/settings/progress-note-templates'
    | '/organizations/settings/training-programs'
    | '/compliance/policies/$policyId/redraft/$proposalId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/farewell'
    | '/otp'
    | '/setup-passkey'
    | '/change-password'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/two-factor'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/force-change-password'
    | '/get-the-app'
    | '/accept-invitation/$invitationId'
    | '/care-plan-share/$token'
    | '/dev/chat-preview'
    | '/dev/mascot'
    | '/impersonate/$token'
    | '/migration-portal/$token'
    | '/onboarding-portal/$token'
    | '/shared-agreement/$token'
    | '/shared-document/$token'
    | '/sign-agreement/$token'
    | '/sign/$token'
    | '/sil-roc-share/$token'
    | '/support-plan-share/$token'
    | '/ai-gateway'
    | '/cross-org'
    | '/signatures'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/communication'
    | '/settings/integrations'
    | '/settings/notifications'
    | '/settings/security'
    | '/'
    | '/create-organization'
    | '/settings'
    | '/organizations/settings'
    | '/shares/cross-org/$token'
    | '/apps/skeleton-demo'
    | '/budget-calculator/$calculationId'
    | '/budget-calculator/quick'
    | '/chats/$conversationId'
    | '/compliance/audits'
    | '/compliance/conflicts-of-interest'
    | '/compliance/findings'
    | '/compliance/gap-analysis'
    | '/compliance/hub'
    | '/compliance/partners'
    | '/compliance/policies'
    | '/compliance/risks'
    | '/compliance/standards'
    | '/demo/skeleton'
    | '/extractions/examples'
    | '/files/viewer'
    | '/forms/review-queue'
    | '/help-center/$ticketId'
    | '/incidents/knowledge-base'
    | '/incidents/new'
    | '/induction/$inductionId'
    | '/learn-hubshift/$templateKey'
    | '/my-shifts/$shiftId'
    | '/ndis-standards/audits'
    | '/ndis-standards/compliance'
    | '/ndis-standards/ican'
    | '/ndis-standards/knowledge-base'
    | '/ndis-standards/policies'
    | '/ndis-standards/reports'
    | '/onboarding/admin'
    | '/onboarding/client'
    | '/onboarding/preview'
    | '/onboarding/required-documents'
    | '/onboarding/staff'
    | '/payruns/$payRunId'
    | '/policies/audits'
    | '/referrals/$referralId'
    | '/reports/billable-charges'
    | '/reports/capacity'
    | '/reports/expired-documents'
    | '/reports/goal-achievement'
    | '/reports/my-billable-charges'
    | '/reports/my-billable-hours'
    | '/reports/my-billables'
    | '/reports/ndia-errors'
    | '/reports/overtime'
    | '/reports/participant-alerts'
    | '/reports/participant-birthdays'
    | '/reports/participant-goals'
    | '/reports/participant-plans'
    | '/reports/participant-records'
    | '/reports/participant-risks'
    | '/reports/participant-utilisation'
    | '/reports/participants-without-goals'
    | '/reports/participants-without-risks'
    | '/reports/preview'
    | '/reports/public-holiday-supports'
    | '/reports/recurring-shifts-expiring'
    | '/reports/service-delivery'
    | '/reports/shift-clashes'
    | '/reports/shift-tasks'
    | '/reports/shift-variance'
    | '/reports/shifts'
    | '/reports/staff-utilisation'
    | '/reports/support-cancellations'
    | '/reports/support-notes'
    | '/reports/supports'
    | '/reports/supports-without-notes'
    | '/reports/tasks'
    | '/reports/tasks-without-notes'
    | '/reports/team-billable-hours'
    | '/reports/team-billables'
    | '/reports/user-availability'
    | '/reports/user-records'
    | '/reports/voided-charges'
    | '/scheduler/alerts'
    | '/scheduler/all-shifts'
    | '/scheduler/availability-requests'
    | '/scheduler/clashes'
    | '/scheduler/overview'
    | '/scheduler/post-shift-review'
    | '/scheduler/progress-notes'
    | '/scheduler/review-queue'
    | '/scheduler/shift-requests'
    | '/shifts/new'
    | '/staff/compliance'
    | '/support-coordination/billing'
    | '/support-coordination/budget'
    | '/support-coordination/case-notes'
    | '/support-coordination/compliance'
    | '/support-coordination/emails'
    | '/support-coordination/mailbox-settings'
    | '/support-coordination/next-best-actions'
    | '/support-coordination/notebook'
    | '/support-coordination/planner'
    | '/support-coordination/registers'
    | '/support-coordination/reports'
    | '/support-coordination/scribe'
    | '/support-coordination/telephony'
    | '/support-coordination/time-entries'
    | '/support-plan-sign/$shareId'
    | '/training/$programId'
    | '/workflows/$workflowId'
    | '/apps'
    | '/audit-logs'
    | '/billing'
    | '/budget-calculator'
    | '/case-notes'
    | '/caseload'
    | '/chats'
    | '/claims'
    | '/clients'
    | '/compliance'
    | '/documents'
    | '/expenses'
    | '/extractions'
    | '/facilities'
    | '/forms'
    | '/help-center'
    | '/incidents'
    | '/invoices'
    | '/learn-hubshift'
    | '/leave'
    | '/my-agreements'
    | '/my-appointments'
    | '/my-availability'
    | '/my-complaints'
    | '/my-consent'
    | '/my-declarations'
    | '/my-forms'
    | '/my-goals'
    | '/my-inbox'
    | '/my-incident-reports'
    | '/my-incidents'
    | '/my-invoices'
    | '/my-onboarding'
    | '/my-participants'
    | '/my-people'
    | '/my-plan'
    | '/my-shifts'
    | '/my-support-team'
    | '/my-timesheets'
    | '/ndis-standards'
    | '/notes'
    | '/notifications'
    | '/offboarding'
    | '/payroll'
    | '/policies'
    | '/public-holidays'
    | '/reconciliation'
    | '/referrals'
    | '/reports'
    | '/roster'
    | '/scheduler'
    | '/staff'
    | '/support-coordination'
    | '/tasks'
    | '/timesheets'
    | '/training'
    | '/upgrade'
    | '/users'
    | '/workflows'
    | '/clients/$clientId/appointments'
    | '/clients/$clientId/audit-trail'
    | '/clients/$clientId/behaviour-support'
    | '/clients/$clientId/care-plan'
    | '/clients/$clientId/documents'
    | '/clients/$clientId/evidence-packs'
    | '/clients/$clientId/funding'
    | '/clients/$clientId/goals'
    | '/clients/$clientId/ican'
    | '/clients/$clientId/incidents'
    | '/clients/$clientId/intake'
    | '/clients/$clientId/medications'
    | '/clients/$clientId/notes'
    | '/clients/$clientId/onboarding'
    | '/clients/$clientId/overview'
    | '/clients/$clientId/profile'
    | '/clients/$clientId/risk-profile'
    | '/clients/$clientId/schedules'
    | '/clients/$clientId/service-agreement'
    | '/clients/$clientId/stakeholders'
    | '/clients/$clientId/support-coordination'
    | '/clients/$clientId/support-plan'
    | '/clients/$clientId/transitions'
    | '/compliance/audits/$auditId'
    | '/compliance/complaints/$complaintId'
    | '/compliance/policies/$policyId'
    | '/compliance/policy-pack/$runId'
    | '/compliance/restrictive-practices/monthly-report'
    | '/compliance/risks/settings'
    | '/forms/$formId/edit'
    | '/forms/$formId/fill'
    | '/forms/$formId/preview'
    | '/incidents/$incidentId/edit'
    | '/incidents/reports/compliance'
    | '/incidents/reports/executive-summary'
    | '/incidents/reports/incident-mapping'
    | '/incidents/reports/operational-performance'
    | '/incidents/reports/trend-analysis'
    | '/ndis-standards/complaints/$complaintId'
    | '/onboarding/management/$memberId'
    | '/onboarding/management/pipeline'
    | '/organizations/settings/agreement-sections'
    | '/organizations/settings/ai-settings'
    | '/organizations/settings/assistant-knowledge'
    | '/organizations/settings/award-rates'
    | '/organizations/settings/award-xero-mapping'
    | '/organizations/settings/cancellation-policy'
    | '/organizations/settings/client-document-types'
    | '/organizations/settings/clock-in'
    | '/organizations/settings/compliance-profile'
    | '/organizations/settings/data-migration'
    | '/organizations/settings/document-types'
    | '/organizations/settings/facilities'
    | '/organizations/settings/go-live'
    | '/organizations/settings/induction'
    | '/organizations/settings/integrations'
    | '/organizations/settings/invoice-templates'
    | '/organizations/settings/line-items'
    | '/organizations/settings/members'
    | '/organizations/settings/notifications-config'
    | '/organizations/settings/payroll'
    | '/organizations/settings/permission-matrix'
    | '/organizations/settings/privacy'
    | '/organizations/settings/profile'
    | '/organizations/settings/public-holidays'
    | '/organizations/settings/referral-intake'
    | '/organizations/settings/regions'
    | '/organizations/settings/reports-configuration'
    | '/organizations/settings/roles'
    | '/organizations/settings/service-types'
    | '/organizations/settings/terms-privacy'
    | '/organizations/settings/travel'
    | '/partner/providers/$providerOrgId'
    | '/partner/training/$templateId'
    | '/scheduler/sil/$arrangementId'
    | '/scheduler/templates/$templateId'
    | '/shifts/$shiftId/edit'
    | '/staff/$staffId/clients'
    | '/staff/$staffId/documents'
    | '/staff/$staffId/employment'
    | '/staff/$staffId/overview'
    | '/staff/$staffId/payroll'
    | '/staff/$staffId/performance'
    | '/staff/$staffId/profile'
    | '/staff/$staffId/roster'
    | '/staff/$staffId/work-rights'
    | '/support-coordination/scribe/$noteId'
    | '/tasks/boards/$boardId'
    | '/clients/$clientId'
    | '/clients/teams'
    | '/compliance/complaints'
    | '/compliance/policy-pack'
    | '/compliance/restrictive-practices'
    | '/incidents/$incidentId'
    | '/incidents/reports'
    | '/ndis-standards/complaints'
    | '/onboarding/management'
    | '/organizations/inductions'
    | '/partner/library'
    | '/partner/providers'
    | '/partner/training'
    | '/scheduler/sil'
    | '/scheduler/templates'
    | '/staff/$staffId'
    | '/staff/teams'
    | '/tasks/$taskId'
    | '/tasks/boards'
    | '/forms/$formId/submissions/$submissionId'
    | '/organizations/settings/progress-note-templates/$templateId'
    | '/organizations/settings/training-programs/$programId'
    | '/forms/$formId/submissions'
    | '/organizations/settings/progress-note-templates'
    | '/organizations/settings/training-programs'
    | '/compliance/policies/$policyId/redraft/$proposalId'
  id:
    | '__root__'
    | '/(auth)'
    | '/_authenticated'
    | '/farewell'
    | '/otp'
    | '/setup-passkey'
    | '/_authenticated/_organization'
    | '/_authenticated/settings'
    | '/(auth)/change-password'
    | '/(auth)/forgot-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(auth)/two-factor'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/force-change-password'
    | '/_authenticated/get-the-app'
    | '/accept-invitation/$invitationId'
    | '/_authenticated/_organization/scheduler'
    | '/_authenticated/_organization/support-coordination'
    | '/(public)/care-plan-share/$token'
    | '/(public)/dev/chat-preview'
    | '/(public)/dev/mascot'
    | '/(public)/impersonate/$token'
    | '/(public)/migration-portal/$token'
    | '/(public)/onboarding-portal/$token'
    | '/(public)/shared-agreement/$token'
    | '/(public)/shared-document/$token'
    | '/(public)/sign-agreement/$token'
    | '/(public)/sign/$token'
    | '/(public)/sil-roc-share/$token'
    | '/(public)/support-plan-share/$token'
    | '/_authenticated/_organization/ai-gateway'
    | '/_authenticated/_organization/cross-org'
    | '/_authenticated/_organization/signatures'
    | '/_authenticated/errors/$error'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/communication'
    | '/_authenticated/settings/integrations'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/security'
    | '/_authenticated/_organization/'
    | '/_authenticated/create-organization/'
    | '/_authenticated/settings/'
    | '/_authenticated/_organization/incidents/reports'
    | '/_authenticated/_organization/organizations/settings'
    | '/(public)/shares/cross-org/$token'
    | '/_authenticated/_organization/apps/skeleton-demo'
    | '/_authenticated/_organization/budget-calculator/$calculationId'
    | '/_authenticated/_organization/budget-calculator/quick'
    | '/_authenticated/_organization/chats/$conversationId'
    | '/_authenticated/_organization/compliance/audits'
    | '/_authenticated/_organization/compliance/conflicts-of-interest'
    | '/_authenticated/_organization/compliance/findings'
    | '/_authenticated/_organization/compliance/gap-analysis'
    | '/_authenticated/_organization/compliance/hub'
    | '/_authenticated/_organization/compliance/partners'
    | '/_authenticated/_organization/compliance/policies'
    | '/_authenticated/_organization/compliance/risks'
    | '/_authenticated/_organization/compliance/standards'
    | '/_authenticated/_organization/demo/skeleton'
    | '/_authenticated/_organization/extractions/examples'
    | '/_authenticated/_organization/files/viewer'
    | '/_authenticated/_organization/forms/review-queue'
    | '/_authenticated/_organization/help-center/$ticketId'
    | '/_authenticated/_organization/incidents/knowledge-base'
    | '/_authenticated/_organization/incidents/new'
    | '/_authenticated/_organization/induction/$inductionId'
    | '/_authenticated/_organization/learn-hubshift/$templateKey'
    | '/_authenticated/_organization/my-shifts/$shiftId'
    | '/_authenticated/_organization/ndis-standards/audits'
    | '/_authenticated/_organization/ndis-standards/compliance'
    | '/_authenticated/_organization/ndis-standards/ican'
    | '/_authenticated/_organization/ndis-standards/knowledge-base'
    | '/_authenticated/_organization/ndis-standards/policies'
    | '/_authenticated/_organization/ndis-standards/reports'
    | '/_authenticated/_organization/onboarding/admin'
    | '/_authenticated/_organization/onboarding/client'
    | '/_authenticated/_organization/onboarding/preview'
    | '/_authenticated/_organization/onboarding/required-documents'
    | '/_authenticated/_organization/onboarding/staff'
    | '/_authenticated/_organization/payruns/$payRunId'
    | '/_authenticated/_organization/policies/audits'
    | '/_authenticated/_organization/referrals/$referralId'
    | '/_authenticated/_organization/reports/billable-charges'
    | '/_authenticated/_organization/reports/capacity'
    | '/_authenticated/_organization/reports/expired-documents'
    | '/_authenticated/_organization/reports/goal-achievement'
    | '/_authenticated/_organization/reports/my-billable-charges'
    | '/_authenticated/_organization/reports/my-billable-hours'
    | '/_authenticated/_organization/reports/my-billables'
    | '/_authenticated/_organization/reports/ndia-errors'
    | '/_authenticated/_organization/reports/overtime'
    | '/_authenticated/_organization/reports/participant-alerts'
    | '/_authenticated/_organization/reports/participant-birthdays'
    | '/_authenticated/_organization/reports/participant-goals'
    | '/_authenticated/_organization/reports/participant-plans'
    | '/_authenticated/_organization/reports/participant-records'
    | '/_authenticated/_organization/reports/participant-risks'
    | '/_authenticated/_organization/reports/participant-utilisation'
    | '/_authenticated/_organization/reports/participants-without-goals'
    | '/_authenticated/_organization/reports/participants-without-risks'
    | '/_authenticated/_organization/reports/preview'
    | '/_authenticated/_organization/reports/public-holiday-supports'
    | '/_authenticated/_organization/reports/recurring-shifts-expiring'
    | '/_authenticated/_organization/reports/service-delivery'
    | '/_authenticated/_organization/reports/shift-clashes'
    | '/_authenticated/_organization/reports/shift-tasks'
    | '/_authenticated/_organization/reports/shift-variance'
    | '/_authenticated/_organization/reports/shifts'
    | '/_authenticated/_organization/reports/staff-utilisation'
    | '/_authenticated/_organization/reports/support-cancellations'
    | '/_authenticated/_organization/reports/support-notes'
    | '/_authenticated/_organization/reports/supports'
    | '/_authenticated/_organization/reports/supports-without-notes'
    | '/_authenticated/_organization/reports/tasks'
    | '/_authenticated/_organization/reports/tasks-without-notes'
    | '/_authenticated/_organization/reports/team-billable-hours'
    | '/_authenticated/_organization/reports/team-billables'
    | '/_authenticated/_organization/reports/user-availability'
    | '/_authenticated/_organization/reports/user-records'
    | '/_authenticated/_organization/reports/voided-charges'
    | '/_authenticated/_organization/scheduler/alerts'
    | '/_authenticated/_organization/scheduler/all-shifts'
    | '/_authenticated/_organization/scheduler/availability-requests'
    | '/_authenticated/_organization/scheduler/clashes'
    | '/_authenticated/_organization/scheduler/overview'
    | '/_authenticated/_organization/scheduler/post-shift-review'
    | '/_authenticated/_organization/scheduler/progress-notes'
    | '/_authenticated/_organization/scheduler/review-queue'
    | '/_authenticated/_organization/scheduler/shift-requests'
    | '/_authenticated/_organization/shifts/new'
    | '/_authenticated/_organization/staff/compliance'
    | '/_authenticated/_organization/support-coordination/billing'
    | '/_authenticated/_organization/support-coordination/budget'
    | '/_authenticated/_organization/support-coordination/case-notes'
    | '/_authenticated/_organization/support-coordination/compliance'
    | '/_authenticated/_organization/support-coordination/emails'
    | '/_authenticated/_organization/support-coordination/mailbox-settings'
    | '/_authenticated/_organization/support-coordination/next-best-actions'
    | '/_authenticated/_organization/support-coordination/notebook'
    | '/_authenticated/_organization/support-coordination/planner'
    | '/_authenticated/_organization/support-coordination/registers'
    | '/_authenticated/_organization/support-coordination/reports'
    | '/_authenticated/_organization/support-coordination/scribe'
    | '/_authenticated/_organization/support-coordination/telephony'
    | '/_authenticated/_organization/support-coordination/time-entries'
    | '/_authenticated/_organization/support-plan-sign/$shareId'
    | '/_authenticated/_organization/training/$programId'
    | '/_authenticated/_organization/workflows/$workflowId'
    | '/_authenticated/_organization/apps/'
    | '/_authenticated/_organization/audit-logs/'
    | '/_authenticated/_organization/billing/'
    | '/_authenticated/_organization/budget-calculator/'
    | '/_authenticated/_organization/case-notes/'
    | '/_authenticated/_organization/caseload/'
    | '/_authenticated/_organization/chats/'
    | '/_authenticated/_organization/claims/'
    | '/_authenticated/_organization/clients/'
    | '/_authenticated/_organization/compliance/'
    | '/_authenticated/_organization/documents/'
    | '/_authenticated/_organization/expenses/'
    | '/_authenticated/_organization/extractions/'
    | '/_authenticated/_organization/facilities/'
    | '/_authenticated/_organization/forms/'
    | '/_authenticated/_organization/help-center/'
    | '/_authenticated/_organization/incidents/'
    | '/_authenticated/_organization/invoices/'
    | '/_authenticated/_organization/learn-hubshift/'
    | '/_authenticated/_organization/leave/'
    | '/_authenticated/_organization/my-agreements/'
    | '/_authenticated/_organization/my-appointments/'
    | '/_authenticated/_organization/my-availability/'
    | '/_authenticated/_organization/my-complaints/'
    | '/_authenticated/_organization/my-consent/'
    | '/_authenticated/_organization/my-declarations/'
    | '/_authenticated/_organization/my-forms/'
    | '/_authenticated/_organization/my-goals/'
    | '/_authenticated/_organization/my-inbox/'
    | '/_authenticated/_organization/my-incident-reports/'
    | '/_authenticated/_organization/my-incidents/'
    | '/_authenticated/_organization/my-invoices/'
    | '/_authenticated/_organization/my-onboarding/'
    | '/_authenticated/_organization/my-participants/'
    | '/_authenticated/_organization/my-people/'
    | '/_authenticated/_organization/my-plan/'
    | '/_authenticated/_organization/my-shifts/'
    | '/_authenticated/_organization/my-support-team/'
    | '/_authenticated/_organization/my-timesheets/'
    | '/_authenticated/_organization/ndis-standards/'
    | '/_authenticated/_organization/notes/'
    | '/_authenticated/_organization/notifications/'
    | '/_authenticated/_organization/offboarding/'
    | '/_authenticated/_organization/payroll/'
    | '/_authenticated/_organization/policies/'
    | '/_authenticated/_organization/public-holidays/'
    | '/_authenticated/_organization/reconciliation/'
    | '/_authenticated/_organization/referrals/'
    | '/_authenticated/_organization/reports/'
    | '/_authenticated/_organization/roster/'
    | '/_authenticated/_organization/scheduler/'
    | '/_authenticated/_organization/staff/'
    | '/_authenticated/_organization/support-coordination/'
    | '/_authenticated/_organization/tasks/'
    | '/_authenticated/_organization/timesheets/'
    | '/_authenticated/_organization/training/'
    | '/_authenticated/_organization/upgrade/'
    | '/_authenticated/_organization/users/'
    | '/_authenticated/_organization/workflows/'
    | '/_authenticated/_organization/clients/$clientId/appointments'
    | '/_authenticated/_organization/clients/$clientId/audit-trail'
    | '/_authenticated/_organization/clients/$clientId/behaviour-support'
    | '/_authenticated/_organization/clients/$clientId/care-plan'
    | '/_authenticated/_organization/clients/$clientId/documents'
    | '/_authenticated/_organization/clients/$clientId/evidence-packs'
    | '/_authenticated/_organization/clients/$clientId/funding'
    | '/_authenticated/_organization/clients/$clientId/goals'
    | '/_authenticated/_organization/clients/$clientId/ican'
    | '/_authenticated/_organization/clients/$clientId/incidents'
    | '/_authenticated/_organization/clients/$clientId/intake'
    | '/_authenticated/_organization/clients/$clientId/medications'
    | '/_authenticated/_organization/clients/$clientId/notes'
    | '/_authenticated/_organization/clients/$clientId/onboarding'
    | '/_authenticated/_organization/clients/$clientId/overview'
    | '/_authenticated/_organization/clients/$clientId/profile'
    | '/_authenticated/_organization/clients/$clientId/risk-profile'
    | '/_authenticated/_organization/clients/$clientId/schedules'
    | '/_authenticated/_organization/clients/$clientId/service-agreement'
    | '/_authenticated/_organization/clients/$clientId/stakeholders'
    | '/_authenticated/_organization/clients/$clientId/support-coordination'
    | '/_authenticated/_organization/clients/$clientId/support-plan'
    | '/_authenticated/_organization/clients/$clientId/transitions'
    | '/_authenticated/_organization/compliance/audits_/$auditId'
    | '/_authenticated/_organization/compliance/complaints/$complaintId'
    | '/_authenticated/_organization/compliance/policies_/$policyId'
    | '/_authenticated/_organization/compliance/policy-pack/$runId'
    | '/_authenticated/_organization/compliance/restrictive-practices/monthly-report'
    | '/_authenticated/_organization/compliance/risks_/settings'
    | '/_authenticated/_organization/forms/$formId/edit'
    | '/_authenticated/_organization/forms/$formId/fill'
    | '/_authenticated/_organization/forms/$formId/preview'
    | '/_authenticated/_organization/incidents/$incidentId/edit'
    | '/_authenticated/_organization/incidents/reports/compliance'
    | '/_authenticated/_organization/incidents/reports/executive-summary'
    | '/_authenticated/_organization/incidents/reports/incident-mapping'
    | '/_authenticated/_organization/incidents/reports/operational-performance'
    | '/_authenticated/_organization/incidents/reports/trend-analysis'
    | '/_authenticated/_organization/ndis-standards/complaints/$complaintId'
    | '/_authenticated/_organization/onboarding/management/$memberId'
    | '/_authenticated/_organization/onboarding/management/pipeline'
    | '/_authenticated/_organization/organizations/settings/agreement-sections'
    | '/_authenticated/_organization/organizations/settings/ai-settings'
    | '/_authenticated/_organization/organizations/settings/assistant-knowledge'
    | '/_authenticated/_organization/organizations/settings/award-rates'
    | '/_authenticated/_organization/organizations/settings/award-xero-mapping'
    | '/_authenticated/_organization/organizations/settings/cancellation-policy'
    | '/_authenticated/_organization/organizations/settings/client-document-types'
    | '/_authenticated/_organization/organizations/settings/clock-in'
    | '/_authenticated/_organization/organizations/settings/compliance-profile'
    | '/_authenticated/_organization/organizations/settings/data-migration'
    | '/_authenticated/_organization/organizations/settings/document-types'
    | '/_authenticated/_organization/organizations/settings/facilities'
    | '/_authenticated/_organization/organizations/settings/go-live'
    | '/_authenticated/_organization/organizations/settings/induction'
    | '/_authenticated/_organization/organizations/settings/integrations'
    | '/_authenticated/_organization/organizations/settings/invoice-templates'
    | '/_authenticated/_organization/organizations/settings/line-items'
    | '/_authenticated/_organization/organizations/settings/members'
    | '/_authenticated/_organization/organizations/settings/notifications-config'
    | '/_authenticated/_organization/organizations/settings/payroll'
    | '/_authenticated/_organization/organizations/settings/permission-matrix'
    | '/_authenticated/_organization/organizations/settings/privacy'
    | '/_authenticated/_organization/organizations/settings/profile'
    | '/_authenticated/_organization/organizations/settings/public-holidays'
    | '/_authenticated/_organization/organizations/settings/referral-intake'
    | '/_authenticated/_organization/organizations/settings/regions'
    | '/_authenticated/_organization/organizations/settings/reports-configuration'
    | '/_authenticated/_organization/organizations/settings/roles'
    | '/_authenticated/_organization/organizations/settings/service-types'
    | '/_authenticated/_organization/organizations/settings/terms-privacy'
    | '/_authenticated/_organization/organizations/settings/travel'
    | '/_authenticated/_organization/partner/providers/$providerOrgId'
    | '/_authenticated/_organization/partner/training/$templateId'
    | '/_authenticated/_organization/scheduler/sil/$arrangementId'
    | '/_authenticated/_organization/scheduler/templates/$templateId'
    | '/_authenticated/_organization/shifts/$shiftId/edit'
    | '/_authenticated/_organization/staff/$staffId/clients'
    | '/_authenticated/_organization/staff/$staffId/documents'
    | '/_authenticated/_organization/staff/$staffId/employment'
    | '/_authenticated/_organization/staff/$staffId/overview'
    | '/_authenticated/_organization/staff/$staffId/payroll'
    | '/_authenticated/_organization/staff/$staffId/performance'
    | '/_authenticated/_organization/staff/$staffId/profile'
    | '/_authenticated/_organization/staff/$staffId/roster'
    | '/_authenticated/_organization/staff/$staffId/work-rights'
    | '/_authenticated/_organization/support-coordination/scribe/$noteId'
    | '/_authenticated/_organization/tasks/boards/$boardId'
    | '/_authenticated/_organization/clients/$clientId/'
    | '/_authenticated/_organization/clients/teams/'
    | '/_authenticated/_organization/compliance/complaints/'
    | '/_authenticated/_organization/compliance/policy-pack/'
    | '/_authenticated/_organization/compliance/restrictive-practices/'
    | '/_authenticated/_organization/incidents/$incidentId/'
    | '/_authenticated/_organization/incidents/reports/'
    | '/_authenticated/_organization/ndis-standards/complaints/'
    | '/_authenticated/_organization/onboarding/management/'
    | '/_authenticated/_organization/organizations/inductions/'
    | '/_authenticated/_organization/partner/library/'
    | '/_authenticated/_organization/partner/providers/'
    | '/_authenticated/_organization/partner/training/'
    | '/_authenticated/_organization/scheduler/sil/'
    | '/_authenticated/_organization/scheduler/templates/'
    | '/_authenticated/_organization/staff/$staffId/'
    | '/_authenticated/_organization/staff/teams/'
    | '/_authenticated/_organization/tasks/$taskId/'
    | '/_authenticated/_organization/tasks/boards/'
    | '/_authenticated/_organization/forms/$formId/submissions/$submissionId'
    | '/_authenticated/_organization/organizations/settings/progress-note-templates/$templateId'
    | '/_authenticated/_organization/organizations/settings/training-programs/$programId'
    | '/_authenticated/_organization/forms/$formId/submissions/'
    | '/_authenticated/_organization/organizations/settings/progress-note-templates/'
    | '/_authenticated/_organization/organizations/settings/training-programs/'
    | '/_authenticated/_organization/compliance/policies_/$policyId_/redraft/$proposalId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  FarewellRoute: typeof FarewellRoute
  OtpRoute: typeof OtpRoute
  SetupPasskeyRoute: typeof SetupPasskeyRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  AcceptInvitationInvitationIdRoute: typeof AcceptInvitationInvitationIdRoute
  publicCarePlanShareTokenRoute: typeof publicCarePlanShareTokenRoute
  publicDevChatPreviewRoute: typeof publicDevChatPreviewRoute
  publicDevMascotRoute: typeof publicDevMascotRoute
  publicImpersonateTokenRoute: typeof publicImpersonateTokenRoute
  publicMigrationPortalTokenRoute: typeof publicMigrationPortalTokenRoute
  publicOnboardingPortalTokenRoute: typeof publicOnboardingPortalTokenRoute
  publicSharedAgreementTokenRoute: typeof publicSharedAgreementTokenRoute
  publicSharedDocumentTokenRoute: typeof publicSharedDocumentTokenRoute
  publicSignAgreementTokenRoute: typeof publicSignAgreementTokenRoute
  publicSignTokenRoute: typeof publicSignTokenRoute
  publicSilRocShareTokenRoute: typeof publicSilRocShareTokenRoute
  publicSupportPlanShareTokenRoute: typeof publicSupportPlanShareTokenRoute
  publicSharesCrossOrgTokenRoute: typeof publicSharesCrossOrgTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup-passkey': {
      id: '/setup-passkey'
      path: '/setup-passkey'
      fullPath: '/setup-passkey'
      preLoaderRoute: typeof SetupPasskeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp': {
      id: '/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof OtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/farewell': {
      id: '/farewell'
      path: '/farewell'
      fullPath: '/farewell'
      preLoaderRoute: typeof FarewellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation/$invitationId': {
      id: '/accept-invitation/$invitationId'
      path: '/accept-invitation/$invitationId'
      fullPath: '/accept-invitation/$invitationId'
      preLoaderRoute: typeof AcceptInvitationInvitationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/get-the-app': {
      id: '/_authenticated/get-the-app'
      path: '/get-the-app'
      fullPath: '/get-the-app'
      preLoaderRoute: typeof AuthenticatedGetTheAppRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/force-change-password': {
      id: '/_authenticated/force-change-password'
      path: '/force-change-password'
      fullPath: '/force-change-password'
      preLoaderRoute: typeof AuthenticatedForceChangePasswordRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/two-factor': {
      id: '/(auth)/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof authTwoFactorRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/change-password': {
      id: '/(auth)/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof authChangePasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_organization': {
      id: '/_authenticated/_organization'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOrganizationRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/create-organization/': {
      id: '/_authenticated/create-organization/'
      path: '/create-organization'
      fullPath: '/create-organization'
      preLoaderRoute: typeof AuthenticatedCreateOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_organization/': {
      id: '/_authenticated/_organization/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/integrations': {
      id: '/_authenticated/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthenticatedSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/communication': {
      id: '/_authenticated/settings/communication'
      path: '/communication'
      fullPath: '/settings/communication'
      preLoaderRoute: typeof AuthenticatedSettingsCommunicationRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/_organization/signatures': {
      id: '/_authenticated/_organization/signatures'
      path: '/signatures'
      fullPath: '/signatures'
      preLoaderRoute: typeof AuthenticatedOrganizationSignaturesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/cross-org': {
      id: '/_authenticated/_organization/cross-org'
      path: '/cross-org'
      fullPath: '/cross-org'
      preLoaderRoute: typeof AuthenticatedOrganizationCrossOrgRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ai-gateway': {
      id: '/_authenticated/_organization/ai-gateway'
      path: '/ai-gateway'
      fullPath: '/ai-gateway'
      preLoaderRoute: typeof AuthenticatedOrganizationAiGatewayRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/(public)/support-plan-share/$token': {
      id: '/(public)/support-plan-share/$token'
      path: '/support-plan-share/$token'
      fullPath: '/support-plan-share/$token'
      preLoaderRoute: typeof publicSupportPlanShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/sil-roc-share/$token': {
      id: '/(public)/sil-roc-share/$token'
      path: '/sil-roc-share/$token'
      fullPath: '/sil-roc-share/$token'
      preLoaderRoute: typeof publicSilRocShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/sign/$token': {
      id: '/(public)/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof publicSignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/sign-agreement/$token': {
      id: '/(public)/sign-agreement/$token'
      path: '/sign-agreement/$token'
      fullPath: '/sign-agreement/$token'
      preLoaderRoute: typeof publicSignAgreementTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/shared-document/$token': {
      id: '/(public)/shared-document/$token'
      path: '/shared-document/$token'
      fullPath: '/shared-document/$token'
      preLoaderRoute: typeof publicSharedDocumentTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/shared-agreement/$token': {
      id: '/(public)/shared-agreement/$token'
      path: '/shared-agreement/$token'
      fullPath: '/shared-agreement/$token'
      preLoaderRoute: typeof publicSharedAgreementTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/onboarding-portal/$token': {
      id: '/(public)/onboarding-portal/$token'
      path: '/onboarding-portal/$token'
      fullPath: '/onboarding-portal/$token'
      preLoaderRoute: typeof publicOnboardingPortalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/migration-portal/$token': {
      id: '/(public)/migration-portal/$token'
      path: '/migration-portal/$token'
      fullPath: '/migration-portal/$token'
      preLoaderRoute: typeof publicMigrationPortalTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/impersonate/$token': {
      id: '/(public)/impersonate/$token'
      path: '/impersonate/$token'
      fullPath: '/impersonate/$token'
      preLoaderRoute: typeof publicImpersonateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/dev/mascot': {
      id: '/(public)/dev/mascot'
      path: '/dev/mascot'
      fullPath: '/dev/mascot'
      preLoaderRoute: typeof publicDevMascotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/dev/chat-preview': {
      id: '/(public)/dev/chat-preview'
      path: '/dev/chat-preview'
      fullPath: '/dev/chat-preview'
      preLoaderRoute: typeof publicDevChatPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/care-plan-share/$token': {
      id: '/(public)/care-plan-share/$token'
      path: '/care-plan-share/$token'
      fullPath: '/care-plan-share/$token'
      preLoaderRoute: typeof publicCarePlanShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_organization/support-coordination': {
      id: '/_authenticated/_organization/support-coordination'
      path: '/support-coordination'
      fullPath: '/support-coordination'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/scheduler': {
      id: '/_authenticated/_organization/scheduler'
      path: '/scheduler'
      fullPath: '/scheduler'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/workflows/': {
      id: '/_authenticated/_organization/workflows/'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof AuthenticatedOrganizationWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/users/': {
      id: '/_authenticated/_organization/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedOrganizationUsersIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/upgrade/': {
      id: '/_authenticated/_organization/upgrade/'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthenticatedOrganizationUpgradeIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/training/': {
      id: '/_authenticated/_organization/training/'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthenticatedOrganizationTrainingIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/timesheets/': {
      id: '/_authenticated/_organization/timesheets/'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AuthenticatedOrganizationTimesheetsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/tasks/': {
      id: '/_authenticated/_organization/tasks/'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AuthenticatedOrganizationTasksIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/': {
      id: '/_authenticated/_organization/support-coordination/'
      path: '/'
      fullPath: '/support-coordination/'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/staff/': {
      id: '/_authenticated/_organization/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/scheduler/': {
      id: '/_authenticated/_organization/scheduler/'
      path: '/'
      fullPath: '/scheduler/'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/roster/': {
      id: '/_authenticated/_organization/roster/'
      path: '/roster'
      fullPath: '/roster'
      preLoaderRoute: typeof AuthenticatedOrganizationRosterIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/': {
      id: '/_authenticated/_organization/reports/'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/referrals/': {
      id: '/_authenticated/_organization/referrals/'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedOrganizationReferralsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reconciliation/': {
      id: '/_authenticated/_organization/reconciliation/'
      path: '/reconciliation'
      fullPath: '/reconciliation'
      preLoaderRoute: typeof AuthenticatedOrganizationReconciliationIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/public-holidays/': {
      id: '/_authenticated/_organization/public-holidays/'
      path: '/public-holidays'
      fullPath: '/public-holidays'
      preLoaderRoute: typeof AuthenticatedOrganizationPublicHolidaysIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/policies/': {
      id: '/_authenticated/_organization/policies/'
      path: '/policies'
      fullPath: '/policies'
      preLoaderRoute: typeof AuthenticatedOrganizationPoliciesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/payroll/': {
      id: '/_authenticated/_organization/payroll/'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AuthenticatedOrganizationPayrollIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/offboarding/': {
      id: '/_authenticated/_organization/offboarding/'
      path: '/offboarding'
      fullPath: '/offboarding'
      preLoaderRoute: typeof AuthenticatedOrganizationOffboardingIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/notifications/': {
      id: '/_authenticated/_organization/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedOrganizationNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/notes/': {
      id: '/_authenticated/_organization/notes/'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AuthenticatedOrganizationNotesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/': {
      id: '/_authenticated/_organization/ndis-standards/'
      path: '/ndis-standards'
      fullPath: '/ndis-standards'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-timesheets/': {
      id: '/_authenticated/_organization/my-timesheets/'
      path: '/my-timesheets'
      fullPath: '/my-timesheets'
      preLoaderRoute: typeof AuthenticatedOrganizationMyTimesheetsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-support-team/': {
      id: '/_authenticated/_organization/my-support-team/'
      path: '/my-support-team'
      fullPath: '/my-support-team'
      preLoaderRoute: typeof AuthenticatedOrganizationMySupportTeamIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-shifts/': {
      id: '/_authenticated/_organization/my-shifts/'
      path: '/my-shifts'
      fullPath: '/my-shifts'
      preLoaderRoute: typeof AuthenticatedOrganizationMyShiftsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-plan/': {
      id: '/_authenticated/_organization/my-plan/'
      path: '/my-plan'
      fullPath: '/my-plan'
      preLoaderRoute: typeof AuthenticatedOrganizationMyPlanIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-people/': {
      id: '/_authenticated/_organization/my-people/'
      path: '/my-people'
      fullPath: '/my-people'
      preLoaderRoute: typeof AuthenticatedOrganizationMyPeopleIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-participants/': {
      id: '/_authenticated/_organization/my-participants/'
      path: '/my-participants'
      fullPath: '/my-participants'
      preLoaderRoute: typeof AuthenticatedOrganizationMyParticipantsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-onboarding/': {
      id: '/_authenticated/_organization/my-onboarding/'
      path: '/my-onboarding'
      fullPath: '/my-onboarding'
      preLoaderRoute: typeof AuthenticatedOrganizationMyOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-invoices/': {
      id: '/_authenticated/_organization/my-invoices/'
      path: '/my-invoices'
      fullPath: '/my-invoices'
      preLoaderRoute: typeof AuthenticatedOrganizationMyInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-incidents/': {
      id: '/_authenticated/_organization/my-incidents/'
      path: '/my-incidents'
      fullPath: '/my-incidents'
      preLoaderRoute: typeof AuthenticatedOrganizationMyIncidentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-incident-reports/': {
      id: '/_authenticated/_organization/my-incident-reports/'
      path: '/my-incident-reports'
      fullPath: '/my-incident-reports'
      preLoaderRoute: typeof AuthenticatedOrganizationMyIncidentReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-inbox/': {
      id: '/_authenticated/_organization/my-inbox/'
      path: '/my-inbox'
      fullPath: '/my-inbox'
      preLoaderRoute: typeof AuthenticatedOrganizationMyInboxIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-goals/': {
      id: '/_authenticated/_organization/my-goals/'
      path: '/my-goals'
      fullPath: '/my-goals'
      preLoaderRoute: typeof AuthenticatedOrganizationMyGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-forms/': {
      id: '/_authenticated/_organization/my-forms/'
      path: '/my-forms'
      fullPath: '/my-forms'
      preLoaderRoute: typeof AuthenticatedOrganizationMyFormsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-declarations/': {
      id: '/_authenticated/_organization/my-declarations/'
      path: '/my-declarations'
      fullPath: '/my-declarations'
      preLoaderRoute: typeof AuthenticatedOrganizationMyDeclarationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-consent/': {
      id: '/_authenticated/_organization/my-consent/'
      path: '/my-consent'
      fullPath: '/my-consent'
      preLoaderRoute: typeof AuthenticatedOrganizationMyConsentIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-complaints/': {
      id: '/_authenticated/_organization/my-complaints/'
      path: '/my-complaints'
      fullPath: '/my-complaints'
      preLoaderRoute: typeof AuthenticatedOrganizationMyComplaintsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-availability/': {
      id: '/_authenticated/_organization/my-availability/'
      path: '/my-availability'
      fullPath: '/my-availability'
      preLoaderRoute: typeof AuthenticatedOrganizationMyAvailabilityIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-appointments/': {
      id: '/_authenticated/_organization/my-appointments/'
      path: '/my-appointments'
      fullPath: '/my-appointments'
      preLoaderRoute: typeof AuthenticatedOrganizationMyAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-agreements/': {
      id: '/_authenticated/_organization/my-agreements/'
      path: '/my-agreements'
      fullPath: '/my-agreements'
      preLoaderRoute: typeof AuthenticatedOrganizationMyAgreementsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/leave/': {
      id: '/_authenticated/_organization/leave/'
      path: '/leave'
      fullPath: '/leave'
      preLoaderRoute: typeof AuthenticatedOrganizationLeaveIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/learn-hubshift/': {
      id: '/_authenticated/_organization/learn-hubshift/'
      path: '/learn-hubshift'
      fullPath: '/learn-hubshift'
      preLoaderRoute: typeof AuthenticatedOrganizationLearnHubshiftIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/invoices/': {
      id: '/_authenticated/_organization/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedOrganizationInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/incidents/': {
      id: '/_authenticated/_organization/incidents/'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/help-center/': {
      id: '/_authenticated/_organization/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedOrganizationHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/forms/': {
      id: '/_authenticated/_organization/forms/'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/facilities/': {
      id: '/_authenticated/_organization/facilities/'
      path: '/facilities'
      fullPath: '/facilities'
      preLoaderRoute: typeof AuthenticatedOrganizationFacilitiesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/extractions/': {
      id: '/_authenticated/_organization/extractions/'
      path: '/extractions'
      fullPath: '/extractions'
      preLoaderRoute: typeof AuthenticatedOrganizationExtractionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/expenses/': {
      id: '/_authenticated/_organization/expenses/'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof AuthenticatedOrganizationExpensesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/documents/': {
      id: '/_authenticated/_organization/documents/'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedOrganizationDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/': {
      id: '/_authenticated/_organization/compliance/'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/': {
      id: '/_authenticated/_organization/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/claims/': {
      id: '/_authenticated/_organization/claims/'
      path: '/claims'
      fullPath: '/claims'
      preLoaderRoute: typeof AuthenticatedOrganizationClaimsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/chats/': {
      id: '/_authenticated/_organization/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AuthenticatedOrganizationChatsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/caseload/': {
      id: '/_authenticated/_organization/caseload/'
      path: '/caseload'
      fullPath: '/caseload'
      preLoaderRoute: typeof AuthenticatedOrganizationCaseloadIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/case-notes/': {
      id: '/_authenticated/_organization/case-notes/'
      path: '/case-notes'
      fullPath: '/case-notes'
      preLoaderRoute: typeof AuthenticatedOrganizationCaseNotesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/budget-calculator/': {
      id: '/_authenticated/_organization/budget-calculator/'
      path: '/budget-calculator'
      fullPath: '/budget-calculator'
      preLoaderRoute: typeof AuthenticatedOrganizationBudgetCalculatorIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/billing/': {
      id: '/_authenticated/_organization/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationBillingIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/audit-logs/': {
      id: '/_authenticated/_organization/audit-logs/'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuthenticatedOrganizationAuditLogsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/apps/': {
      id: '/_authenticated/_organization/apps/'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedOrganizationAppsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/workflows/$workflowId': {
      id: '/_authenticated/_organization/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof AuthenticatedOrganizationWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/training/$programId': {
      id: '/_authenticated/_organization/training/$programId'
      path: '/training/$programId'
      fullPath: '/training/$programId'
      preLoaderRoute: typeof AuthenticatedOrganizationTrainingProgramIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/support-plan-sign/$shareId': {
      id: '/_authenticated/_organization/support-plan-sign/$shareId'
      path: '/support-plan-sign/$shareId'
      fullPath: '/support-plan-sign/$shareId'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportPlanSignShareIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/time-entries': {
      id: '/_authenticated/_organization/support-coordination/time-entries'
      path: '/time-entries'
      fullPath: '/support-coordination/time-entries'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationTimeEntriesRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/telephony': {
      id: '/_authenticated/_organization/support-coordination/telephony'
      path: '/telephony'
      fullPath: '/support-coordination/telephony'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationTelephonyRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/scribe': {
      id: '/_authenticated/_organization/support-coordination/scribe'
      path: '/scribe'
      fullPath: '/support-coordination/scribe'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationScribeRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/reports': {
      id: '/_authenticated/_organization/support-coordination/reports'
      path: '/reports'
      fullPath: '/support-coordination/reports'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationReportsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/registers': {
      id: '/_authenticated/_organization/support-coordination/registers'
      path: '/registers'
      fullPath: '/support-coordination/registers'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationRegistersRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/planner': {
      id: '/_authenticated/_organization/support-coordination/planner'
      path: '/planner'
      fullPath: '/support-coordination/planner'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationPlannerRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/notebook': {
      id: '/_authenticated/_organization/support-coordination/notebook'
      path: '/notebook'
      fullPath: '/support-coordination/notebook'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationNotebookRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/next-best-actions': {
      id: '/_authenticated/_organization/support-coordination/next-best-actions'
      path: '/next-best-actions'
      fullPath: '/support-coordination/next-best-actions'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationNextBestActionsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/mailbox-settings': {
      id: '/_authenticated/_organization/support-coordination/mailbox-settings'
      path: '/mailbox-settings'
      fullPath: '/support-coordination/mailbox-settings'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationMailboxSettingsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/emails': {
      id: '/_authenticated/_organization/support-coordination/emails'
      path: '/emails'
      fullPath: '/support-coordination/emails'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationEmailsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/compliance': {
      id: '/_authenticated/_organization/support-coordination/compliance'
      path: '/compliance'
      fullPath: '/support-coordination/compliance'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationComplianceRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/case-notes': {
      id: '/_authenticated/_organization/support-coordination/case-notes'
      path: '/case-notes'
      fullPath: '/support-coordination/case-notes'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationCaseNotesRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/budget': {
      id: '/_authenticated/_organization/support-coordination/budget'
      path: '/budget'
      fullPath: '/support-coordination/budget'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationBudgetRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/billing': {
      id: '/_authenticated/_organization/support-coordination/billing'
      path: '/billing'
      fullPath: '/support-coordination/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationBillingRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRoute
    }
    '/_authenticated/_organization/staff/compliance': {
      id: '/_authenticated/_organization/staff/compliance'
      path: '/staff/compliance'
      fullPath: '/staff/compliance'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffComplianceRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/shifts/new': {
      id: '/_authenticated/_organization/shifts/new'
      path: '/shifts/new'
      fullPath: '/shifts/new'
      preLoaderRoute: typeof AuthenticatedOrganizationShiftsNewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/scheduler/shift-requests': {
      id: '/_authenticated/_organization/scheduler/shift-requests'
      path: '/shift-requests'
      fullPath: '/scheduler/shift-requests'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerShiftRequestsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/review-queue': {
      id: '/_authenticated/_organization/scheduler/review-queue'
      path: '/review-queue'
      fullPath: '/scheduler/review-queue'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerReviewQueueRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/progress-notes': {
      id: '/_authenticated/_organization/scheduler/progress-notes'
      path: '/progress-notes'
      fullPath: '/scheduler/progress-notes'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerProgressNotesRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/post-shift-review': {
      id: '/_authenticated/_organization/scheduler/post-shift-review'
      path: '/post-shift-review'
      fullPath: '/scheduler/post-shift-review'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerPostShiftReviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/overview': {
      id: '/_authenticated/_organization/scheduler/overview'
      path: '/overview'
      fullPath: '/scheduler/overview'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerOverviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/clashes': {
      id: '/_authenticated/_organization/scheduler/clashes'
      path: '/clashes'
      fullPath: '/scheduler/clashes'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerClashesRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/availability-requests': {
      id: '/_authenticated/_organization/scheduler/availability-requests'
      path: '/availability-requests'
      fullPath: '/scheduler/availability-requests'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerAvailabilityRequestsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/all-shifts': {
      id: '/_authenticated/_organization/scheduler/all-shifts'
      path: '/all-shifts'
      fullPath: '/scheduler/all-shifts'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerAllShiftsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/alerts': {
      id: '/_authenticated/_organization/scheduler/alerts'
      path: '/alerts'
      fullPath: '/scheduler/alerts'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerAlertsRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/reports/voided-charges': {
      id: '/_authenticated/_organization/reports/voided-charges'
      path: '/reports/voided-charges'
      fullPath: '/reports/voided-charges'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsVoidedChargesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/user-records': {
      id: '/_authenticated/_organization/reports/user-records'
      path: '/reports/user-records'
      fullPath: '/reports/user-records'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsUserRecordsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/user-availability': {
      id: '/_authenticated/_organization/reports/user-availability'
      path: '/reports/user-availability'
      fullPath: '/reports/user-availability'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsUserAvailabilityRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/team-billables': {
      id: '/_authenticated/_organization/reports/team-billables'
      path: '/reports/team-billables'
      fullPath: '/reports/team-billables'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsTeamBillablesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/team-billable-hours': {
      id: '/_authenticated/_organization/reports/team-billable-hours'
      path: '/reports/team-billable-hours'
      fullPath: '/reports/team-billable-hours'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsTeamBillableHoursRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/tasks-without-notes': {
      id: '/_authenticated/_organization/reports/tasks-without-notes'
      path: '/reports/tasks-without-notes'
      fullPath: '/reports/tasks-without-notes'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsTasksWithoutNotesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/tasks': {
      id: '/_authenticated/_organization/reports/tasks'
      path: '/reports/tasks'
      fullPath: '/reports/tasks'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsTasksRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/supports-without-notes': {
      id: '/_authenticated/_organization/reports/supports-without-notes'
      path: '/reports/supports-without-notes'
      fullPath: '/reports/supports-without-notes'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsSupportsWithoutNotesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/supports': {
      id: '/_authenticated/_organization/reports/supports'
      path: '/reports/supports'
      fullPath: '/reports/supports'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsSupportsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/support-notes': {
      id: '/_authenticated/_organization/reports/support-notes'
      path: '/reports/support-notes'
      fullPath: '/reports/support-notes'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsSupportNotesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/support-cancellations': {
      id: '/_authenticated/_organization/reports/support-cancellations'
      path: '/reports/support-cancellations'
      fullPath: '/reports/support-cancellations'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsSupportCancellationsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/staff-utilisation': {
      id: '/_authenticated/_organization/reports/staff-utilisation'
      path: '/reports/staff-utilisation'
      fullPath: '/reports/staff-utilisation'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsStaffUtilisationRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/shifts': {
      id: '/_authenticated/_organization/reports/shifts'
      path: '/reports/shifts'
      fullPath: '/reports/shifts'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsShiftsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/shift-variance': {
      id: '/_authenticated/_organization/reports/shift-variance'
      path: '/reports/shift-variance'
      fullPath: '/reports/shift-variance'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsShiftVarianceRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/shift-tasks': {
      id: '/_authenticated/_organization/reports/shift-tasks'
      path: '/reports/shift-tasks'
      fullPath: '/reports/shift-tasks'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsShiftTasksRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/shift-clashes': {
      id: '/_authenticated/_organization/reports/shift-clashes'
      path: '/reports/shift-clashes'
      fullPath: '/reports/shift-clashes'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsShiftClashesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/service-delivery': {
      id: '/_authenticated/_organization/reports/service-delivery'
      path: '/reports/service-delivery'
      fullPath: '/reports/service-delivery'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsServiceDeliveryRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/recurring-shifts-expiring': {
      id: '/_authenticated/_organization/reports/recurring-shifts-expiring'
      path: '/reports/recurring-shifts-expiring'
      fullPath: '/reports/recurring-shifts-expiring'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsRecurringShiftsExpiringRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/public-holiday-supports': {
      id: '/_authenticated/_organization/reports/public-holiday-supports'
      path: '/reports/public-holiday-supports'
      fullPath: '/reports/public-holiday-supports'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsPublicHolidaySupportsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/preview': {
      id: '/_authenticated/_organization/reports/preview'
      path: '/reports/preview'
      fullPath: '/reports/preview'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsPreviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participants-without-risks': {
      id: '/_authenticated/_organization/reports/participants-without-risks'
      path: '/reports/participants-without-risks'
      fullPath: '/reports/participants-without-risks'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantsWithoutRisksRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participants-without-goals': {
      id: '/_authenticated/_organization/reports/participants-without-goals'
      path: '/reports/participants-without-goals'
      fullPath: '/reports/participants-without-goals'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantsWithoutGoalsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-utilisation': {
      id: '/_authenticated/_organization/reports/participant-utilisation'
      path: '/reports/participant-utilisation'
      fullPath: '/reports/participant-utilisation'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantUtilisationRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-risks': {
      id: '/_authenticated/_organization/reports/participant-risks'
      path: '/reports/participant-risks'
      fullPath: '/reports/participant-risks'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantRisksRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-records': {
      id: '/_authenticated/_organization/reports/participant-records'
      path: '/reports/participant-records'
      fullPath: '/reports/participant-records'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantRecordsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-plans': {
      id: '/_authenticated/_organization/reports/participant-plans'
      path: '/reports/participant-plans'
      fullPath: '/reports/participant-plans'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantPlansRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-goals': {
      id: '/_authenticated/_organization/reports/participant-goals'
      path: '/reports/participant-goals'
      fullPath: '/reports/participant-goals'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantGoalsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-birthdays': {
      id: '/_authenticated/_organization/reports/participant-birthdays'
      path: '/reports/participant-birthdays'
      fullPath: '/reports/participant-birthdays'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantBirthdaysRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/participant-alerts': {
      id: '/_authenticated/_organization/reports/participant-alerts'
      path: '/reports/participant-alerts'
      fullPath: '/reports/participant-alerts'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsParticipantAlertsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/overtime': {
      id: '/_authenticated/_organization/reports/overtime'
      path: '/reports/overtime'
      fullPath: '/reports/overtime'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsOvertimeRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/ndia-errors': {
      id: '/_authenticated/_organization/reports/ndia-errors'
      path: '/reports/ndia-errors'
      fullPath: '/reports/ndia-errors'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsNdiaErrorsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/my-billables': {
      id: '/_authenticated/_organization/reports/my-billables'
      path: '/reports/my-billables'
      fullPath: '/reports/my-billables'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsMyBillablesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/my-billable-hours': {
      id: '/_authenticated/_organization/reports/my-billable-hours'
      path: '/reports/my-billable-hours'
      fullPath: '/reports/my-billable-hours'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsMyBillableHoursRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/my-billable-charges': {
      id: '/_authenticated/_organization/reports/my-billable-charges'
      path: '/reports/my-billable-charges'
      fullPath: '/reports/my-billable-charges'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsMyBillableChargesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/goal-achievement': {
      id: '/_authenticated/_organization/reports/goal-achievement'
      path: '/reports/goal-achievement'
      fullPath: '/reports/goal-achievement'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsGoalAchievementRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/expired-documents': {
      id: '/_authenticated/_organization/reports/expired-documents'
      path: '/reports/expired-documents'
      fullPath: '/reports/expired-documents'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsExpiredDocumentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/capacity': {
      id: '/_authenticated/_organization/reports/capacity'
      path: '/reports/capacity'
      fullPath: '/reports/capacity'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsCapacityRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/reports/billable-charges': {
      id: '/_authenticated/_organization/reports/billable-charges'
      path: '/reports/billable-charges'
      fullPath: '/reports/billable-charges'
      preLoaderRoute: typeof AuthenticatedOrganizationReportsBillableChargesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/referrals/$referralId': {
      id: '/_authenticated/_organization/referrals/$referralId'
      path: '/referrals/$referralId'
      fullPath: '/referrals/$referralId'
      preLoaderRoute: typeof AuthenticatedOrganizationReferralsReferralIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/policies/audits': {
      id: '/_authenticated/_organization/policies/audits'
      path: '/policies/audits'
      fullPath: '/policies/audits'
      preLoaderRoute: typeof AuthenticatedOrganizationPoliciesAuditsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/payruns/$payRunId': {
      id: '/_authenticated/_organization/payruns/$payRunId'
      path: '/payruns/$payRunId'
      fullPath: '/payruns/$payRunId'
      preLoaderRoute: typeof AuthenticatedOrganizationPayrunsPayRunIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/staff': {
      id: '/_authenticated/_organization/onboarding/staff'
      path: '/onboarding/staff'
      fullPath: '/onboarding/staff'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingStaffRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/required-documents': {
      id: '/_authenticated/_organization/onboarding/required-documents'
      path: '/onboarding/required-documents'
      fullPath: '/onboarding/required-documents'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingRequiredDocumentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/preview': {
      id: '/_authenticated/_organization/onboarding/preview'
      path: '/onboarding/preview'
      fullPath: '/onboarding/preview'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingPreviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/client': {
      id: '/_authenticated/_organization/onboarding/client'
      path: '/onboarding/client'
      fullPath: '/onboarding/client'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingClientRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/admin': {
      id: '/_authenticated/_organization/onboarding/admin'
      path: '/onboarding/admin'
      fullPath: '/onboarding/admin'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingAdminRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/reports': {
      id: '/_authenticated/_organization/ndis-standards/reports'
      path: '/ndis-standards/reports'
      fullPath: '/ndis-standards/reports'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsReportsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/policies': {
      id: '/_authenticated/_organization/ndis-standards/policies'
      path: '/ndis-standards/policies'
      fullPath: '/ndis-standards/policies'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsPoliciesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/knowledge-base': {
      id: '/_authenticated/_organization/ndis-standards/knowledge-base'
      path: '/ndis-standards/knowledge-base'
      fullPath: '/ndis-standards/knowledge-base'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsKnowledgeBaseRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/ican': {
      id: '/_authenticated/_organization/ndis-standards/ican'
      path: '/ndis-standards/ican'
      fullPath: '/ndis-standards/ican'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsIcanRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/compliance': {
      id: '/_authenticated/_organization/ndis-standards/compliance'
      path: '/ndis-standards/compliance'
      fullPath: '/ndis-standards/compliance'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsComplianceRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/audits': {
      id: '/_authenticated/_organization/ndis-standards/audits'
      path: '/ndis-standards/audits'
      fullPath: '/ndis-standards/audits'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsAuditsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/my-shifts/$shiftId': {
      id: '/_authenticated/_organization/my-shifts/$shiftId'
      path: '/my-shifts/$shiftId'
      fullPath: '/my-shifts/$shiftId'
      preLoaderRoute: typeof AuthenticatedOrganizationMyShiftsShiftIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/learn-hubshift/$templateKey': {
      id: '/_authenticated/_organization/learn-hubshift/$templateKey'
      path: '/learn-hubshift/$templateKey'
      fullPath: '/learn-hubshift/$templateKey'
      preLoaderRoute: typeof AuthenticatedOrganizationLearnHubshiftTemplateKeyRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/induction/$inductionId': {
      id: '/_authenticated/_organization/induction/$inductionId'
      path: '/induction/$inductionId'
      fullPath: '/induction/$inductionId'
      preLoaderRoute: typeof AuthenticatedOrganizationInductionInductionIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/incidents/new': {
      id: '/_authenticated/_organization/incidents/new'
      path: '/incidents/new'
      fullPath: '/incidents/new'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsNewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/incidents/knowledge-base': {
      id: '/_authenticated/_organization/incidents/knowledge-base'
      path: '/incidents/knowledge-base'
      fullPath: '/incidents/knowledge-base'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsKnowledgeBaseRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/help-center/$ticketId': {
      id: '/_authenticated/_organization/help-center/$ticketId'
      path: '/help-center/$ticketId'
      fullPath: '/help-center/$ticketId'
      preLoaderRoute: typeof AuthenticatedOrganizationHelpCenterTicketIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/forms/review-queue': {
      id: '/_authenticated/_organization/forms/review-queue'
      path: '/forms/review-queue'
      fullPath: '/forms/review-queue'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsReviewQueueRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/files/viewer': {
      id: '/_authenticated/_organization/files/viewer'
      path: '/files/viewer'
      fullPath: '/files/viewer'
      preLoaderRoute: typeof AuthenticatedOrganizationFilesViewerRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/extractions/examples': {
      id: '/_authenticated/_organization/extractions/examples'
      path: '/extractions/examples'
      fullPath: '/extractions/examples'
      preLoaderRoute: typeof AuthenticatedOrganizationExtractionsExamplesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/demo/skeleton': {
      id: '/_authenticated/_organization/demo/skeleton'
      path: '/demo/skeleton'
      fullPath: '/demo/skeleton'
      preLoaderRoute: typeof AuthenticatedOrganizationDemoSkeletonRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/standards': {
      id: '/_authenticated/_organization/compliance/standards'
      path: '/compliance/standards'
      fullPath: '/compliance/standards'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceStandardsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/risks': {
      id: '/_authenticated/_organization/compliance/risks'
      path: '/compliance/risks'
      fullPath: '/compliance/risks'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceRisksRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/policies': {
      id: '/_authenticated/_organization/compliance/policies'
      path: '/compliance/policies'
      fullPath: '/compliance/policies'
      preLoaderRoute: typeof AuthenticatedOrganizationCompliancePoliciesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/partners': {
      id: '/_authenticated/_organization/compliance/partners'
      path: '/compliance/partners'
      fullPath: '/compliance/partners'
      preLoaderRoute: typeof AuthenticatedOrganizationCompliancePartnersRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/hub': {
      id: '/_authenticated/_organization/compliance/hub'
      path: '/compliance/hub'
      fullPath: '/compliance/hub'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceHubRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/gap-analysis': {
      id: '/_authenticated/_organization/compliance/gap-analysis'
      path: '/compliance/gap-analysis'
      fullPath: '/compliance/gap-analysis'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceGapAnalysisRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/findings': {
      id: '/_authenticated/_organization/compliance/findings'
      path: '/compliance/findings'
      fullPath: '/compliance/findings'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceFindingsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/conflicts-of-interest': {
      id: '/_authenticated/_organization/compliance/conflicts-of-interest'
      path: '/compliance/conflicts-of-interest'
      fullPath: '/compliance/conflicts-of-interest'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceConflictsOfInterestRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/audits': {
      id: '/_authenticated/_organization/compliance/audits'
      path: '/compliance/audits'
      fullPath: '/compliance/audits'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceAuditsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/chats/$conversationId': {
      id: '/_authenticated/_organization/chats/$conversationId'
      path: '/chats/$conversationId'
      fullPath: '/chats/$conversationId'
      preLoaderRoute: typeof AuthenticatedOrganizationChatsConversationIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/budget-calculator/quick': {
      id: '/_authenticated/_organization/budget-calculator/quick'
      path: '/budget-calculator/quick'
      fullPath: '/budget-calculator/quick'
      preLoaderRoute: typeof AuthenticatedOrganizationBudgetCalculatorQuickRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/budget-calculator/$calculationId': {
      id: '/_authenticated/_organization/budget-calculator/$calculationId'
      path: '/budget-calculator/$calculationId'
      fullPath: '/budget-calculator/$calculationId'
      preLoaderRoute: typeof AuthenticatedOrganizationBudgetCalculatorCalculationIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/apps/skeleton-demo': {
      id: '/_authenticated/_organization/apps/skeleton-demo'
      path: '/apps/skeleton-demo'
      fullPath: '/apps/skeleton-demo'
      preLoaderRoute: typeof AuthenticatedOrganizationAppsSkeletonDemoRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/(public)/shares/cross-org/$token': {
      id: '/(public)/shares/cross-org/$token'
      path: '/shares/cross-org/$token'
      fullPath: '/shares/cross-org/$token'
      preLoaderRoute: typeof publicSharesCrossOrgTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_organization/organizations/settings': {
      id: '/_authenticated/_organization/organizations/settings'
      path: '/organizations/settings'
      fullPath: '/organizations/settings'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/incidents/reports': {
      id: '/_authenticated/_organization/incidents/reports'
      path: '/incidents/reports'
      fullPath: '/incidents/reports'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/tasks/boards/': {
      id: '/_authenticated/_organization/tasks/boards/'
      path: '/tasks/boards'
      fullPath: '/tasks/boards'
      preLoaderRoute: typeof AuthenticatedOrganizationTasksBoardsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/tasks/$taskId/': {
      id: '/_authenticated/_organization/tasks/$taskId/'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedOrganizationTasksTaskIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/teams/': {
      id: '/_authenticated/_organization/staff/teams/'
      path: '/staff/teams'
      fullPath: '/staff/teams'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffTeamsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/': {
      id: '/_authenticated/_organization/staff/$staffId/'
      path: '/staff/$staffId'
      fullPath: '/staff/$staffId'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/scheduler/templates/': {
      id: '/_authenticated/_organization/scheduler/templates/'
      path: '/templates'
      fullPath: '/scheduler/templates'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/sil/': {
      id: '/_authenticated/_organization/scheduler/sil/'
      path: '/sil'
      fullPath: '/scheduler/sil'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerSilIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/partner/training/': {
      id: '/_authenticated/_organization/partner/training/'
      path: '/partner/training'
      fullPath: '/partner/training'
      preLoaderRoute: typeof AuthenticatedOrganizationPartnerTrainingIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/partner/providers/': {
      id: '/_authenticated/_organization/partner/providers/'
      path: '/partner/providers'
      fullPath: '/partner/providers'
      preLoaderRoute: typeof AuthenticatedOrganizationPartnerProvidersIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/partner/library/': {
      id: '/_authenticated/_organization/partner/library/'
      path: '/partner/library'
      fullPath: '/partner/library'
      preLoaderRoute: typeof AuthenticatedOrganizationPartnerLibraryIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/organizations/inductions/': {
      id: '/_authenticated/_organization/organizations/inductions/'
      path: '/organizations/inductions'
      fullPath: '/organizations/inductions'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsInductionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/management/': {
      id: '/_authenticated/_organization/onboarding/management/'
      path: '/onboarding/management'
      fullPath: '/onboarding/management'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingManagementIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/complaints/': {
      id: '/_authenticated/_organization/ndis-standards/complaints/'
      path: '/ndis-standards/complaints'
      fullPath: '/ndis-standards/complaints'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsComplaintsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/incidents/reports/': {
      id: '/_authenticated/_organization/incidents/reports/'
      path: '/'
      fullPath: '/incidents/reports/'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRoute
    }
    '/_authenticated/_organization/incidents/$incidentId/': {
      id: '/_authenticated/_organization/incidents/$incidentId/'
      path: '/incidents/$incidentId'
      fullPath: '/incidents/$incidentId'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsIncidentIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/restrictive-practices/': {
      id: '/_authenticated/_organization/compliance/restrictive-practices/'
      path: '/compliance/restrictive-practices'
      fullPath: '/compliance/restrictive-practices'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceRestrictivePracticesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/policy-pack/': {
      id: '/_authenticated/_organization/compliance/policy-pack/'
      path: '/compliance/policy-pack'
      fullPath: '/compliance/policy-pack'
      preLoaderRoute: typeof AuthenticatedOrganizationCompliancePolicyPackIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/complaints/': {
      id: '/_authenticated/_organization/compliance/complaints/'
      path: '/compliance/complaints'
      fullPath: '/compliance/complaints'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceComplaintsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/teams/': {
      id: '/_authenticated/_organization/clients/teams/'
      path: '/clients/teams'
      fullPath: '/clients/teams'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsTeamsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/': {
      id: '/_authenticated/_organization/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/tasks/boards/$boardId': {
      id: '/_authenticated/_organization/tasks/boards/$boardId'
      path: '/tasks/boards/$boardId'
      fullPath: '/tasks/boards/$boardId'
      preLoaderRoute: typeof AuthenticatedOrganizationTasksBoardsBoardIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/support-coordination/scribe/$noteId': {
      id: '/_authenticated/_organization/support-coordination/scribe/$noteId'
      path: '/$noteId'
      fullPath: '/support-coordination/scribe/$noteId'
      preLoaderRoute: typeof AuthenticatedOrganizationSupportCoordinationScribeNoteIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationSupportCoordinationScribeRoute
    }
    '/_authenticated/_organization/staff/$staffId/work-rights': {
      id: '/_authenticated/_organization/staff/$staffId/work-rights'
      path: '/staff/$staffId/work-rights'
      fullPath: '/staff/$staffId/work-rights'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdWorkRightsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/roster': {
      id: '/_authenticated/_organization/staff/$staffId/roster'
      path: '/staff/$staffId/roster'
      fullPath: '/staff/$staffId/roster'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdRosterRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/profile': {
      id: '/_authenticated/_organization/staff/$staffId/profile'
      path: '/staff/$staffId/profile'
      fullPath: '/staff/$staffId/profile'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdProfileRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/performance': {
      id: '/_authenticated/_organization/staff/$staffId/performance'
      path: '/staff/$staffId/performance'
      fullPath: '/staff/$staffId/performance'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdPerformanceRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/payroll': {
      id: '/_authenticated/_organization/staff/$staffId/payroll'
      path: '/staff/$staffId/payroll'
      fullPath: '/staff/$staffId/payroll'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdPayrollRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/overview': {
      id: '/_authenticated/_organization/staff/$staffId/overview'
      path: '/staff/$staffId/overview'
      fullPath: '/staff/$staffId/overview'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdOverviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/employment': {
      id: '/_authenticated/_organization/staff/$staffId/employment'
      path: '/staff/$staffId/employment'
      fullPath: '/staff/$staffId/employment'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdEmploymentRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/documents': {
      id: '/_authenticated/_organization/staff/$staffId/documents'
      path: '/staff/$staffId/documents'
      fullPath: '/staff/$staffId/documents'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/staff/$staffId/clients': {
      id: '/_authenticated/_organization/staff/$staffId/clients'
      path: '/staff/$staffId/clients'
      fullPath: '/staff/$staffId/clients'
      preLoaderRoute: typeof AuthenticatedOrganizationStaffStaffIdClientsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/shifts/$shiftId/edit': {
      id: '/_authenticated/_organization/shifts/$shiftId/edit'
      path: '/shifts/$shiftId/edit'
      fullPath: '/shifts/$shiftId/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationShiftsShiftIdEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/scheduler/templates/$templateId': {
      id: '/_authenticated/_organization/scheduler/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/scheduler/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/scheduler/sil/$arrangementId': {
      id: '/_authenticated/_organization/scheduler/sil/$arrangementId'
      path: '/sil/$arrangementId'
      fullPath: '/scheduler/sil/$arrangementId'
      preLoaderRoute: typeof AuthenticatedOrganizationSchedulerSilArrangementIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationSchedulerRouteRoute
    }
    '/_authenticated/_organization/partner/training/$templateId': {
      id: '/_authenticated/_organization/partner/training/$templateId'
      path: '/partner/training/$templateId'
      fullPath: '/partner/training/$templateId'
      preLoaderRoute: typeof AuthenticatedOrganizationPartnerTrainingTemplateIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/partner/providers/$providerOrgId': {
      id: '/_authenticated/_organization/partner/providers/$providerOrgId'
      path: '/partner/providers/$providerOrgId'
      fullPath: '/partner/providers/$providerOrgId'
      preLoaderRoute: typeof AuthenticatedOrganizationPartnerProvidersProviderOrgIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/travel': {
      id: '/_authenticated/_organization/organizations/settings/travel'
      path: '/travel'
      fullPath: '/organizations/settings/travel'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTravelRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/terms-privacy': {
      id: '/_authenticated/_organization/organizations/settings/terms-privacy'
      path: '/terms-privacy'
      fullPath: '/organizations/settings/terms-privacy'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/service-types': {
      id: '/_authenticated/_organization/organizations/settings/service-types'
      path: '/service-types'
      fullPath: '/organizations/settings/service-types'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsServiceTypesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/roles': {
      id: '/_authenticated/_organization/organizations/settings/roles'
      path: '/roles'
      fullPath: '/organizations/settings/roles'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRolesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/reports-configuration': {
      id: '/_authenticated/_organization/organizations/settings/reports-configuration'
      path: '/reports-configuration'
      fullPath: '/organizations/settings/reports-configuration'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/regions': {
      id: '/_authenticated/_organization/organizations/settings/regions'
      path: '/regions'
      fullPath: '/organizations/settings/regions'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRegionsRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/referral-intake': {
      id: '/_authenticated/_organization/organizations/settings/referral-intake'
      path: '/referral-intake'
      fullPath: '/organizations/settings/referral-intake'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/public-holidays': {
      id: '/_authenticated/_organization/organizations/settings/public-holidays'
      path: '/public-holidays'
      fullPath: '/organizations/settings/public-holidays'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/profile': {
      id: '/_authenticated/_organization/organizations/settings/profile'
      path: '/profile'
      fullPath: '/organizations/settings/profile'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/privacy': {
      id: '/_authenticated/_organization/organizations/settings/privacy'
      path: '/privacy'
      fullPath: '/organizations/settings/privacy'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPrivacyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/permission-matrix': {
      id: '/_authenticated/_organization/organizations/settings/permission-matrix'
      path: '/permission-matrix'
      fullPath: '/organizations/settings/permission-matrix'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/payroll': {
      id: '/_authenticated/_organization/organizations/settings/payroll'
      path: '/payroll'
      fullPath: '/organizations/settings/payroll'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPayrollRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/notifications-config': {
      id: '/_authenticated/_organization/organizations/settings/notifications-config'
      path: '/notifications-config'
      fullPath: '/organizations/settings/notifications-config'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/members': {
      id: '/_authenticated/_organization/organizations/settings/members'
      path: '/members'
      fullPath: '/organizations/settings/members'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/line-items': {
      id: '/_authenticated/_organization/organizations/settings/line-items'
      path: '/line-items'
      fullPath: '/organizations/settings/line-items'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsLineItemsRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/invoice-templates': {
      id: '/_authenticated/_organization/organizations/settings/invoice-templates'
      path: '/invoice-templates'
      fullPath: '/organizations/settings/invoice-templates'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/integrations': {
      id: '/_authenticated/_organization/organizations/settings/integrations'
      path: '/integrations'
      fullPath: '/organizations/settings/integrations'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/induction': {
      id: '/_authenticated/_organization/organizations/settings/induction'
      path: '/induction'
      fullPath: '/organizations/settings/induction'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsInductionRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/go-live': {
      id: '/_authenticated/_organization/organizations/settings/go-live'
      path: '/go-live'
      fullPath: '/organizations/settings/go-live'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsGoLiveRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/facilities': {
      id: '/_authenticated/_organization/organizations/settings/facilities'
      path: '/facilities'
      fullPath: '/organizations/settings/facilities'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsFacilitiesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/document-types': {
      id: '/_authenticated/_organization/organizations/settings/document-types'
      path: '/document-types'
      fullPath: '/organizations/settings/document-types'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/data-migration': {
      id: '/_authenticated/_organization/organizations/settings/data-migration'
      path: '/data-migration'
      fullPath: '/organizations/settings/data-migration'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsDataMigrationRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/compliance-profile': {
      id: '/_authenticated/_organization/organizations/settings/compliance-profile'
      path: '/compliance-profile'
      fullPath: '/organizations/settings/compliance-profile'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/clock-in': {
      id: '/_authenticated/_organization/organizations/settings/clock-in'
      path: '/clock-in'
      fullPath: '/organizations/settings/clock-in'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsClockInRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/client-document-types': {
      id: '/_authenticated/_organization/organizations/settings/client-document-types'
      path: '/client-document-types'
      fullPath: '/organizations/settings/client-document-types'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/cancellation-policy': {
      id: '/_authenticated/_organization/organizations/settings/cancellation-policy'
      path: '/cancellation-policy'
      fullPath: '/organizations/settings/cancellation-policy'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/award-xero-mapping': {
      id: '/_authenticated/_organization/organizations/settings/award-xero-mapping'
      path: '/award-xero-mapping'
      fullPath: '/organizations/settings/award-xero-mapping'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/award-rates': {
      id: '/_authenticated/_organization/organizations/settings/award-rates'
      path: '/award-rates'
      fullPath: '/organizations/settings/award-rates'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAwardRatesRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/assistant-knowledge': {
      id: '/_authenticated/_organization/organizations/settings/assistant-knowledge'
      path: '/assistant-knowledge'
      fullPath: '/organizations/settings/assistant-knowledge'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/ai-settings': {
      id: '/_authenticated/_organization/organizations/settings/ai-settings'
      path: '/ai-settings'
      fullPath: '/organizations/settings/ai-settings'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAiSettingsRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/agreement-sections': {
      id: '/_authenticated/_organization/organizations/settings/agreement-sections'
      path: '/agreement-sections'
      fullPath: '/organizations/settings/agreement-sections'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/onboarding/management/pipeline': {
      id: '/_authenticated/_organization/onboarding/management/pipeline'
      path: '/onboarding/management/pipeline'
      fullPath: '/onboarding/management/pipeline'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingManagementPipelineRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/onboarding/management/$memberId': {
      id: '/_authenticated/_organization/onboarding/management/$memberId'
      path: '/onboarding/management/$memberId'
      fullPath: '/onboarding/management/$memberId'
      preLoaderRoute: typeof AuthenticatedOrganizationOnboardingManagementMemberIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/ndis-standards/complaints/$complaintId': {
      id: '/_authenticated/_organization/ndis-standards/complaints/$complaintId'
      path: '/ndis-standards/complaints/$complaintId'
      fullPath: '/ndis-standards/complaints/$complaintId'
      preLoaderRoute: typeof AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/incidents/reports/trend-analysis': {
      id: '/_authenticated/_organization/incidents/reports/trend-analysis'
      path: '/trend-analysis'
      fullPath: '/incidents/reports/trend-analysis'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsTrendAnalysisRouteImport
      parentRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRoute
    }
    '/_authenticated/_organization/incidents/reports/operational-performance': {
      id: '/_authenticated/_organization/incidents/reports/operational-performance'
      path: '/operational-performance'
      fullPath: '/incidents/reports/operational-performance'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRouteImport
      parentRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRoute
    }
    '/_authenticated/_organization/incidents/reports/incident-mapping': {
      id: '/_authenticated/_organization/incidents/reports/incident-mapping'
      path: '/incident-mapping'
      fullPath: '/incidents/reports/incident-mapping'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsIncidentMappingRouteImport
      parentRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRoute
    }
    '/_authenticated/_organization/incidents/reports/executive-summary': {
      id: '/_authenticated/_organization/incidents/reports/executive-summary'
      path: '/executive-summary'
      fullPath: '/incidents/reports/executive-summary'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRouteImport
      parentRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRoute
    }
    '/_authenticated/_organization/incidents/reports/compliance': {
      id: '/_authenticated/_organization/incidents/reports/compliance'
      path: '/compliance'
      fullPath: '/incidents/reports/compliance'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsReportsComplianceRouteImport
      parentRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRoute
    }
    '/_authenticated/_organization/incidents/$incidentId/edit': {
      id: '/_authenticated/_organization/incidents/$incidentId/edit'
      path: '/incidents/$incidentId/edit'
      fullPath: '/incidents/$incidentId/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationIncidentsIncidentIdEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/forms/$formId/preview': {
      id: '/_authenticated/_organization/forms/$formId/preview'
      path: '/forms/$formId/preview'
      fullPath: '/forms/$formId/preview'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsFormIdPreviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/forms/$formId/fill': {
      id: '/_authenticated/_organization/forms/$formId/fill'
      path: '/forms/$formId/fill'
      fullPath: '/forms/$formId/fill'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsFormIdFillRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/forms/$formId/edit': {
      id: '/_authenticated/_organization/forms/$formId/edit'
      path: '/forms/$formId/edit'
      fullPath: '/forms/$formId/edit'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsFormIdEditRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/risks_/settings': {
      id: '/_authenticated/_organization/compliance/risks_/settings'
      path: '/compliance/risks/settings'
      fullPath: '/compliance/risks/settings'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceRisksSettingsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/restrictive-practices/monthly-report': {
      id: '/_authenticated/_organization/compliance/restrictive-practices/monthly-report'
      path: '/compliance/restrictive-practices/monthly-report'
      fullPath: '/compliance/restrictive-practices/monthly-report'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/policy-pack/$runId': {
      id: '/_authenticated/_organization/compliance/policy-pack/$runId'
      path: '/compliance/policy-pack/$runId'
      fullPath: '/compliance/policy-pack/$runId'
      preLoaderRoute: typeof AuthenticatedOrganizationCompliancePolicyPackRunIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/policies_/$policyId': {
      id: '/_authenticated/_organization/compliance/policies_/$policyId'
      path: '/compliance/policies/$policyId'
      fullPath: '/compliance/policies/$policyId'
      preLoaderRoute: typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/complaints/$complaintId': {
      id: '/_authenticated/_organization/compliance/complaints/$complaintId'
      path: '/compliance/complaints/$complaintId'
      fullPath: '/compliance/complaints/$complaintId'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceComplaintsComplaintIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/audits_/$auditId': {
      id: '/_authenticated/_organization/compliance/audits_/$auditId'
      path: '/compliance/audits/$auditId'
      fullPath: '/compliance/audits/$auditId'
      preLoaderRoute: typeof AuthenticatedOrganizationComplianceAuditsAuditIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/transitions': {
      id: '/_authenticated/_organization/clients/$clientId/transitions'
      path: '/clients/$clientId/transitions'
      fullPath: '/clients/$clientId/transitions'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdTransitionsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/support-plan': {
      id: '/_authenticated/_organization/clients/$clientId/support-plan'
      path: '/clients/$clientId/support-plan'
      fullPath: '/clients/$clientId/support-plan'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdSupportPlanRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/support-coordination': {
      id: '/_authenticated/_organization/clients/$clientId/support-coordination'
      path: '/clients/$clientId/support-coordination'
      fullPath: '/clients/$clientId/support-coordination'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdSupportCoordinationRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/stakeholders': {
      id: '/_authenticated/_organization/clients/$clientId/stakeholders'
      path: '/clients/$clientId/stakeholders'
      fullPath: '/clients/$clientId/stakeholders'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdStakeholdersRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/service-agreement': {
      id: '/_authenticated/_organization/clients/$clientId/service-agreement'
      path: '/clients/$clientId/service-agreement'
      fullPath: '/clients/$clientId/service-agreement'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdServiceAgreementRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/schedules': {
      id: '/_authenticated/_organization/clients/$clientId/schedules'
      path: '/clients/$clientId/schedules'
      fullPath: '/clients/$clientId/schedules'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdSchedulesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/risk-profile': {
      id: '/_authenticated/_organization/clients/$clientId/risk-profile'
      path: '/clients/$clientId/risk-profile'
      fullPath: '/clients/$clientId/risk-profile'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdRiskProfileRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/profile': {
      id: '/_authenticated/_organization/clients/$clientId/profile'
      path: '/clients/$clientId/profile'
      fullPath: '/clients/$clientId/profile'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdProfileRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/overview': {
      id: '/_authenticated/_organization/clients/$clientId/overview'
      path: '/clients/$clientId/overview'
      fullPath: '/clients/$clientId/overview'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdOverviewRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/onboarding': {
      id: '/_authenticated/_organization/clients/$clientId/onboarding'
      path: '/clients/$clientId/onboarding'
      fullPath: '/clients/$clientId/onboarding'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdOnboardingRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/notes': {
      id: '/_authenticated/_organization/clients/$clientId/notes'
      path: '/clients/$clientId/notes'
      fullPath: '/clients/$clientId/notes'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdNotesRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/medications': {
      id: '/_authenticated/_organization/clients/$clientId/medications'
      path: '/clients/$clientId/medications'
      fullPath: '/clients/$clientId/medications'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdMedicationsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/intake': {
      id: '/_authenticated/_organization/clients/$clientId/intake'
      path: '/clients/$clientId/intake'
      fullPath: '/clients/$clientId/intake'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdIntakeRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/incidents': {
      id: '/_authenticated/_organization/clients/$clientId/incidents'
      path: '/clients/$clientId/incidents'
      fullPath: '/clients/$clientId/incidents'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdIncidentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/ican': {
      id: '/_authenticated/_organization/clients/$clientId/ican'
      path: '/clients/$clientId/ican'
      fullPath: '/clients/$clientId/ican'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdIcanRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/goals': {
      id: '/_authenticated/_organization/clients/$clientId/goals'
      path: '/clients/$clientId/goals'
      fullPath: '/clients/$clientId/goals'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdGoalsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/funding': {
      id: '/_authenticated/_organization/clients/$clientId/funding'
      path: '/clients/$clientId/funding'
      fullPath: '/clients/$clientId/funding'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdFundingRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/evidence-packs': {
      id: '/_authenticated/_organization/clients/$clientId/evidence-packs'
      path: '/clients/$clientId/evidence-packs'
      fullPath: '/clients/$clientId/evidence-packs'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdEvidencePacksRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/documents': {
      id: '/_authenticated/_organization/clients/$clientId/documents'
      path: '/clients/$clientId/documents'
      fullPath: '/clients/$clientId/documents'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdDocumentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/care-plan': {
      id: '/_authenticated/_organization/clients/$clientId/care-plan'
      path: '/clients/$clientId/care-plan'
      fullPath: '/clients/$clientId/care-plan'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdCarePlanRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/behaviour-support': {
      id: '/_authenticated/_organization/clients/$clientId/behaviour-support'
      path: '/clients/$clientId/behaviour-support'
      fullPath: '/clients/$clientId/behaviour-support'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdBehaviourSupportRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/audit-trail': {
      id: '/_authenticated/_organization/clients/$clientId/audit-trail'
      path: '/clients/$clientId/audit-trail'
      fullPath: '/clients/$clientId/audit-trail'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdAuditTrailRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/clients/$clientId/appointments': {
      id: '/_authenticated/_organization/clients/$clientId/appointments'
      path: '/clients/$clientId/appointments'
      fullPath: '/clients/$clientId/appointments'
      preLoaderRoute: typeof AuthenticatedOrganizationClientsClientIdAppointmentsRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/training-programs/': {
      id: '/_authenticated/_organization/organizations/settings/training-programs/'
      path: '/training-programs'
      fullPath: '/organizations/settings/training-programs'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/progress-note-templates/': {
      id: '/_authenticated/_organization/organizations/settings/progress-note-templates/'
      path: '/progress-note-templates'
      fullPath: '/organizations/settings/progress-note-templates'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/forms/$formId/submissions/': {
      id: '/_authenticated/_organization/forms/$formId/submissions/'
      path: '/forms/$formId/submissions'
      fullPath: '/forms/$formId/submissions'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsFormIdSubmissionsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/training-programs/$programId': {
      id: '/_authenticated/_organization/organizations/settings/training-programs/$programId'
      path: '/training-programs/$programId'
      fullPath: '/organizations/settings/training-programs/$programId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/organizations/settings/progress-note-templates/$templateId': {
      id: '/_authenticated/_organization/organizations/settings/progress-note-templates/$templateId'
      path: '/progress-note-templates/$templateId'
      fullPath: '/organizations/settings/progress-note-templates/$templateId'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRoute
    }
    '/_authenticated/_organization/forms/$formId/submissions/$submissionId': {
      id: '/_authenticated/_organization/forms/$formId/submissions/$submissionId'
      path: '/forms/$formId/submissions/$submissionId'
      fullPath: '/forms/$formId/submissions/$submissionId'
      preLoaderRoute: typeof AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
    '/_authenticated/_organization/compliance/policies_/$policyId_/redraft/$proposalId': {
      id: '/_authenticated/_organization/compliance/policies_/$policyId_/redraft/$proposalId'
      path: '/compliance/policies/$policyId/redraft/$proposalId'
      fullPath: '/compliance/policies/$policyId/redraft/$proposalId'
      preLoaderRoute: typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRouteImport
      parentRoute: typeof AuthenticatedOrganizationRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authChangePasswordRoute: typeof authChangePasswordRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  authTwoFactorRoute: typeof authTwoFactorRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authChangePasswordRoute: authChangePasswordRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  authTwoFactorRoute: authTwoFactorRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedOrganizationSchedulerRouteRouteChildren {
  AuthenticatedOrganizationSchedulerAlertsRoute: typeof AuthenticatedOrganizationSchedulerAlertsRoute
  AuthenticatedOrganizationSchedulerAllShiftsRoute: typeof AuthenticatedOrganizationSchedulerAllShiftsRoute
  AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute: typeof AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute
  AuthenticatedOrganizationSchedulerClashesRoute: typeof AuthenticatedOrganizationSchedulerClashesRoute
  AuthenticatedOrganizationSchedulerOverviewRoute: typeof AuthenticatedOrganizationSchedulerOverviewRoute
  AuthenticatedOrganizationSchedulerPostShiftReviewRoute: typeof AuthenticatedOrganizationSchedulerPostShiftReviewRoute
  AuthenticatedOrganizationSchedulerProgressNotesRoute: typeof AuthenticatedOrganizationSchedulerProgressNotesRoute
  AuthenticatedOrganizationSchedulerReviewQueueRoute: typeof AuthenticatedOrganizationSchedulerReviewQueueRoute
  AuthenticatedOrganizationSchedulerShiftRequestsRoute: typeof AuthenticatedOrganizationSchedulerShiftRequestsRoute
  AuthenticatedOrganizationSchedulerIndexRoute: typeof AuthenticatedOrganizationSchedulerIndexRoute
  AuthenticatedOrganizationSchedulerSilArrangementIdRoute: typeof AuthenticatedOrganizationSchedulerSilArrangementIdRoute
  AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute: typeof AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute
  AuthenticatedOrganizationSchedulerSilIndexRoute: typeof AuthenticatedOrganizationSchedulerSilIndexRoute
  AuthenticatedOrganizationSchedulerTemplatesIndexRoute: typeof AuthenticatedOrganizationSchedulerTemplatesIndexRoute
}

const AuthenticatedOrganizationSchedulerRouteRouteChildren: AuthenticatedOrganizationSchedulerRouteRouteChildren =
  {
    AuthenticatedOrganizationSchedulerAlertsRoute:
      AuthenticatedOrganizationSchedulerAlertsRoute,
    AuthenticatedOrganizationSchedulerAllShiftsRoute:
      AuthenticatedOrganizationSchedulerAllShiftsRoute,
    AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute:
      AuthenticatedOrganizationSchedulerAvailabilityRequestsRoute,
    AuthenticatedOrganizationSchedulerClashesRoute:
      AuthenticatedOrganizationSchedulerClashesRoute,
    AuthenticatedOrganizationSchedulerOverviewRoute:
      AuthenticatedOrganizationSchedulerOverviewRoute,
    AuthenticatedOrganizationSchedulerPostShiftReviewRoute:
      AuthenticatedOrganizationSchedulerPostShiftReviewRoute,
    AuthenticatedOrganizationSchedulerProgressNotesRoute:
      AuthenticatedOrganizationSchedulerProgressNotesRoute,
    AuthenticatedOrganizationSchedulerReviewQueueRoute:
      AuthenticatedOrganizationSchedulerReviewQueueRoute,
    AuthenticatedOrganizationSchedulerShiftRequestsRoute:
      AuthenticatedOrganizationSchedulerShiftRequestsRoute,
    AuthenticatedOrganizationSchedulerIndexRoute:
      AuthenticatedOrganizationSchedulerIndexRoute,
    AuthenticatedOrganizationSchedulerSilArrangementIdRoute:
      AuthenticatedOrganizationSchedulerSilArrangementIdRoute,
    AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute:
      AuthenticatedOrganizationSchedulerTemplatesTemplateIdRoute,
    AuthenticatedOrganizationSchedulerSilIndexRoute:
      AuthenticatedOrganizationSchedulerSilIndexRoute,
    AuthenticatedOrganizationSchedulerTemplatesIndexRoute:
      AuthenticatedOrganizationSchedulerTemplatesIndexRoute,
  }

const AuthenticatedOrganizationSchedulerRouteRouteWithChildren =
  AuthenticatedOrganizationSchedulerRouteRoute._addFileChildren(
    AuthenticatedOrganizationSchedulerRouteRouteChildren,
  )

interface AuthenticatedOrganizationSupportCoordinationScribeRouteChildren {
  AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute: typeof AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute
}

const AuthenticatedOrganizationSupportCoordinationScribeRouteChildren: AuthenticatedOrganizationSupportCoordinationScribeRouteChildren =
  {
    AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute:
      AuthenticatedOrganizationSupportCoordinationScribeNoteIdRoute,
  }

const AuthenticatedOrganizationSupportCoordinationScribeRouteWithChildren =
  AuthenticatedOrganizationSupportCoordinationScribeRoute._addFileChildren(
    AuthenticatedOrganizationSupportCoordinationScribeRouteChildren,
  )

interface AuthenticatedOrganizationSupportCoordinationRouteRouteChildren {
  AuthenticatedOrganizationSupportCoordinationBillingRoute: typeof AuthenticatedOrganizationSupportCoordinationBillingRoute
  AuthenticatedOrganizationSupportCoordinationBudgetRoute: typeof AuthenticatedOrganizationSupportCoordinationBudgetRoute
  AuthenticatedOrganizationSupportCoordinationCaseNotesRoute: typeof AuthenticatedOrganizationSupportCoordinationCaseNotesRoute
  AuthenticatedOrganizationSupportCoordinationComplianceRoute: typeof AuthenticatedOrganizationSupportCoordinationComplianceRoute
  AuthenticatedOrganizationSupportCoordinationEmailsRoute: typeof AuthenticatedOrganizationSupportCoordinationEmailsRoute
  AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute: typeof AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute
  AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute: typeof AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute
  AuthenticatedOrganizationSupportCoordinationNotebookRoute: typeof AuthenticatedOrganizationSupportCoordinationNotebookRoute
  AuthenticatedOrganizationSupportCoordinationPlannerRoute: typeof AuthenticatedOrganizationSupportCoordinationPlannerRoute
  AuthenticatedOrganizationSupportCoordinationRegistersRoute: typeof AuthenticatedOrganizationSupportCoordinationRegistersRoute
  AuthenticatedOrganizationSupportCoordinationReportsRoute: typeof AuthenticatedOrganizationSupportCoordinationReportsRoute
  AuthenticatedOrganizationSupportCoordinationScribeRoute: typeof AuthenticatedOrganizationSupportCoordinationScribeRouteWithChildren
  AuthenticatedOrganizationSupportCoordinationTelephonyRoute: typeof AuthenticatedOrganizationSupportCoordinationTelephonyRoute
  AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute: typeof AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute
  AuthenticatedOrganizationSupportCoordinationIndexRoute: typeof AuthenticatedOrganizationSupportCoordinationIndexRoute
}

const AuthenticatedOrganizationSupportCoordinationRouteRouteChildren: AuthenticatedOrganizationSupportCoordinationRouteRouteChildren =
  {
    AuthenticatedOrganizationSupportCoordinationBillingRoute:
      AuthenticatedOrganizationSupportCoordinationBillingRoute,
    AuthenticatedOrganizationSupportCoordinationBudgetRoute:
      AuthenticatedOrganizationSupportCoordinationBudgetRoute,
    AuthenticatedOrganizationSupportCoordinationCaseNotesRoute:
      AuthenticatedOrganizationSupportCoordinationCaseNotesRoute,
    AuthenticatedOrganizationSupportCoordinationComplianceRoute:
      AuthenticatedOrganizationSupportCoordinationComplianceRoute,
    AuthenticatedOrganizationSupportCoordinationEmailsRoute:
      AuthenticatedOrganizationSupportCoordinationEmailsRoute,
    AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute:
      AuthenticatedOrganizationSupportCoordinationMailboxSettingsRoute,
    AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute:
      AuthenticatedOrganizationSupportCoordinationNextBestActionsRoute,
    AuthenticatedOrganizationSupportCoordinationNotebookRoute:
      AuthenticatedOrganizationSupportCoordinationNotebookRoute,
    AuthenticatedOrganizationSupportCoordinationPlannerRoute:
      AuthenticatedOrganizationSupportCoordinationPlannerRoute,
    AuthenticatedOrganizationSupportCoordinationRegistersRoute:
      AuthenticatedOrganizationSupportCoordinationRegistersRoute,
    AuthenticatedOrganizationSupportCoordinationReportsRoute:
      AuthenticatedOrganizationSupportCoordinationReportsRoute,
    AuthenticatedOrganizationSupportCoordinationScribeRoute:
      AuthenticatedOrganizationSupportCoordinationScribeRouteWithChildren,
    AuthenticatedOrganizationSupportCoordinationTelephonyRoute:
      AuthenticatedOrganizationSupportCoordinationTelephonyRoute,
    AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute:
      AuthenticatedOrganizationSupportCoordinationTimeEntriesRoute,
    AuthenticatedOrganizationSupportCoordinationIndexRoute:
      AuthenticatedOrganizationSupportCoordinationIndexRoute,
  }

const AuthenticatedOrganizationSupportCoordinationRouteRouteWithChildren =
  AuthenticatedOrganizationSupportCoordinationRouteRoute._addFileChildren(
    AuthenticatedOrganizationSupportCoordinationRouteRouteChildren,
  )

interface AuthenticatedOrganizationIncidentsReportsRouteRouteChildren {
  AuthenticatedOrganizationIncidentsReportsComplianceRoute: typeof AuthenticatedOrganizationIncidentsReportsComplianceRoute
  AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute: typeof AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute
  AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute: typeof AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute
  AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute: typeof AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute
  AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute: typeof AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute
  AuthenticatedOrganizationIncidentsReportsIndexRoute: typeof AuthenticatedOrganizationIncidentsReportsIndexRoute
}

const AuthenticatedOrganizationIncidentsReportsRouteRouteChildren: AuthenticatedOrganizationIncidentsReportsRouteRouteChildren =
  {
    AuthenticatedOrganizationIncidentsReportsComplianceRoute:
      AuthenticatedOrganizationIncidentsReportsComplianceRoute,
    AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute:
      AuthenticatedOrganizationIncidentsReportsExecutiveSummaryRoute,
    AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute:
      AuthenticatedOrganizationIncidentsReportsIncidentMappingRoute,
    AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute:
      AuthenticatedOrganizationIncidentsReportsOperationalPerformanceRoute,
    AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute:
      AuthenticatedOrganizationIncidentsReportsTrendAnalysisRoute,
    AuthenticatedOrganizationIncidentsReportsIndexRoute:
      AuthenticatedOrganizationIncidentsReportsIndexRoute,
  }

const AuthenticatedOrganizationIncidentsReportsRouteRouteWithChildren =
  AuthenticatedOrganizationIncidentsReportsRouteRoute._addFileChildren(
    AuthenticatedOrganizationIncidentsReportsRouteRouteChildren,
  )

interface AuthenticatedOrganizationOrganizationsSettingsRouteRouteChildren {
  AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute
  AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute
  AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute
  AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute
  AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute: typeof AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute
  AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute: typeof AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute
  AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute
  AuthenticatedOrganizationOrganizationsSettingsClockInRoute: typeof AuthenticatedOrganizationOrganizationsSettingsClockInRoute
  AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute: typeof AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute
  AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute: typeof AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute
  AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute
  AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute
  AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute: typeof AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute
  AuthenticatedOrganizationOrganizationsSettingsInductionRoute: typeof AuthenticatedOrganizationOrganizationsSettingsInductionRoute
  AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute: typeof AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute
  AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute
  AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute: typeof AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute
  AuthenticatedOrganizationOrganizationsSettingsMembersRoute: typeof AuthenticatedOrganizationOrganizationsSettingsMembersRoute
  AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute: typeof AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute
  AuthenticatedOrganizationOrganizationsSettingsPayrollRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPayrollRoute
  AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute
  AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute
  AuthenticatedOrganizationOrganizationsSettingsProfileRoute: typeof AuthenticatedOrganizationOrganizationsSettingsProfileRoute
  AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute: typeof AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute
  AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute: typeof AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute
  AuthenticatedOrganizationOrganizationsSettingsRegionsRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRegionsRoute
  AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute: typeof AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute
  AuthenticatedOrganizationOrganizationsSettingsRolesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRolesRoute
  AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute: typeof AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute
  AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute
  AuthenticatedOrganizationOrganizationsSettingsTravelRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTravelRoute
  AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute: typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute
  AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute
  AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute: typeof AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute
  AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute: typeof AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute
}

const AuthenticatedOrganizationOrganizationsSettingsRouteRouteChildren: AuthenticatedOrganizationOrganizationsSettingsRouteRouteChildren =
  {
    AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute:
      AuthenticatedOrganizationOrganizationsSettingsAgreementSectionsRoute,
    AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute:
      AuthenticatedOrganizationOrganizationsSettingsAiSettingsRoute,
    AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute:
      AuthenticatedOrganizationOrganizationsSettingsAssistantKnowledgeRoute,
    AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute:
      AuthenticatedOrganizationOrganizationsSettingsAwardRatesRoute,
    AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute:
      AuthenticatedOrganizationOrganizationsSettingsAwardXeroMappingRoute,
    AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute:
      AuthenticatedOrganizationOrganizationsSettingsCancellationPolicyRoute,
    AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute:
      AuthenticatedOrganizationOrganizationsSettingsClientDocumentTypesRoute,
    AuthenticatedOrganizationOrganizationsSettingsClockInRoute:
      AuthenticatedOrganizationOrganizationsSettingsClockInRoute,
    AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute:
      AuthenticatedOrganizationOrganizationsSettingsComplianceProfileRoute,
    AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute:
      AuthenticatedOrganizationOrganizationsSettingsDataMigrationRoute,
    AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute:
      AuthenticatedOrganizationOrganizationsSettingsDocumentTypesRoute,
    AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute:
      AuthenticatedOrganizationOrganizationsSettingsFacilitiesRoute,
    AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute:
      AuthenticatedOrganizationOrganizationsSettingsGoLiveRoute,
    AuthenticatedOrganizationOrganizationsSettingsInductionRoute:
      AuthenticatedOrganizationOrganizationsSettingsInductionRoute,
    AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute:
      AuthenticatedOrganizationOrganizationsSettingsIntegrationsRoute,
    AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute:
      AuthenticatedOrganizationOrganizationsSettingsInvoiceTemplatesRoute,
    AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute:
      AuthenticatedOrganizationOrganizationsSettingsLineItemsRoute,
    AuthenticatedOrganizationOrganizationsSettingsMembersRoute:
      AuthenticatedOrganizationOrganizationsSettingsMembersRoute,
    AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute:
      AuthenticatedOrganizationOrganizationsSettingsNotificationsConfigRoute,
    AuthenticatedOrganizationOrganizationsSettingsPayrollRoute:
      AuthenticatedOrganizationOrganizationsSettingsPayrollRoute,
    AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute:
      AuthenticatedOrganizationOrganizationsSettingsPermissionMatrixRoute,
    AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute:
      AuthenticatedOrganizationOrganizationsSettingsPrivacyRoute,
    AuthenticatedOrganizationOrganizationsSettingsProfileRoute:
      AuthenticatedOrganizationOrganizationsSettingsProfileRoute,
    AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute:
      AuthenticatedOrganizationOrganizationsSettingsPublicHolidaysRoute,
    AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute:
      AuthenticatedOrganizationOrganizationsSettingsReferralIntakeRoute,
    AuthenticatedOrganizationOrganizationsSettingsRegionsRoute:
      AuthenticatedOrganizationOrganizationsSettingsRegionsRoute,
    AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute:
      AuthenticatedOrganizationOrganizationsSettingsReportsConfigurationRoute,
    AuthenticatedOrganizationOrganizationsSettingsRolesRoute:
      AuthenticatedOrganizationOrganizationsSettingsRolesRoute,
    AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute:
      AuthenticatedOrganizationOrganizationsSettingsServiceTypesRoute,
    AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute:
      AuthenticatedOrganizationOrganizationsSettingsTermsPrivacyRoute,
    AuthenticatedOrganizationOrganizationsSettingsTravelRoute:
      AuthenticatedOrganizationOrganizationsSettingsTravelRoute,
    AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute:
      AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesTemplateIdRoute,
    AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute:
      AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsProgramIdRoute,
    AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute:
      AuthenticatedOrganizationOrganizationsSettingsProgressNoteTemplatesIndexRoute,
    AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute:
      AuthenticatedOrganizationOrganizationsSettingsTrainingProgramsIndexRoute,
  }

const AuthenticatedOrganizationOrganizationsSettingsRouteRouteWithChildren =
  AuthenticatedOrganizationOrganizationsSettingsRouteRoute._addFileChildren(
    AuthenticatedOrganizationOrganizationsSettingsRouteRouteChildren,
  )

interface AuthenticatedOrganizationRouteRouteChildren {
  AuthenticatedOrganizationSchedulerRouteRoute: typeof AuthenticatedOrganizationSchedulerRouteRouteWithChildren
  AuthenticatedOrganizationSupportCoordinationRouteRoute: typeof AuthenticatedOrganizationSupportCoordinationRouteRouteWithChildren
  AuthenticatedOrganizationAiGatewayRoute: typeof AuthenticatedOrganizationAiGatewayRoute
  AuthenticatedOrganizationCrossOrgRoute: typeof AuthenticatedOrganizationCrossOrgRoute
  AuthenticatedOrganizationSignaturesRoute: typeof AuthenticatedOrganizationSignaturesRoute
  AuthenticatedOrganizationIndexRoute: typeof AuthenticatedOrganizationIndexRoute
  AuthenticatedOrganizationIncidentsReportsRouteRoute: typeof AuthenticatedOrganizationIncidentsReportsRouteRouteWithChildren
  AuthenticatedOrganizationOrganizationsSettingsRouteRoute: typeof AuthenticatedOrganizationOrganizationsSettingsRouteRouteWithChildren
  AuthenticatedOrganizationAppsSkeletonDemoRoute: typeof AuthenticatedOrganizationAppsSkeletonDemoRoute
  AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute: typeof AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute
  AuthenticatedOrganizationBudgetCalculatorQuickRoute: typeof AuthenticatedOrganizationBudgetCalculatorQuickRoute
  AuthenticatedOrganizationChatsConversationIdRoute: typeof AuthenticatedOrganizationChatsConversationIdRoute
  AuthenticatedOrganizationComplianceAuditsRoute: typeof AuthenticatedOrganizationComplianceAuditsRoute
  AuthenticatedOrganizationComplianceConflictsOfInterestRoute: typeof AuthenticatedOrganizationComplianceConflictsOfInterestRoute
  AuthenticatedOrganizationComplianceFindingsRoute: typeof AuthenticatedOrganizationComplianceFindingsRoute
  AuthenticatedOrganizationComplianceGapAnalysisRoute: typeof AuthenticatedOrganizationComplianceGapAnalysisRoute
  AuthenticatedOrganizationComplianceHubRoute: typeof AuthenticatedOrganizationComplianceHubRoute
  AuthenticatedOrganizationCompliancePartnersRoute: typeof AuthenticatedOrganizationCompliancePartnersRoute
  AuthenticatedOrganizationCompliancePoliciesRoute: typeof AuthenticatedOrganizationCompliancePoliciesRoute
  AuthenticatedOrganizationComplianceRisksRoute: typeof AuthenticatedOrganizationComplianceRisksRoute
  AuthenticatedOrganizationComplianceStandardsRoute: typeof AuthenticatedOrganizationComplianceStandardsRoute
  AuthenticatedOrganizationDemoSkeletonRoute: typeof AuthenticatedOrganizationDemoSkeletonRoute
  AuthenticatedOrganizationExtractionsExamplesRoute: typeof AuthenticatedOrganizationExtractionsExamplesRoute
  AuthenticatedOrganizationFilesViewerRoute: typeof AuthenticatedOrganizationFilesViewerRoute
  AuthenticatedOrganizationFormsReviewQueueRoute: typeof AuthenticatedOrganizationFormsReviewQueueRoute
  AuthenticatedOrganizationHelpCenterTicketIdRoute: typeof AuthenticatedOrganizationHelpCenterTicketIdRoute
  AuthenticatedOrganizationIncidentsKnowledgeBaseRoute: typeof AuthenticatedOrganizationIncidentsKnowledgeBaseRoute
  AuthenticatedOrganizationIncidentsNewRoute: typeof AuthenticatedOrganizationIncidentsNewRoute
  AuthenticatedOrganizationInductionInductionIdRoute: typeof AuthenticatedOrganizationInductionInductionIdRoute
  AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute: typeof AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute
  AuthenticatedOrganizationMyShiftsShiftIdRoute: typeof AuthenticatedOrganizationMyShiftsShiftIdRoute
  AuthenticatedOrganizationNdisStandardsAuditsRoute: typeof AuthenticatedOrganizationNdisStandardsAuditsRoute
  AuthenticatedOrganizationNdisStandardsComplianceRoute: typeof AuthenticatedOrganizationNdisStandardsComplianceRoute
  AuthenticatedOrganizationNdisStandardsIcanRoute: typeof AuthenticatedOrganizationNdisStandardsIcanRoute
  AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute: typeof AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute
  AuthenticatedOrganizationNdisStandardsPoliciesRoute: typeof AuthenticatedOrganizationNdisStandardsPoliciesRoute
  AuthenticatedOrganizationNdisStandardsReportsRoute: typeof AuthenticatedOrganizationNdisStandardsReportsRoute
  AuthenticatedOrganizationOnboardingAdminRoute: typeof AuthenticatedOrganizationOnboardingAdminRoute
  AuthenticatedOrganizationOnboardingClientRoute: typeof AuthenticatedOrganizationOnboardingClientRoute
  AuthenticatedOrganizationOnboardingPreviewRoute: typeof AuthenticatedOrganizationOnboardingPreviewRoute
  AuthenticatedOrganizationOnboardingRequiredDocumentsRoute: typeof AuthenticatedOrganizationOnboardingRequiredDocumentsRoute
  AuthenticatedOrganizationOnboardingStaffRoute: typeof AuthenticatedOrganizationOnboardingStaffRoute
  AuthenticatedOrganizationPayrunsPayRunIdRoute: typeof AuthenticatedOrganizationPayrunsPayRunIdRoute
  AuthenticatedOrganizationPoliciesAuditsRoute: typeof AuthenticatedOrganizationPoliciesAuditsRoute
  AuthenticatedOrganizationReferralsReferralIdRoute: typeof AuthenticatedOrganizationReferralsReferralIdRoute
  AuthenticatedOrganizationReportsBillableChargesRoute: typeof AuthenticatedOrganizationReportsBillableChargesRoute
  AuthenticatedOrganizationReportsCapacityRoute: typeof AuthenticatedOrganizationReportsCapacityRoute
  AuthenticatedOrganizationReportsExpiredDocumentsRoute: typeof AuthenticatedOrganizationReportsExpiredDocumentsRoute
  AuthenticatedOrganizationReportsGoalAchievementRoute: typeof AuthenticatedOrganizationReportsGoalAchievementRoute
  AuthenticatedOrganizationReportsMyBillableChargesRoute: typeof AuthenticatedOrganizationReportsMyBillableChargesRoute
  AuthenticatedOrganizationReportsMyBillableHoursRoute: typeof AuthenticatedOrganizationReportsMyBillableHoursRoute
  AuthenticatedOrganizationReportsMyBillablesRoute: typeof AuthenticatedOrganizationReportsMyBillablesRoute
  AuthenticatedOrganizationReportsNdiaErrorsRoute: typeof AuthenticatedOrganizationReportsNdiaErrorsRoute
  AuthenticatedOrganizationReportsOvertimeRoute: typeof AuthenticatedOrganizationReportsOvertimeRoute
  AuthenticatedOrganizationReportsParticipantAlertsRoute: typeof AuthenticatedOrganizationReportsParticipantAlertsRoute
  AuthenticatedOrganizationReportsParticipantBirthdaysRoute: typeof AuthenticatedOrganizationReportsParticipantBirthdaysRoute
  AuthenticatedOrganizationReportsParticipantGoalsRoute: typeof AuthenticatedOrganizationReportsParticipantGoalsRoute
  AuthenticatedOrganizationReportsParticipantPlansRoute: typeof AuthenticatedOrganizationReportsParticipantPlansRoute
  AuthenticatedOrganizationReportsParticipantRecordsRoute: typeof AuthenticatedOrganizationReportsParticipantRecordsRoute
  AuthenticatedOrganizationReportsParticipantRisksRoute: typeof AuthenticatedOrganizationReportsParticipantRisksRoute
  AuthenticatedOrganizationReportsParticipantUtilisationRoute: typeof AuthenticatedOrganizationReportsParticipantUtilisationRoute
  AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute: typeof AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute
  AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute: typeof AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute
  AuthenticatedOrganizationReportsPreviewRoute: typeof AuthenticatedOrganizationReportsPreviewRoute
  AuthenticatedOrganizationReportsPublicHolidaySupportsRoute: typeof AuthenticatedOrganizationReportsPublicHolidaySupportsRoute
  AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute: typeof AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute
  AuthenticatedOrganizationReportsServiceDeliveryRoute: typeof AuthenticatedOrganizationReportsServiceDeliveryRoute
  AuthenticatedOrganizationReportsShiftClashesRoute: typeof AuthenticatedOrganizationReportsShiftClashesRoute
  AuthenticatedOrganizationReportsShiftTasksRoute: typeof AuthenticatedOrganizationReportsShiftTasksRoute
  AuthenticatedOrganizationReportsShiftVarianceRoute: typeof AuthenticatedOrganizationReportsShiftVarianceRoute
  AuthenticatedOrganizationReportsShiftsRoute: typeof AuthenticatedOrganizationReportsShiftsRoute
  AuthenticatedOrganizationReportsStaffUtilisationRoute: typeof AuthenticatedOrganizationReportsStaffUtilisationRoute
  AuthenticatedOrganizationReportsSupportCancellationsRoute: typeof AuthenticatedOrganizationReportsSupportCancellationsRoute
  AuthenticatedOrganizationReportsSupportNotesRoute: typeof AuthenticatedOrganizationReportsSupportNotesRoute
  AuthenticatedOrganizationReportsSupportsRoute: typeof AuthenticatedOrganizationReportsSupportsRoute
  AuthenticatedOrganizationReportsSupportsWithoutNotesRoute: typeof AuthenticatedOrganizationReportsSupportsWithoutNotesRoute
  AuthenticatedOrganizationReportsTasksRoute: typeof AuthenticatedOrganizationReportsTasksRoute
  AuthenticatedOrganizationReportsTasksWithoutNotesRoute: typeof AuthenticatedOrganizationReportsTasksWithoutNotesRoute
  AuthenticatedOrganizationReportsTeamBillableHoursRoute: typeof AuthenticatedOrganizationReportsTeamBillableHoursRoute
  AuthenticatedOrganizationReportsTeamBillablesRoute: typeof AuthenticatedOrganizationReportsTeamBillablesRoute
  AuthenticatedOrganizationReportsUserAvailabilityRoute: typeof AuthenticatedOrganizationReportsUserAvailabilityRoute
  AuthenticatedOrganizationReportsUserRecordsRoute: typeof AuthenticatedOrganizationReportsUserRecordsRoute
  AuthenticatedOrganizationReportsVoidedChargesRoute: typeof AuthenticatedOrganizationReportsVoidedChargesRoute
  AuthenticatedOrganizationShiftsNewRoute: typeof AuthenticatedOrganizationShiftsNewRoute
  AuthenticatedOrganizationStaffComplianceRoute: typeof AuthenticatedOrganizationStaffComplianceRoute
  AuthenticatedOrganizationSupportPlanSignShareIdRoute: typeof AuthenticatedOrganizationSupportPlanSignShareIdRoute
  AuthenticatedOrganizationTrainingProgramIdRoute: typeof AuthenticatedOrganizationTrainingProgramIdRoute
  AuthenticatedOrganizationWorkflowsWorkflowIdRoute: typeof AuthenticatedOrganizationWorkflowsWorkflowIdRoute
  AuthenticatedOrganizationAppsIndexRoute: typeof AuthenticatedOrganizationAppsIndexRoute
  AuthenticatedOrganizationAuditLogsIndexRoute: typeof AuthenticatedOrganizationAuditLogsIndexRoute
  AuthenticatedOrganizationBillingIndexRoute: typeof AuthenticatedOrganizationBillingIndexRoute
  AuthenticatedOrganizationBudgetCalculatorIndexRoute: typeof AuthenticatedOrganizationBudgetCalculatorIndexRoute
  AuthenticatedOrganizationCaseNotesIndexRoute: typeof AuthenticatedOrganizationCaseNotesIndexRoute
  AuthenticatedOrganizationCaseloadIndexRoute: typeof AuthenticatedOrganizationCaseloadIndexRoute
  AuthenticatedOrganizationChatsIndexRoute: typeof AuthenticatedOrganizationChatsIndexRoute
  AuthenticatedOrganizationClaimsIndexRoute: typeof AuthenticatedOrganizationClaimsIndexRoute
  AuthenticatedOrganizationClientsIndexRoute: typeof AuthenticatedOrganizationClientsIndexRoute
  AuthenticatedOrganizationComplianceIndexRoute: typeof AuthenticatedOrganizationComplianceIndexRoute
  AuthenticatedOrganizationDocumentsIndexRoute: typeof AuthenticatedOrganizationDocumentsIndexRoute
  AuthenticatedOrganizationExpensesIndexRoute: typeof AuthenticatedOrganizationExpensesIndexRoute
  AuthenticatedOrganizationExtractionsIndexRoute: typeof AuthenticatedOrganizationExtractionsIndexRoute
  AuthenticatedOrganizationFacilitiesIndexRoute: typeof AuthenticatedOrganizationFacilitiesIndexRoute
  AuthenticatedOrganizationFormsIndexRoute: typeof AuthenticatedOrganizationFormsIndexRoute
  AuthenticatedOrganizationHelpCenterIndexRoute: typeof AuthenticatedOrganizationHelpCenterIndexRoute
  AuthenticatedOrganizationIncidentsIndexRoute: typeof AuthenticatedOrganizationIncidentsIndexRoute
  AuthenticatedOrganizationInvoicesIndexRoute: typeof AuthenticatedOrganizationInvoicesIndexRoute
  AuthenticatedOrganizationLearnHubshiftIndexRoute: typeof AuthenticatedOrganizationLearnHubshiftIndexRoute
  AuthenticatedOrganizationLeaveIndexRoute: typeof AuthenticatedOrganizationLeaveIndexRoute
  AuthenticatedOrganizationMyAgreementsIndexRoute: typeof AuthenticatedOrganizationMyAgreementsIndexRoute
  AuthenticatedOrganizationMyAppointmentsIndexRoute: typeof AuthenticatedOrganizationMyAppointmentsIndexRoute
  AuthenticatedOrganizationMyAvailabilityIndexRoute: typeof AuthenticatedOrganizationMyAvailabilityIndexRoute
  AuthenticatedOrganizationMyComplaintsIndexRoute: typeof AuthenticatedOrganizationMyComplaintsIndexRoute
  AuthenticatedOrganizationMyConsentIndexRoute: typeof AuthenticatedOrganizationMyConsentIndexRoute
  AuthenticatedOrganizationMyDeclarationsIndexRoute: typeof AuthenticatedOrganizationMyDeclarationsIndexRoute
  AuthenticatedOrganizationMyFormsIndexRoute: typeof AuthenticatedOrganizationMyFormsIndexRoute
  AuthenticatedOrganizationMyGoalsIndexRoute: typeof AuthenticatedOrganizationMyGoalsIndexRoute
  AuthenticatedOrganizationMyInboxIndexRoute: typeof AuthenticatedOrganizationMyInboxIndexRoute
  AuthenticatedOrganizationMyIncidentReportsIndexRoute: typeof AuthenticatedOrganizationMyIncidentReportsIndexRoute
  AuthenticatedOrganizationMyIncidentsIndexRoute: typeof AuthenticatedOrganizationMyIncidentsIndexRoute
  AuthenticatedOrganizationMyInvoicesIndexRoute: typeof AuthenticatedOrganizationMyInvoicesIndexRoute
  AuthenticatedOrganizationMyOnboardingIndexRoute: typeof AuthenticatedOrganizationMyOnboardingIndexRoute
  AuthenticatedOrganizationMyParticipantsIndexRoute: typeof AuthenticatedOrganizationMyParticipantsIndexRoute
  AuthenticatedOrganizationMyPeopleIndexRoute: typeof AuthenticatedOrganizationMyPeopleIndexRoute
  AuthenticatedOrganizationMyPlanIndexRoute: typeof AuthenticatedOrganizationMyPlanIndexRoute
  AuthenticatedOrganizationMyShiftsIndexRoute: typeof AuthenticatedOrganizationMyShiftsIndexRoute
  AuthenticatedOrganizationMySupportTeamIndexRoute: typeof AuthenticatedOrganizationMySupportTeamIndexRoute
  AuthenticatedOrganizationMyTimesheetsIndexRoute: typeof AuthenticatedOrganizationMyTimesheetsIndexRoute
  AuthenticatedOrganizationNdisStandardsIndexRoute: typeof AuthenticatedOrganizationNdisStandardsIndexRoute
  AuthenticatedOrganizationNotesIndexRoute: typeof AuthenticatedOrganizationNotesIndexRoute
  AuthenticatedOrganizationNotificationsIndexRoute: typeof AuthenticatedOrganizationNotificationsIndexRoute
  AuthenticatedOrganizationOffboardingIndexRoute: typeof AuthenticatedOrganizationOffboardingIndexRoute
  AuthenticatedOrganizationPayrollIndexRoute: typeof AuthenticatedOrganizationPayrollIndexRoute
  AuthenticatedOrganizationPoliciesIndexRoute: typeof AuthenticatedOrganizationPoliciesIndexRoute
  AuthenticatedOrganizationPublicHolidaysIndexRoute: typeof AuthenticatedOrganizationPublicHolidaysIndexRoute
  AuthenticatedOrganizationReconciliationIndexRoute: typeof AuthenticatedOrganizationReconciliationIndexRoute
  AuthenticatedOrganizationReferralsIndexRoute: typeof AuthenticatedOrganizationReferralsIndexRoute
  AuthenticatedOrganizationReportsIndexRoute: typeof AuthenticatedOrganizationReportsIndexRoute
  AuthenticatedOrganizationRosterIndexRoute: typeof AuthenticatedOrganizationRosterIndexRoute
  AuthenticatedOrganizationStaffIndexRoute: typeof AuthenticatedOrganizationStaffIndexRoute
  AuthenticatedOrganizationTasksIndexRoute: typeof AuthenticatedOrganizationTasksIndexRoute
  AuthenticatedOrganizationTimesheetsIndexRoute: typeof AuthenticatedOrganizationTimesheetsIndexRoute
  AuthenticatedOrganizationTrainingIndexRoute: typeof AuthenticatedOrganizationTrainingIndexRoute
  AuthenticatedOrganizationUpgradeIndexRoute: typeof AuthenticatedOrganizationUpgradeIndexRoute
  AuthenticatedOrganizationUsersIndexRoute: typeof AuthenticatedOrganizationUsersIndexRoute
  AuthenticatedOrganizationWorkflowsIndexRoute: typeof AuthenticatedOrganizationWorkflowsIndexRoute
  AuthenticatedOrganizationClientsClientIdAppointmentsRoute: typeof AuthenticatedOrganizationClientsClientIdAppointmentsRoute
  AuthenticatedOrganizationClientsClientIdAuditTrailRoute: typeof AuthenticatedOrganizationClientsClientIdAuditTrailRoute
  AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute: typeof AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute
  AuthenticatedOrganizationClientsClientIdCarePlanRoute: typeof AuthenticatedOrganizationClientsClientIdCarePlanRoute
  AuthenticatedOrganizationClientsClientIdDocumentsRoute: typeof AuthenticatedOrganizationClientsClientIdDocumentsRoute
  AuthenticatedOrganizationClientsClientIdEvidencePacksRoute: typeof AuthenticatedOrganizationClientsClientIdEvidencePacksRoute
  AuthenticatedOrganizationClientsClientIdFundingRoute: typeof AuthenticatedOrganizationClientsClientIdFundingRoute
  AuthenticatedOrganizationClientsClientIdGoalsRoute: typeof AuthenticatedOrganizationClientsClientIdGoalsRoute
  AuthenticatedOrganizationClientsClientIdIcanRoute: typeof AuthenticatedOrganizationClientsClientIdIcanRoute
  AuthenticatedOrganizationClientsClientIdIncidentsRoute: typeof AuthenticatedOrganizationClientsClientIdIncidentsRoute
  AuthenticatedOrganizationClientsClientIdIntakeRoute: typeof AuthenticatedOrganizationClientsClientIdIntakeRoute
  AuthenticatedOrganizationClientsClientIdMedicationsRoute: typeof AuthenticatedOrganizationClientsClientIdMedicationsRoute
  AuthenticatedOrganizationClientsClientIdNotesRoute: typeof AuthenticatedOrganizationClientsClientIdNotesRoute
  AuthenticatedOrganizationClientsClientIdOnboardingRoute: typeof AuthenticatedOrganizationClientsClientIdOnboardingRoute
  AuthenticatedOrganizationClientsClientIdOverviewRoute: typeof AuthenticatedOrganizationClientsClientIdOverviewRoute
  AuthenticatedOrganizationClientsClientIdProfileRoute: typeof AuthenticatedOrganizationClientsClientIdProfileRoute
  AuthenticatedOrganizationClientsClientIdRiskProfileRoute: typeof AuthenticatedOrganizationClientsClientIdRiskProfileRoute
  AuthenticatedOrganizationClientsClientIdSchedulesRoute: typeof AuthenticatedOrganizationClientsClientIdSchedulesRoute
  AuthenticatedOrganizationClientsClientIdServiceAgreementRoute: typeof AuthenticatedOrganizationClientsClientIdServiceAgreementRoute
  AuthenticatedOrganizationClientsClientIdStakeholdersRoute: typeof AuthenticatedOrganizationClientsClientIdStakeholdersRoute
  AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute: typeof AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute
  AuthenticatedOrganizationClientsClientIdSupportPlanRoute: typeof AuthenticatedOrganizationClientsClientIdSupportPlanRoute
  AuthenticatedOrganizationClientsClientIdTransitionsRoute: typeof AuthenticatedOrganizationClientsClientIdTransitionsRoute
  AuthenticatedOrganizationComplianceAuditsAuditIdRoute: typeof AuthenticatedOrganizationComplianceAuditsAuditIdRoute
  AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute: typeof AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute
  AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute: typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute
  AuthenticatedOrganizationCompliancePolicyPackRunIdRoute: typeof AuthenticatedOrganizationCompliancePolicyPackRunIdRoute
  AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute: typeof AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute
  AuthenticatedOrganizationComplianceRisksSettingsRoute: typeof AuthenticatedOrganizationComplianceRisksSettingsRoute
  AuthenticatedOrganizationFormsFormIdEditRoute: typeof AuthenticatedOrganizationFormsFormIdEditRoute
  AuthenticatedOrganizationFormsFormIdFillRoute: typeof AuthenticatedOrganizationFormsFormIdFillRoute
  AuthenticatedOrganizationFormsFormIdPreviewRoute: typeof AuthenticatedOrganizationFormsFormIdPreviewRoute
  AuthenticatedOrganizationIncidentsIncidentIdEditRoute: typeof AuthenticatedOrganizationIncidentsIncidentIdEditRoute
  AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute: typeof AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute
  AuthenticatedOrganizationOnboardingManagementMemberIdRoute: typeof AuthenticatedOrganizationOnboardingManagementMemberIdRoute
  AuthenticatedOrganizationOnboardingManagementPipelineRoute: typeof AuthenticatedOrganizationOnboardingManagementPipelineRoute
  AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute: typeof AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute
  AuthenticatedOrganizationPartnerTrainingTemplateIdRoute: typeof AuthenticatedOrganizationPartnerTrainingTemplateIdRoute
  AuthenticatedOrganizationShiftsShiftIdEditRoute: typeof AuthenticatedOrganizationShiftsShiftIdEditRoute
  AuthenticatedOrganizationStaffStaffIdClientsRoute: typeof AuthenticatedOrganizationStaffStaffIdClientsRoute
  AuthenticatedOrganizationStaffStaffIdDocumentsRoute: typeof AuthenticatedOrganizationStaffStaffIdDocumentsRoute
  AuthenticatedOrganizationStaffStaffIdEmploymentRoute: typeof AuthenticatedOrganizationStaffStaffIdEmploymentRoute
  AuthenticatedOrganizationStaffStaffIdOverviewRoute: typeof AuthenticatedOrganizationStaffStaffIdOverviewRoute
  AuthenticatedOrganizationStaffStaffIdPayrollRoute: typeof AuthenticatedOrganizationStaffStaffIdPayrollRoute
  AuthenticatedOrganizationStaffStaffIdPerformanceRoute: typeof AuthenticatedOrganizationStaffStaffIdPerformanceRoute
  AuthenticatedOrganizationStaffStaffIdProfileRoute: typeof AuthenticatedOrganizationStaffStaffIdProfileRoute
  AuthenticatedOrganizationStaffStaffIdRosterRoute: typeof AuthenticatedOrganizationStaffStaffIdRosterRoute
  AuthenticatedOrganizationStaffStaffIdWorkRightsRoute: typeof AuthenticatedOrganizationStaffStaffIdWorkRightsRoute
  AuthenticatedOrganizationTasksBoardsBoardIdRoute: typeof AuthenticatedOrganizationTasksBoardsBoardIdRoute
  AuthenticatedOrganizationClientsClientIdIndexRoute: typeof AuthenticatedOrganizationClientsClientIdIndexRoute
  AuthenticatedOrganizationClientsTeamsIndexRoute: typeof AuthenticatedOrganizationClientsTeamsIndexRoute
  AuthenticatedOrganizationComplianceComplaintsIndexRoute: typeof AuthenticatedOrganizationComplianceComplaintsIndexRoute
  AuthenticatedOrganizationCompliancePolicyPackIndexRoute: typeof AuthenticatedOrganizationCompliancePolicyPackIndexRoute
  AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute: typeof AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute
  AuthenticatedOrganizationIncidentsIncidentIdIndexRoute: typeof AuthenticatedOrganizationIncidentsIncidentIdIndexRoute
  AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute: typeof AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute
  AuthenticatedOrganizationOnboardingManagementIndexRoute: typeof AuthenticatedOrganizationOnboardingManagementIndexRoute
  AuthenticatedOrganizationOrganizationsInductionsIndexRoute: typeof AuthenticatedOrganizationOrganizationsInductionsIndexRoute
  AuthenticatedOrganizationPartnerLibraryIndexRoute: typeof AuthenticatedOrganizationPartnerLibraryIndexRoute
  AuthenticatedOrganizationPartnerProvidersIndexRoute: typeof AuthenticatedOrganizationPartnerProvidersIndexRoute
  AuthenticatedOrganizationPartnerTrainingIndexRoute: typeof AuthenticatedOrganizationPartnerTrainingIndexRoute
  AuthenticatedOrganizationStaffStaffIdIndexRoute: typeof AuthenticatedOrganizationStaffStaffIdIndexRoute
  AuthenticatedOrganizationStaffTeamsIndexRoute: typeof AuthenticatedOrganizationStaffTeamsIndexRoute
  AuthenticatedOrganizationTasksTaskIdIndexRoute: typeof AuthenticatedOrganizationTasksTaskIdIndexRoute
  AuthenticatedOrganizationTasksBoardsIndexRoute: typeof AuthenticatedOrganizationTasksBoardsIndexRoute
  AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute: typeof AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute
  AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute: typeof AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute
  AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute: typeof AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute
}

const AuthenticatedOrganizationRouteRouteChildren: AuthenticatedOrganizationRouteRouteChildren =
  {
    AuthenticatedOrganizationSchedulerRouteRoute:
      AuthenticatedOrganizationSchedulerRouteRouteWithChildren,
    AuthenticatedOrganizationSupportCoordinationRouteRoute:
      AuthenticatedOrganizationSupportCoordinationRouteRouteWithChildren,
    AuthenticatedOrganizationAiGatewayRoute:
      AuthenticatedOrganizationAiGatewayRoute,
    AuthenticatedOrganizationCrossOrgRoute:
      AuthenticatedOrganizationCrossOrgRoute,
    AuthenticatedOrganizationSignaturesRoute:
      AuthenticatedOrganizationSignaturesRoute,
    AuthenticatedOrganizationIndexRoute: AuthenticatedOrganizationIndexRoute,
    AuthenticatedOrganizationIncidentsReportsRouteRoute:
      AuthenticatedOrganizationIncidentsReportsRouteRouteWithChildren,
    AuthenticatedOrganizationOrganizationsSettingsRouteRoute:
      AuthenticatedOrganizationOrganizationsSettingsRouteRouteWithChildren,
    AuthenticatedOrganizationAppsSkeletonDemoRoute:
      AuthenticatedOrganizationAppsSkeletonDemoRoute,
    AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute:
      AuthenticatedOrganizationBudgetCalculatorCalculationIdRoute,
    AuthenticatedOrganizationBudgetCalculatorQuickRoute:
      AuthenticatedOrganizationBudgetCalculatorQuickRoute,
    AuthenticatedOrganizationChatsConversationIdRoute:
      AuthenticatedOrganizationChatsConversationIdRoute,
    AuthenticatedOrganizationComplianceAuditsRoute:
      AuthenticatedOrganizationComplianceAuditsRoute,
    AuthenticatedOrganizationComplianceConflictsOfInterestRoute:
      AuthenticatedOrganizationComplianceConflictsOfInterestRoute,
    AuthenticatedOrganizationComplianceFindingsRoute:
      AuthenticatedOrganizationComplianceFindingsRoute,
    AuthenticatedOrganizationComplianceGapAnalysisRoute:
      AuthenticatedOrganizationComplianceGapAnalysisRoute,
    AuthenticatedOrganizationComplianceHubRoute:
      AuthenticatedOrganizationComplianceHubRoute,
    AuthenticatedOrganizationCompliancePartnersRoute:
      AuthenticatedOrganizationCompliancePartnersRoute,
    AuthenticatedOrganizationCompliancePoliciesRoute:
      AuthenticatedOrganizationCompliancePoliciesRoute,
    AuthenticatedOrganizationComplianceRisksRoute:
      AuthenticatedOrganizationComplianceRisksRoute,
    AuthenticatedOrganizationComplianceStandardsRoute:
      AuthenticatedOrganizationComplianceStandardsRoute,
    AuthenticatedOrganizationDemoSkeletonRoute:
      AuthenticatedOrganizationDemoSkeletonRoute,
    AuthenticatedOrganizationExtractionsExamplesRoute:
      AuthenticatedOrganizationExtractionsExamplesRoute,
    AuthenticatedOrganizationFilesViewerRoute:
      AuthenticatedOrganizationFilesViewerRoute,
    AuthenticatedOrganizationFormsReviewQueueRoute:
      AuthenticatedOrganizationFormsReviewQueueRoute,
    AuthenticatedOrganizationHelpCenterTicketIdRoute:
      AuthenticatedOrganizationHelpCenterTicketIdRoute,
    AuthenticatedOrganizationIncidentsKnowledgeBaseRoute:
      AuthenticatedOrganizationIncidentsKnowledgeBaseRoute,
    AuthenticatedOrganizationIncidentsNewRoute:
      AuthenticatedOrganizationIncidentsNewRoute,
    AuthenticatedOrganizationInductionInductionIdRoute:
      AuthenticatedOrganizationInductionInductionIdRoute,
    AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute:
      AuthenticatedOrganizationLearnHubshiftTemplateKeyRoute,
    AuthenticatedOrganizationMyShiftsShiftIdRoute:
      AuthenticatedOrganizationMyShiftsShiftIdRoute,
    AuthenticatedOrganizationNdisStandardsAuditsRoute:
      AuthenticatedOrganizationNdisStandardsAuditsRoute,
    AuthenticatedOrganizationNdisStandardsComplianceRoute:
      AuthenticatedOrganizationNdisStandardsComplianceRoute,
    AuthenticatedOrganizationNdisStandardsIcanRoute:
      AuthenticatedOrganizationNdisStandardsIcanRoute,
    AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute:
      AuthenticatedOrganizationNdisStandardsKnowledgeBaseRoute,
    AuthenticatedOrganizationNdisStandardsPoliciesRoute:
      AuthenticatedOrganizationNdisStandardsPoliciesRoute,
    AuthenticatedOrganizationNdisStandardsReportsRoute:
      AuthenticatedOrganizationNdisStandardsReportsRoute,
    AuthenticatedOrganizationOnboardingAdminRoute:
      AuthenticatedOrganizationOnboardingAdminRoute,
    AuthenticatedOrganizationOnboardingClientRoute:
      AuthenticatedOrganizationOnboardingClientRoute,
    AuthenticatedOrganizationOnboardingPreviewRoute:
      AuthenticatedOrganizationOnboardingPreviewRoute,
    AuthenticatedOrganizationOnboardingRequiredDocumentsRoute:
      AuthenticatedOrganizationOnboardingRequiredDocumentsRoute,
    AuthenticatedOrganizationOnboardingStaffRoute:
      AuthenticatedOrganizationOnboardingStaffRoute,
    AuthenticatedOrganizationPayrunsPayRunIdRoute:
      AuthenticatedOrganizationPayrunsPayRunIdRoute,
    AuthenticatedOrganizationPoliciesAuditsRoute:
      AuthenticatedOrganizationPoliciesAuditsRoute,
    AuthenticatedOrganizationReferralsReferralIdRoute:
      AuthenticatedOrganizationReferralsReferralIdRoute,
    AuthenticatedOrganizationReportsBillableChargesRoute:
      AuthenticatedOrganizationReportsBillableChargesRoute,
    AuthenticatedOrganizationReportsCapacityRoute:
      AuthenticatedOrganizationReportsCapacityRoute,
    AuthenticatedOrganizationReportsExpiredDocumentsRoute:
      AuthenticatedOrganizationReportsExpiredDocumentsRoute,
    AuthenticatedOrganizationReportsGoalAchievementRoute:
      AuthenticatedOrganizationReportsGoalAchievementRoute,
    AuthenticatedOrganizationReportsMyBillableChargesRoute:
      AuthenticatedOrganizationReportsMyBillableChargesRoute,
    AuthenticatedOrganizationReportsMyBillableHoursRoute:
      AuthenticatedOrganizationReportsMyBillableHoursRoute,
    AuthenticatedOrganizationReportsMyBillablesRoute:
      AuthenticatedOrganizationReportsMyBillablesRoute,
    AuthenticatedOrganizationReportsNdiaErrorsRoute:
      AuthenticatedOrganizationReportsNdiaErrorsRoute,
    AuthenticatedOrganizationReportsOvertimeRoute:
      AuthenticatedOrganizationReportsOvertimeRoute,
    AuthenticatedOrganizationReportsParticipantAlertsRoute:
      AuthenticatedOrganizationReportsParticipantAlertsRoute,
    AuthenticatedOrganizationReportsParticipantBirthdaysRoute:
      AuthenticatedOrganizationReportsParticipantBirthdaysRoute,
    AuthenticatedOrganizationReportsParticipantGoalsRoute:
      AuthenticatedOrganizationReportsParticipantGoalsRoute,
    AuthenticatedOrganizationReportsParticipantPlansRoute:
      AuthenticatedOrganizationReportsParticipantPlansRoute,
    AuthenticatedOrganizationReportsParticipantRecordsRoute:
      AuthenticatedOrganizationReportsParticipantRecordsRoute,
    AuthenticatedOrganizationReportsParticipantRisksRoute:
      AuthenticatedOrganizationReportsParticipantRisksRoute,
    AuthenticatedOrganizationReportsParticipantUtilisationRoute:
      AuthenticatedOrganizationReportsParticipantUtilisationRoute,
    AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute:
      AuthenticatedOrganizationReportsParticipantsWithoutGoalsRoute,
    AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute:
      AuthenticatedOrganizationReportsParticipantsWithoutRisksRoute,
    AuthenticatedOrganizationReportsPreviewRoute:
      AuthenticatedOrganizationReportsPreviewRoute,
    AuthenticatedOrganizationReportsPublicHolidaySupportsRoute:
      AuthenticatedOrganizationReportsPublicHolidaySupportsRoute,
    AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute:
      AuthenticatedOrganizationReportsRecurringShiftsExpiringRoute,
    AuthenticatedOrganizationReportsServiceDeliveryRoute:
      AuthenticatedOrganizationReportsServiceDeliveryRoute,
    AuthenticatedOrganizationReportsShiftClashesRoute:
      AuthenticatedOrganizationReportsShiftClashesRoute,
    AuthenticatedOrganizationReportsShiftTasksRoute:
      AuthenticatedOrganizationReportsShiftTasksRoute,
    AuthenticatedOrganizationReportsShiftVarianceRoute:
      AuthenticatedOrganizationReportsShiftVarianceRoute,
    AuthenticatedOrganizationReportsShiftsRoute:
      AuthenticatedOrganizationReportsShiftsRoute,
    AuthenticatedOrganizationReportsStaffUtilisationRoute:
      AuthenticatedOrganizationReportsStaffUtilisationRoute,
    AuthenticatedOrganizationReportsSupportCancellationsRoute:
      AuthenticatedOrganizationReportsSupportCancellationsRoute,
    AuthenticatedOrganizationReportsSupportNotesRoute:
      AuthenticatedOrganizationReportsSupportNotesRoute,
    AuthenticatedOrganizationReportsSupportsRoute:
      AuthenticatedOrganizationReportsSupportsRoute,
    AuthenticatedOrganizationReportsSupportsWithoutNotesRoute:
      AuthenticatedOrganizationReportsSupportsWithoutNotesRoute,
    AuthenticatedOrganizationReportsTasksRoute:
      AuthenticatedOrganizationReportsTasksRoute,
    AuthenticatedOrganizationReportsTasksWithoutNotesRoute:
      AuthenticatedOrganizationReportsTasksWithoutNotesRoute,
    AuthenticatedOrganizationReportsTeamBillableHoursRoute:
      AuthenticatedOrganizationReportsTeamBillableHoursRoute,
    AuthenticatedOrganizationReportsTeamBillablesRoute:
      AuthenticatedOrganizationReportsTeamBillablesRoute,
    AuthenticatedOrganizationReportsUserAvailabilityRoute:
      AuthenticatedOrganizationReportsUserAvailabilityRoute,
    AuthenticatedOrganizationReportsUserRecordsRoute:
      AuthenticatedOrganizationReportsUserRecordsRoute,
    AuthenticatedOrganizationReportsVoidedChargesRoute:
      AuthenticatedOrganizationReportsVoidedChargesRoute,
    AuthenticatedOrganizationShiftsNewRoute:
      AuthenticatedOrganizationShiftsNewRoute,
    AuthenticatedOrganizationStaffComplianceRoute:
      AuthenticatedOrganizationStaffComplianceRoute,
    AuthenticatedOrganizationSupportPlanSignShareIdRoute:
      AuthenticatedOrganizationSupportPlanSignShareIdRoute,
    AuthenticatedOrganizationTrainingProgramIdRoute:
      AuthenticatedOrganizationTrainingProgramIdRoute,
    AuthenticatedOrganizationWorkflowsWorkflowIdRoute:
      AuthenticatedOrganizationWorkflowsWorkflowIdRoute,
    AuthenticatedOrganizationAppsIndexRoute:
      AuthenticatedOrganizationAppsIndexRoute,
    AuthenticatedOrganizationAuditLogsIndexRoute:
      AuthenticatedOrganizationAuditLogsIndexRoute,
    AuthenticatedOrganizationBillingIndexRoute:
      AuthenticatedOrganizationBillingIndexRoute,
    AuthenticatedOrganizationBudgetCalculatorIndexRoute:
      AuthenticatedOrganizationBudgetCalculatorIndexRoute,
    AuthenticatedOrganizationCaseNotesIndexRoute:
      AuthenticatedOrganizationCaseNotesIndexRoute,
    AuthenticatedOrganizationCaseloadIndexRoute:
      AuthenticatedOrganizationCaseloadIndexRoute,
    AuthenticatedOrganizationChatsIndexRoute:
      AuthenticatedOrganizationChatsIndexRoute,
    AuthenticatedOrganizationClaimsIndexRoute:
      AuthenticatedOrganizationClaimsIndexRoute,
    AuthenticatedOrganizationClientsIndexRoute:
      AuthenticatedOrganizationClientsIndexRoute,
    AuthenticatedOrganizationComplianceIndexRoute:
      AuthenticatedOrganizationComplianceIndexRoute,
    AuthenticatedOrganizationDocumentsIndexRoute:
      AuthenticatedOrganizationDocumentsIndexRoute,
    AuthenticatedOrganizationExpensesIndexRoute:
      AuthenticatedOrganizationExpensesIndexRoute,
    AuthenticatedOrganizationExtractionsIndexRoute:
      AuthenticatedOrganizationExtractionsIndexRoute,
    AuthenticatedOrganizationFacilitiesIndexRoute:
      AuthenticatedOrganizationFacilitiesIndexRoute,
    AuthenticatedOrganizationFormsIndexRoute:
      AuthenticatedOrganizationFormsIndexRoute,
    AuthenticatedOrganizationHelpCenterIndexRoute:
      AuthenticatedOrganizationHelpCenterIndexRoute,
    AuthenticatedOrganizationIncidentsIndexRoute:
      AuthenticatedOrganizationIncidentsIndexRoute,
    AuthenticatedOrganizationInvoicesIndexRoute:
      AuthenticatedOrganizationInvoicesIndexRoute,
    AuthenticatedOrganizationLearnHubshiftIndexRoute:
      AuthenticatedOrganizationLearnHubshiftIndexRoute,
    AuthenticatedOrganizationLeaveIndexRoute:
      AuthenticatedOrganizationLeaveIndexRoute,
    AuthenticatedOrganizationMyAgreementsIndexRoute:
      AuthenticatedOrganizationMyAgreementsIndexRoute,
    AuthenticatedOrganizationMyAppointmentsIndexRoute:
      AuthenticatedOrganizationMyAppointmentsIndexRoute,
    AuthenticatedOrganizationMyAvailabilityIndexRoute:
      AuthenticatedOrganizationMyAvailabilityIndexRoute,
    AuthenticatedOrganizationMyComplaintsIndexRoute:
      AuthenticatedOrganizationMyComplaintsIndexRoute,
    AuthenticatedOrganizationMyConsentIndexRoute:
      AuthenticatedOrganizationMyConsentIndexRoute,
    AuthenticatedOrganizationMyDeclarationsIndexRoute:
      AuthenticatedOrganizationMyDeclarationsIndexRoute,
    AuthenticatedOrganizationMyFormsIndexRoute:
      AuthenticatedOrganizationMyFormsIndexRoute,
    AuthenticatedOrganizationMyGoalsIndexRoute:
      AuthenticatedOrganizationMyGoalsIndexRoute,
    AuthenticatedOrganizationMyInboxIndexRoute:
      AuthenticatedOrganizationMyInboxIndexRoute,
    AuthenticatedOrganizationMyIncidentReportsIndexRoute:
      AuthenticatedOrganizationMyIncidentReportsIndexRoute,
    AuthenticatedOrganizationMyIncidentsIndexRoute:
      AuthenticatedOrganizationMyIncidentsIndexRoute,
    AuthenticatedOrganizationMyInvoicesIndexRoute:
      AuthenticatedOrganizationMyInvoicesIndexRoute,
    AuthenticatedOrganizationMyOnboardingIndexRoute:
      AuthenticatedOrganizationMyOnboardingIndexRoute,
    AuthenticatedOrganizationMyParticipantsIndexRoute:
      AuthenticatedOrganizationMyParticipantsIndexRoute,
    AuthenticatedOrganizationMyPeopleIndexRoute:
      AuthenticatedOrganizationMyPeopleIndexRoute,
    AuthenticatedOrganizationMyPlanIndexRoute:
      AuthenticatedOrganizationMyPlanIndexRoute,
    AuthenticatedOrganizationMyShiftsIndexRoute:
      AuthenticatedOrganizationMyShiftsIndexRoute,
    AuthenticatedOrganizationMySupportTeamIndexRoute:
      AuthenticatedOrganizationMySupportTeamIndexRoute,
    AuthenticatedOrganizationMyTimesheetsIndexRoute:
      AuthenticatedOrganizationMyTimesheetsIndexRoute,
    AuthenticatedOrganizationNdisStandardsIndexRoute:
      AuthenticatedOrganizationNdisStandardsIndexRoute,
    AuthenticatedOrganizationNotesIndexRoute:
      AuthenticatedOrganizationNotesIndexRoute,
    AuthenticatedOrganizationNotificationsIndexRoute:
      AuthenticatedOrganizationNotificationsIndexRoute,
    AuthenticatedOrganizationOffboardingIndexRoute:
      AuthenticatedOrganizationOffboardingIndexRoute,
    AuthenticatedOrganizationPayrollIndexRoute:
      AuthenticatedOrganizationPayrollIndexRoute,
    AuthenticatedOrganizationPoliciesIndexRoute:
      AuthenticatedOrganizationPoliciesIndexRoute,
    AuthenticatedOrganizationPublicHolidaysIndexRoute:
      AuthenticatedOrganizationPublicHolidaysIndexRoute,
    AuthenticatedOrganizationReconciliationIndexRoute:
      AuthenticatedOrganizationReconciliationIndexRoute,
    AuthenticatedOrganizationReferralsIndexRoute:
      AuthenticatedOrganizationReferralsIndexRoute,
    AuthenticatedOrganizationReportsIndexRoute:
      AuthenticatedOrganizationReportsIndexRoute,
    AuthenticatedOrganizationRosterIndexRoute:
      AuthenticatedOrganizationRosterIndexRoute,
    AuthenticatedOrganizationStaffIndexRoute:
      AuthenticatedOrganizationStaffIndexRoute,
    AuthenticatedOrganizationTasksIndexRoute:
      AuthenticatedOrganizationTasksIndexRoute,
    AuthenticatedOrganizationTimesheetsIndexRoute:
      AuthenticatedOrganizationTimesheetsIndexRoute,
    AuthenticatedOrganizationTrainingIndexRoute:
      AuthenticatedOrganizationTrainingIndexRoute,
    AuthenticatedOrganizationUpgradeIndexRoute:
      AuthenticatedOrganizationUpgradeIndexRoute,
    AuthenticatedOrganizationUsersIndexRoute:
      AuthenticatedOrganizationUsersIndexRoute,
    AuthenticatedOrganizationWorkflowsIndexRoute:
      AuthenticatedOrganizationWorkflowsIndexRoute,
    AuthenticatedOrganizationClientsClientIdAppointmentsRoute:
      AuthenticatedOrganizationClientsClientIdAppointmentsRoute,
    AuthenticatedOrganizationClientsClientIdAuditTrailRoute:
      AuthenticatedOrganizationClientsClientIdAuditTrailRoute,
    AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute:
      AuthenticatedOrganizationClientsClientIdBehaviourSupportRoute,
    AuthenticatedOrganizationClientsClientIdCarePlanRoute:
      AuthenticatedOrganizationClientsClientIdCarePlanRoute,
    AuthenticatedOrganizationClientsClientIdDocumentsRoute:
      AuthenticatedOrganizationClientsClientIdDocumentsRoute,
    AuthenticatedOrganizationClientsClientIdEvidencePacksRoute:
      AuthenticatedOrganizationClientsClientIdEvidencePacksRoute,
    AuthenticatedOrganizationClientsClientIdFundingRoute:
      AuthenticatedOrganizationClientsClientIdFundingRoute,
    AuthenticatedOrganizationClientsClientIdGoalsRoute:
      AuthenticatedOrganizationClientsClientIdGoalsRoute,
    AuthenticatedOrganizationClientsClientIdIcanRoute:
      AuthenticatedOrganizationClientsClientIdIcanRoute,
    AuthenticatedOrganizationClientsClientIdIncidentsRoute:
      AuthenticatedOrganizationClientsClientIdIncidentsRoute,
    AuthenticatedOrganizationClientsClientIdIntakeRoute:
      AuthenticatedOrganizationClientsClientIdIntakeRoute,
    AuthenticatedOrganizationClientsClientIdMedicationsRoute:
      AuthenticatedOrganizationClientsClientIdMedicationsRoute,
    AuthenticatedOrganizationClientsClientIdNotesRoute:
      AuthenticatedOrganizationClientsClientIdNotesRoute,
    AuthenticatedOrganizationClientsClientIdOnboardingRoute:
      AuthenticatedOrganizationClientsClientIdOnboardingRoute,
    AuthenticatedOrganizationClientsClientIdOverviewRoute:
      AuthenticatedOrganizationClientsClientIdOverviewRoute,
    AuthenticatedOrganizationClientsClientIdProfileRoute:
      AuthenticatedOrganizationClientsClientIdProfileRoute,
    AuthenticatedOrganizationClientsClientIdRiskProfileRoute:
      AuthenticatedOrganizationClientsClientIdRiskProfileRoute,
    AuthenticatedOrganizationClientsClientIdSchedulesRoute:
      AuthenticatedOrganizationClientsClientIdSchedulesRoute,
    AuthenticatedOrganizationClientsClientIdServiceAgreementRoute:
      AuthenticatedOrganizationClientsClientIdServiceAgreementRoute,
    AuthenticatedOrganizationClientsClientIdStakeholdersRoute:
      AuthenticatedOrganizationClientsClientIdStakeholdersRoute,
    AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute:
      AuthenticatedOrganizationClientsClientIdSupportCoordinationRoute,
    AuthenticatedOrganizationClientsClientIdSupportPlanRoute:
      AuthenticatedOrganizationClientsClientIdSupportPlanRoute,
    AuthenticatedOrganizationClientsClientIdTransitionsRoute:
      AuthenticatedOrganizationClientsClientIdTransitionsRoute,
    AuthenticatedOrganizationComplianceAuditsAuditIdRoute:
      AuthenticatedOrganizationComplianceAuditsAuditIdRoute,
    AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute:
      AuthenticatedOrganizationComplianceComplaintsComplaintIdRoute,
    AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute:
      AuthenticatedOrganizationCompliancePoliciesPolicyIdRoute,
    AuthenticatedOrganizationCompliancePolicyPackRunIdRoute:
      AuthenticatedOrganizationCompliancePolicyPackRunIdRoute,
    AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute:
      AuthenticatedOrganizationComplianceRestrictivePracticesMonthlyReportRoute,
    AuthenticatedOrganizationComplianceRisksSettingsRoute:
      AuthenticatedOrganizationComplianceRisksSettingsRoute,
    AuthenticatedOrganizationFormsFormIdEditRoute:
      AuthenticatedOrganizationFormsFormIdEditRoute,
    AuthenticatedOrganizationFormsFormIdFillRoute:
      AuthenticatedOrganizationFormsFormIdFillRoute,
    AuthenticatedOrganizationFormsFormIdPreviewRoute:
      AuthenticatedOrganizationFormsFormIdPreviewRoute,
    AuthenticatedOrganizationIncidentsIncidentIdEditRoute:
      AuthenticatedOrganizationIncidentsIncidentIdEditRoute,
    AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute:
      AuthenticatedOrganizationNdisStandardsComplaintsComplaintIdRoute,
    AuthenticatedOrganizationOnboardingManagementMemberIdRoute:
      AuthenticatedOrganizationOnboardingManagementMemberIdRoute,
    AuthenticatedOrganizationOnboardingManagementPipelineRoute:
      AuthenticatedOrganizationOnboardingManagementPipelineRoute,
    AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute:
      AuthenticatedOrganizationPartnerProvidersProviderOrgIdRoute,
    AuthenticatedOrganizationPartnerTrainingTemplateIdRoute:
      AuthenticatedOrganizationPartnerTrainingTemplateIdRoute,
    AuthenticatedOrganizationShiftsShiftIdEditRoute:
      AuthenticatedOrganizationShiftsShiftIdEditRoute,
    AuthenticatedOrganizationStaffStaffIdClientsRoute:
      AuthenticatedOrganizationStaffStaffIdClientsRoute,
    AuthenticatedOrganizationStaffStaffIdDocumentsRoute:
      AuthenticatedOrganizationStaffStaffIdDocumentsRoute,
    AuthenticatedOrganizationStaffStaffIdEmploymentRoute:
      AuthenticatedOrganizationStaffStaffIdEmploymentRoute,
    AuthenticatedOrganizationStaffStaffIdOverviewRoute:
      AuthenticatedOrganizationStaffStaffIdOverviewRoute,
    AuthenticatedOrganizationStaffStaffIdPayrollRoute:
      AuthenticatedOrganizationStaffStaffIdPayrollRoute,
    AuthenticatedOrganizationStaffStaffIdPerformanceRoute:
      AuthenticatedOrganizationStaffStaffIdPerformanceRoute,
    AuthenticatedOrganizationStaffStaffIdProfileRoute:
      AuthenticatedOrganizationStaffStaffIdProfileRoute,
    AuthenticatedOrganizationStaffStaffIdRosterRoute:
      AuthenticatedOrganizationStaffStaffIdRosterRoute,
    AuthenticatedOrganizationStaffStaffIdWorkRightsRoute:
      AuthenticatedOrganizationStaffStaffIdWorkRightsRoute,
    AuthenticatedOrganizationTasksBoardsBoardIdRoute:
      AuthenticatedOrganizationTasksBoardsBoardIdRoute,
    AuthenticatedOrganizationClientsClientIdIndexRoute:
      AuthenticatedOrganizationClientsClientIdIndexRoute,
    AuthenticatedOrganizationClientsTeamsIndexRoute:
      AuthenticatedOrganizationClientsTeamsIndexRoute,
    AuthenticatedOrganizationComplianceComplaintsIndexRoute:
      AuthenticatedOrganizationComplianceComplaintsIndexRoute,
    AuthenticatedOrganizationCompliancePolicyPackIndexRoute:
      AuthenticatedOrganizationCompliancePolicyPackIndexRoute,
    AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute:
      AuthenticatedOrganizationComplianceRestrictivePracticesIndexRoute,
    AuthenticatedOrganizationIncidentsIncidentIdIndexRoute:
      AuthenticatedOrganizationIncidentsIncidentIdIndexRoute,
    AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute:
      AuthenticatedOrganizationNdisStandardsComplaintsIndexRoute,
    AuthenticatedOrganizationOnboardingManagementIndexRoute:
      AuthenticatedOrganizationOnboardingManagementIndexRoute,
    AuthenticatedOrganizationOrganizationsInductionsIndexRoute:
      AuthenticatedOrganizationOrganizationsInductionsIndexRoute,
    AuthenticatedOrganizationPartnerLibraryIndexRoute:
      AuthenticatedOrganizationPartnerLibraryIndexRoute,
    AuthenticatedOrganizationPartnerProvidersIndexRoute:
      AuthenticatedOrganizationPartnerProvidersIndexRoute,
    AuthenticatedOrganizationPartnerTrainingIndexRoute:
      AuthenticatedOrganizationPartnerTrainingIndexRoute,
    AuthenticatedOrganizationStaffStaffIdIndexRoute:
      AuthenticatedOrganizationStaffStaffIdIndexRoute,
    AuthenticatedOrganizationStaffTeamsIndexRoute:
      AuthenticatedOrganizationStaffTeamsIndexRoute,
    AuthenticatedOrganizationTasksTaskIdIndexRoute:
      AuthenticatedOrganizationTasksTaskIdIndexRoute,
    AuthenticatedOrganizationTasksBoardsIndexRoute:
      AuthenticatedOrganizationTasksBoardsIndexRoute,
    AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute:
      AuthenticatedOrganizationFormsFormIdSubmissionsSubmissionIdRoute,
    AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute:
      AuthenticatedOrganizationFormsFormIdSubmissionsIndexRoute,
    AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute:
      AuthenticatedOrganizationCompliancePoliciesPolicyIdRedraftProposalIdRoute,
  }

const AuthenticatedOrganizationRouteRouteWithChildren =
  AuthenticatedOrganizationRouteRoute._addFileChildren(
    AuthenticatedOrganizationRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsCommunicationRoute: typeof AuthenticatedSettingsCommunicationRoute
  AuthenticatedSettingsIntegrationsRoute: typeof AuthenticatedSettingsIntegrationsRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsCommunicationRoute:
      AuthenticatedSettingsCommunicationRoute,
    AuthenticatedSettingsIntegrationsRoute:
      AuthenticatedSettingsIntegrationsRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedOrganizationRouteRoute: typeof AuthenticatedOrganizationRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedForceChangePasswordRoute: typeof AuthenticatedForceChangePasswordRoute
  AuthenticatedGetTheAppRoute: typeof AuthenticatedGetTheAppRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedCreateOrganizationIndexRoute: typeof AuthenticatedCreateOrganizationIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedOrganizationRouteRoute:
    AuthenticatedOrganizationRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedForceChangePasswordRoute: AuthenticatedForceChangePasswordRoute,
  AuthenticatedGetTheAppRoute: AuthenticatedGetTheAppRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedCreateOrganizationIndexRoute:
    AuthenticatedCreateOrganizationIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  FarewellRoute: FarewellRoute,
  OtpRoute: OtpRoute,
  SetupPasskeyRoute: SetupPasskeyRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  AcceptInvitationInvitationIdRoute: AcceptInvitationInvitationIdRoute,
  publicCarePlanShareTokenRoute: publicCarePlanShareTokenRoute,
  publicDevChatPreviewRoute: publicDevChatPreviewRoute,
  publicDevMascotRoute: publicDevMascotRoute,
  publicImpersonateTokenRoute: publicImpersonateTokenRoute,
  publicMigrationPortalTokenRoute: publicMigrationPortalTokenRoute,
  publicOnboardingPortalTokenRoute: publicOnboardingPortalTokenRoute,
  publicSharedAgreementTokenRoute: publicSharedAgreementTokenRoute,
  publicSharedDocumentTokenRoute: publicSharedDocumentTokenRoute,
  publicSignAgreementTokenRoute: publicSignAgreementTokenRoute,
  publicSignTokenRoute: publicSignTokenRoute,
  publicSilRocShareTokenRoute: publicSilRocShareTokenRoute,
  publicSupportPlanShareTokenRoute: publicSupportPlanShareTokenRoute,
  publicSharesCrossOrgTokenRoute: publicSharesCrossOrgTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
